/* Benchtop planner logic */

cabjaks.customBenchtops = function (options) {
	var moneyFormat = options.money_format,
	storeFrontApiKey = options.store_front_api_key,
	customerEmail = options.customer_email,
	$benchtopPlanner = $('.benchtop-planner'),
	$progress = $benchtopPlanner.find('.progress'),
	$step5Next = $benchtopPlanner.find('.step-5 a.btn'),
	$finalImage = $benchtopPlanner.find('.step-9 .if-straight-any .diagram'),
	$finalImageL = $benchtopPlanner.find('.step-9 .if-l-any .diagram'),
	$finalImageU = $benchtopPlanner.find('.step-9 .if-u-any .diagram'),
	$benchtopPieces = $benchtopPlanner.find('.step-9 .benchtop-pieces'),
	finalImageSrc = $finalImage.data('src'),
	finalImageSrcset = $finalImage.data('srcset'),
	finalImageWidth = 569,
	finalImageWidthL = 814,
	finalImageWidthU = 814,
	standardLength = 3600,
	stoneStandardLength = 3200,
	defaultDepth = 600,
	minLength = 70,
	minUGap = 800,
	longEndFinishing = 650,
	longEndPolishing = 1000,
	joinSpace = 20,
	currentlyEditing,
	typingTimer,
	endFinishingProduct = null,
	endFinishingID = null,
	endFinishingPrice = null,
	endFinishingQty = 0,
	endFinishingLongID = null,
	endFinishingLongPrice = null,
	endFinishingLongQty = 0,
	// Polishing products and pricing
	polishingProduct = null,
	polishingPrice = null,
	polishingID = null,
	polishingLongPrice = null,
	polishingLongID = null,
	polishingQty = 0,
	polishingLongQty = 0,
	waterfallProduct = null,
	waterfallPrice = null,
	waterfallID = null,
	waterfallQty = 0,
	waterfallStandardID = null,
	waterfallStandardPrice = null,
	waterfallLargeID = null,
	waterfallLargePrice = null,
	// Separate left and right waterfall areas
	leftWaterfallArea = 0,
	rightWaterfallArea = 0,
	// Separate left and right waterfall material products
	leftWaterfallMaterialProductID = null,
	rightWaterfallMaterialProductID = null,
	leftWaterfallMaterialPrice = 0,
	rightWaterfallMaterialPrice = 0,
	// Cut-outs (stone) state and pricing
	cutoutProduct = null,
	cutoutID = null,
	cutoutPrice = null,
	cutoutQty = 0,
	// Cutout variants (both sink/tap and hob use same product)
	cutoutTopID = null,
	cutoutUnderID = null,
	cutoutTopPrice = null,
	cutoutUnderPrice = null,
	// Hob mount and qty per segment
	// Cutout mount and quantity variables
	sinkTapMount = 'Top mounted',
	sinkTapQty = 1,
	hobMount = 'Top mounted',
	hobQty = 1,
	airSwitchQty = 1,
	tapholeProduct = null,
	tapholeID = null,
	tapholePrice = null,
	tapholeQty = 0,
	windowCutoutProduct = null,
	windowCutoutID = null,
	windowCutoutPrice = null,
	windowCutoutQty = 0,

	// Common cutout variables (for all shapes)
	sinkTapCutout = false,
	hobCutout = false,
	airSwitchCutout = false,

	joinProduct = null,
	joinID = null,
	joinPrice = null,
	joinQty = 0,
	glueProduct = null,
	glueID = null,
	gluePrice = null,
	glueQty = 0,
	// Stone join product/pricing
	stoneJoinProduct = null,
	stoneJoinID = null,
	stoneJoinPrice = null,
	currentStep = 1,
	stepProgress = 1,
	shapeChanged = false,
	benchtopShape = 'Straight',
	breakfastBar = false,
	breakfastBarSide = null,
	benchMaterial = 'Laminate',
	materialProductID = null,
	waterfallMaterialProductID = null,
	benchtopsPrice = 0,
	waterfallMaterialPrice = 0,
	waterfallArea = 0,
	// Material colors by tier
	materialColorsLoaded = false,
	colorTier = 'starter', // starter, premium, professional
	starterColors = [],
	premiumColors = [],
	professionalColors = [],
	endFinishingsPrice = 0,
	benchtopPieces = 0,
	benchtop1ID = null,
	benchtop1Price = null,
	length1 = null,
	length1Final = null,
	depth1 = null,
	benchtop1AID = null,
	benchtop1APrice = null,
	length1AFinal = null,
	benchtop2ID = null,
	benchtop2Price = null,
	length2 = null,
	length2Final = null,
	depth2 = null,
	benchtop2AID = null,
	benchtop2APrice = null,
	length2AFinal = null,
	benchtop3ID = null,
	benchtop3Price = null,
	length3 = null,
	length3Final = null,
	depth3 = null,
	benchtop3AID = null,
	benchtop3APrice = null,
	length3AFinal = null,
	measurementsCache = {},
	leftFinished = false,
	rightFinished = false,
	wallFinished = false,
	totalSquareMM = 0,

	wallStraightFinishingBack = false,

	wallLFinishingBackLeft = false,
	wallLFinishingBackRight = false,

	wallLFinishingBackRightBB = false,
	wallLFinishingBackLeftBB = false,

	wallUFinishingBackLeft = false,
	wallUFinishingBackCentre = false,
	wallUFinishingBackRight = false,


	wallUFinishingBackCentreBBOnLeft = false,
	wallUFinishingBackRightBB = false,

	wallUFinishingBackLeftBB = false,
	wallUFinishingBackCentreBBRJoin = false,

	wallFinishedList = [],

	// Polishing (stone) state and tracking
	leftPolishedTreated = false,
	rightPolishedTreated = false,
	leftWaterfall = false,
	rightWaterfall = false,
	wallPolished = false,
	wallPolishedList = [],
	wallStraightPolishingBack = false,
	wallLPolishingBackLeft = false,
	wallLPolishingBackRight = false,
	wallLPolishingBackRightBB = false,
	wallLPolishingBackLeftBB = false,
	wallUPolishingBackLeft = false,
	wallUPolishingBackCentre = false,
	wallUPolishingBackRight = false,
	wallUPolishingBackCentreBBOnLeft = false,
	wallUPolishingBackRightBB = false,
	wallUPolishingBackLeftBB = false,
	wallUPolishingBackCentreBBRJoin = false,


	joinType = 'Left',
	forceJoin = false,
	colour = null,
	reviewImage = null,
	reviewImageTag = null,
	reviewImageDone = false,
	reviewImageLDone = false,
	reviewImageUDone = false,
	dontReloadReviewImage = false,
	loadColourImages = true,
	addtoCartQueue = [],

	addAnother = false,
	$savedPlan =  $benchtopPlanner.find('.saved-plan'),
	$loadOptions =$benchtopPlanner.find('.step-1 .load-options'),
	$planToLoad = $loadOptions.find('select#plan-to-load'),
	$saveOptions = $('.save-options'),
	$planTitle = $saveOptions.find('input#plan-title'),
	$customerForm = $benchtopPlanner.find('.ajax-customer-form'),
	$warning = $benchtopPlanner.find('.panel-warning'),
	$login = $customerForm.find('.form-login'),
	$register = $customerForm.find('.form-register'),
	$fullOverlay = $benchtopPlanner.find('.full-overlay'),
	finalPrice = 0,
	finalPriceFormatted = null,
	stonePolishingPrice = 0,
	stoneCutoutsPrice = 0,
	// Installation state and pricing
	needInstallation = true,
	installContactName = '',
	installContactNumber = '',
	installPostcode = '',
	installationPrice = 0,
	installationFeePrice = 0,
	installationTravelPrice = 0,
	// AGB rule (CAB-425 comment 450820): only one installation fee + travel call-out
	// per cart, regardless of how many benchtops are added. When the cart already
	// contains those variants from a previous benchtop, we zero the per-benchtop
	// fee in the Step 9 total AND skip pushing them into addtoCartQueue again.
	installationFeesAlreadyInCart = false,
	installFeeProduct = null,
	installFeeIDWithJoints = null,
	installFeePriceWithJoints = null,
	installFeeIDNoJoints = null,
	installFeePriceNoJoints = null,
	installTravelProduct = null,
	installTravelDefaultID = null,
	$saveButton = $benchtopPlanner.find('a.btn-save'),
	firstSave = true,
	savePlanAfterLogin = false,
	addToCartAfterSave = false,
	customerID = options.customer_id,
	customerTags = options.customer_tags,
	planID = options.plan_id,
	planToLoad = 1,
	savedVariables = new Object(),
	saveTimer,
	totalPlan = options.total,
	totalAllowed = 500,
	addToCartCount = 0,
	loadingSavedPlan = false,
	firstLoad = false;

	// Load end finishing product
	loadEndFinishing(false);

	// Load stone polishing and waterfall products
	loadPolishingProducts(false);
	loadCutoutProducts(false);
	loadStoneJoin(false);
	loadInstallationProducts(false);

	// Add error to field + general step error
	function addError($this, msg) {
		$this.addClass('error').closest('.step').find('.form-error').addClass('shown').html('<p>' + msg + '</p>');
	}

	// Remove error from field + remove general step error
	function removeError($this) {
		$this.removeClass('error').closest('.step').find('.form-error').removeClass('shown');
	}

	function addFormError($this, msg) {
		$this.addClass('error').closest('form').find('.form-error').addClass('shown').append('<p>' + msg + '</p>');
	}

	function getStoneStandardLength() {
		if(benchMaterial == 'Laminate') {
			return standardLength;
		} else {
			return stoneStandardLength;
		}
	}

	function calculateStraightLength() {
		// Clear 1A info
		benchtop1AID = null;
		benchtop1APrice = null;
		length1AFinal = null;

		const standardLength = getStoneStandardLength();

		const maxBeforeSplit = standardLength + 600;

		if(length1 && depth1) {
			if(length1 > standardLength) {
				if(length1 > maxBeforeSplit) {
					// Set right as standardLength
					length1AFinal = standardLength;
					length1Final = length1 - length1AFinal;
				} else {
					// Set left as 600
					length1Final = 600;
					length1AFinal = length1 - length1Final;
				}
			} else {
				length1Final = length1;
			}
			getPrice();
		}
	}

	function calculateLLength() {
		// Clear 1A info
		benchtop1AID = null;
		benchtop1APrice = null;
		length1AFinal = null;

		// Clear 2A info
		benchtop2AID = null;
		benchtop2APrice = null;
		length2AFinal = null;

		const standardLength = getStoneStandardLength();
		const maxBeforeSplit = standardLength + 600;

		// Calcuate 'real size' of benchtop (this changes depending on the join, but will be recalculated later if the join side is changed)
		if(length1 > standardLength || length2 > standardLength) {

			// Force joins in a certain direction if it will mean less benchtop pieces
			// Don't do this to breakfast bars because they can only have the join in one place
			if(!breakfastBar) {
				// Left should be one piece
				if(length1 > standardLength && length1 - depth2 <= standardLength) {
					if(length2 <= standardLength) {
						joinType = 'Left';
						forceJoin = true;

						length1Final = length1 - depth2 + joinSpace;
						length2Final = length2;

						$benchtopPlanner.find('.step-5 .if-l').addClass('shown');
						$benchtopPlanner.find('.step-5 .if-l-join-l-forced, .step-5 .if-l-join-r-forced').removeClass('shown');
					}
				}

				// Right should be one piece
				if(length2 > standardLength && length2 - depth1 <= standardLength) {
					if(length1 <= standardLength) {
						joinType = 'Right';
						forceJoin = true;

						length1Final = length1;
						length2Final = length2 - depth1 + joinSpace;

						$benchtopPlanner.find('.step-5 .if-l').addClass('shown');
						$benchtopPlanner.find('.step-5 .if-l-join-l-forced, .step-5 .if-l-join-r-forced').removeClass('shown');
					}
				}
			}

			if(!forceJoin) {
				if(joinType == 'Left') {
					if(length1 > standardLength && length2 > standardLength) {
						if(length1 - depth2 <= standardLength) {
							// Only need one piece
							length1Final = length1 - depth2 + joinSpace;
						} else if(length1 - depth2 > maxBeforeSplit) {
							// Set right as standardLength
							length1AFinal = standardLength;
							length1Final = length1 - depth2 + joinSpace - length1AFinal;
						} else {
							// Set left as 600
							length1Final = 600;
							length1AFinal = length1 - depth2 + joinSpace - length1Final;
						}

						if(length2 > maxBeforeSplit) {
							// Set left as standardLength
							length2Final = standardLength;
							length2AFinal = length2 - length2Final;
						} else {
							// Set right as 600
							length2AFinal = 600;
							length2Final = length2 - length2AFinal;
						}

					} else if(length1 > standardLength) {
						if(length1 - depth2 <= standardLength) {
							// Only need one piece
							length1Final = length1 - depth2 + joinSpace;
						} else if(length1 - depth2 > maxBeforeSplit) {
							// Set right as standardLength
							length1AFinal = standardLength;
							length1Final = length1 - depth2 + joinSpace - length1AFinal;
						} else {
							// Set left as 600
							length1Final = 600;
							length1AFinal = length1 - depth2 + joinSpace - length1Final;
						}
						length2Final = length2;

					} else if(length2 > standardLength) {
						length1Final = length1 - depth2 + joinSpace;
						if(length2 > maxBeforeSplit) {
							// Set left as standardLength
							length2Final = standardLength;
							length2AFinal = length2 - length2Final;
						} else {
							// Set right as 600
							length2AFinal = 600;
							length2Final = length2 - length2AFinal;
						}
					}

				} else if(joinType == 'Right') {
					if(length1 > standardLength && length2 > standardLength) {
						if(length1 > maxBeforeSplit) {
							// Set right as standardLength
							length1AFinal = standardLength;
							length1Final = length1 - length1AFinal;
						} else {
							// Set left as 600
							length1Final = 600;
							length1AFinal = length1 - length1Final;
						}

						if(length2 - depth1 <= standardLength) {
							// Only need one piece
							length2Final = length2 - depth1 + joinSpace;
						} else if(length2 - depth1 > maxBeforeSplit) {
							// Set left as standardLength
							length2Final = standardLength;
							length2AFinal = length2 - depth1 + joinSpace - length2Final;
						} else {
							// Set right as 600
							length2AFinal = 600;
							length2Final = length2 - depth1 + joinSpace - length2AFinal;
						}

					} else if(length1 > standardLength) {
						if(length1 > maxBeforeSplit) {
							// Set right as standardLength
							length1AFinal = standardLength;
							length1Final = length1 - length1AFinal;
						} else {
							// Set left as 600
							length1Final = 600;
							length1AFinal = length1 - length1Final;
						}
						length2Final = length2 - depth1 + joinSpace;

					} else if(length2 > standardLength) {
						length1Final = length1;
						if(length2 - depth1 <= standardLength) {
							// Only need one piece
							length2Final = length2 - depth1 + joinSpace;
						} else if(length2 - depth1 > maxBeforeSplit) {
							// Set left as standardLength
							length2Final = standardLength;
							length2AFinal = length2 - depth1 + joinSpace - length2Final;
						} else {
							// Set right as 600
							length2AFinal = 600;
							length2Final = length2 - depth1 + joinSpace - length2AFinal;
						}
					}
				}
			}

		} else {
			if(joinType == 'Left') {
				length1Final = length1 - depth2 + joinSpace;
				length2Final = length2;
			} else if(joinType == 'Right') {
				length1Final = length1;
				length2Final = length2 - depth1 + joinSpace;
			}
		}

		// Make sure that the lengths are ok
		if(length1 >= (depth2 + minLength) && length2 >= (depth1 + minLength)) {
			getPrice();
		}
	}
	function calculateULength() {
		// Clear 1A info
		benchtop1AID = null;
		benchtop1APrice = null;
		length1AFinal = null;

		// Clear 2A info
		benchtop2AID = null;
		benchtop2APrice = null;
		length2AFinal = null;

		// Clear 3A info
		benchtop3AID = null;
		benchtop3APrice = null;
		length3AFinal = null;

		const standardLength = getStoneStandardLength();
		const maxBeforeSplit = standardLength + 600;

		// Calcuate 'real size' of benchtop (this changes depending on the join, but will be recalculated later if the join side is changed)
		if(length1 > standardLength || length2 > standardLength || length3 > standardLength) {
			if(joinType == 'RightLeft') {
				if(length1 > standardLength && length2 > standardLength && length3 > standardLength) {
					if(length1 > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - length1Final;
					}
					if(length2 - depth1 + joinSpace - depth3 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace;
					} else if(length2 - depth1 + joinSpace - depth3 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - depth1 + joinSpace - depth3 + joinSpace - length2Final;
					} else {
						// Set right as 600
						length2AFinal = 600;
						length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace - length2AFinal;
					}
					if(length3 > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - length3AFinal;
					}

				} else if(length1 > standardLength && length2 > standardLength) {
					if(length1 > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - length1Final;
					}
					if(length2 - depth1 + joinSpace - depth3 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace;
					} else if(length2 - depth1 + joinSpace - depth3 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - depth1 + joinSpace - depth3 + joinSpace - length2Final;
					} else {
						// Set right as 600
						length2AFinal = 600;
						length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace - length2AFinal;
					}
					length3Final = length3;

				} else if(length1 > standardLength && length3 > standardLength) {
					if(length1 > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - length1Final;
					}
					length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace;
					if(length3 > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - length3AFinal;
					}

				} else if(length2 > standardLength && length3 > standardLength) {
					length1Final = length1;
					if(length2 - depth1 + joinSpace - depth3 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace;
					} else if(length2 - depth1 + joinSpace - depth3 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - depth1 + joinSpace - depth3 + joinSpace - length2Final;
					} else {
						// Set right as 600
						length2AFinal = 600;
						length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace - length2AFinal;
					}
					if(length3 > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - length3AFinal;
					}

				} else if(length1 > standardLength) {
					if(length1 > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - length1Final;
					}
					length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace;
					length3Final = length3;

				} else if(length2 > standardLength) {
					length1Final = length1;
					if(length2 - depth1 + joinSpace - depth3 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace;
					} else if(length2 - depth1 + joinSpace - depth3 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - depth1 + joinSpace - depth3 + joinSpace - length2Final;
					} else {
						// Set right as 600
						length2AFinal = 600;
						length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace - length2AFinal;
					}
					length3Final = length3;

				} else if(length3 > standardLength) {
					length1Final = length1;
					length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace;
					if(length3 > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - length3AFinal;
					}
				}

			} else if(joinType == 'LeftRight') {
				if(length1 > standardLength && length2 > standardLength && length3 > standardLength) {
					if(length1 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length1Final = length1 - depth2 + joinSpace;
					} else if(length1 - depth2 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - depth2 + joinSpace - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - depth2 + joinSpace - length1Final;
					}
					if(length2 > standardLength + depth3 + 200) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - length2Final;
					} else {
						// Set right as depth + 200 (so the join will be covered ok)
						length2AFinal = depth3 + 200;
						// Set 600 as minimum
						if(length2AFinal < 600) {
							length2AFinal = 600;
						}
						length2Final = length2 - length2AFinal;
					}
					if(length3 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length3Final = length3 - depth2 + joinSpace;
					} else if(length3 - depth2 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - depth2 + joinSpace - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - depth2 + joinSpace - length3AFinal;
					}

				} else if(length1 > standardLength && length2 > standardLength) {
					if(length1 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length1Final = length1 - depth2 + joinSpace;
					} else if(length1 - depth2 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - depth2 + joinSpace - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - depth2 + joinSpace - length1Final;
					}
					if(length2 > standardLength + depth3 + 200) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - length2Final;
					} else {
						// Set right as depth + 200 (so the join will be covered ok)
						length2AFinal = depth3 + 200;
						// Set 600 as minimum
						if(length2AFinal < 600) {
							length2AFinal = 600;
						}
						length2Final = length2 - length2AFinal;
					}
					length3Final = length3 - depth2 + joinSpace;

				} else if(length1 > standardLength && length3 > standardLength) {
					if(length1 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length1Final = length1 - depth2 + joinSpace;
					} else if(length1 - depth2 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - depth2 + joinSpace - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - depth2 + joinSpace - length1Final;
					}
					length2Final = length2;
					if(length3 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length3Final = length3 - depth2 + joinSpace;
					} else if(length3 - depth2 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - depth2 + joinSpace - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - depth2 + joinSpace - length3AFinal;
					}

				} else if(length2 > standardLength && length3 > standardLength) {
					length1Final = length1 - depth2 + joinSpace;
					if(length2 > standardLength + depth3 + 200) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - length2Final;
					} else {
						// Set right as depth + 200 (so the join will be covered ok)
						length2AFinal = depth3 + 200;
						// Set 600 as minimum
						if(length2AFinal < 600) {
							length2AFinal = 600;
						}
						length2Final = length2 - length2AFinal;
					}
					if(length3 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length3Final = length3 - depth2 + joinSpace;
					} else if(length3 - depth2 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - depth2 + joinSpace - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - depth2 + joinSpace - length3AFinal;
					}

				} else if(length1 > standardLength) {
					if(length1 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length1Final = length1 - depth2 + joinSpace;
					} else if(length1 - depth2 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - depth2 + joinSpace - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - depth2 + joinSpace - length1Final;
					}
					length2Final = length2;
					length3Final = length3 - depth2 + joinSpace;

				} else if(length2 > standardLength) {
					length1Final = length1 - depth2 + joinSpace;
					if(length2 > standardLength + depth3 + 200) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - length2Final;
					} else {
						// Set right as depth + 200 (so the join will be covered ok)
						length2AFinal = depth3 + 200;
						// Set 600 as minimum
						if(length2AFinal < 600) {
							length2AFinal = 600;
						}
						length2Final = length2 - length2AFinal;
					}
					length3Final = length3 - depth2 + joinSpace;

				} else if(length3 > standardLength) {
					length1Final = length1 - depth2 + joinSpace;
					length2Final = length2;
					if(length3 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length3Final = length3 - depth2 + joinSpace;
					} else if(length3 - depth2 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - depth2 + joinSpace - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - depth2 + joinSpace - length3AFinal;
					}
				}

			} else if(joinType == 'Left') {
				if(length1 > standardLength && length2 > standardLength && length3 > standardLength) {
					if(length1 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length1Final = length1 - depth2 + joinSpace;
					} else if(length1 - depth2 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - depth2 + joinSpace - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - depth2 + joinSpace - length1Final;
					}
					if(length2 - depth3 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth3 + joinSpace;
					} else if(length2 - depth3 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - depth3 + joinSpace - length2Final;
					} else {
						// Set right as 600
						length2AFinal = 600;
						length2Final = length2 - depth3 + joinSpace - length2AFinal;
					}
					if(length3 > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - length3AFinal;
					}

				} else if(length1 > standardLength && length2 > standardLength) {
					if(length1 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length1Final = length1 - depth2 + joinSpace;
					} else if(length1 - depth2 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - depth2 + joinSpace - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - depth2 + joinSpace - length1Final;
					}
					if(length2 - depth3 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth3 + joinSpace;
					} else if(length2 - depth3 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - depth3 + joinSpace - length2Final;
					} else {
						// Set right as 600
						length2AFinal = 600;
						length2Final = length2 - depth3 + joinSpace - length2AFinal;
					}
					length3Final = length3;

				} else if(length1 > standardLength && length3 > standardLength) {
					if(length1 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length1Final = length1 - depth2 + joinSpace;
					} else if(length1 - depth2 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - depth2 + joinSpace - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - depth2 + joinSpace - length1Final;
					}
					length2Final = length2 - depth3 + joinSpace;
					if(length3 > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - length3AFinal;
					}

				} else if(length2 > standardLength && length3 > standardLength) {
					length1Final = length1 - depth2 + joinSpace;
					if(length2 - depth3 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth3 + joinSpace;
					} else if(length2 - depth3 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - depth3 + joinSpace - length2Final;
					} else {
						// Set right as 600
						length2AFinal = 600;
						length2Final = length2 - depth3 + joinSpace - length2AFinal;
					}
					if(length3 > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - length3AFinal;
					}

				} else if(length1 > standardLength) {
					if(length1 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length1Final = length1 - depth2 + joinSpace;
					} else if(length1 - depth2 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - depth2 + joinSpace - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - depth2 + joinSpace - length1Final;
					}
					length2Final = length2 - depth3 + joinSpace;
					length3Final = length3;

				} else if(length2 > standardLength) {
					length1Final = length1 - depth2 + joinSpace;
					if(length2 - depth3 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth3 + joinSpace;
					} else if(length2 - depth3 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length2Final = standardLength;
						length2AFinal = length2 - depth3 + joinSpace - length2Final;
					} else {
						// Set right as 600
						length2AFinal = 600;
						length2Final = length2 - depth3 + joinSpace - length2AFinal;
					}
					length3Final = length3;

				} else if(length3 > standardLength) {
					length1Final = length1 - depth2 + joinSpace;
					length2Final = length2 - depth3 + joinSpace;
					if(length3 > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - length3AFinal;
					}
				}
			} else if(joinType == 'Right') {
				if(length1 > standardLength && length2 > standardLength && length3 > standardLength) {
					if(length1 > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - length1Final;
					}
					if(length2 - depth1 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth1 + joinSpace;
					} else if(length2 - depth1 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length2AFinal = standardLength;
						length2Final = length2 - depth1 + joinSpace - length2AFinal;
					} else {
						// Set left as 600
						length2Final = 600;
						length2AFinal = length2 - depth1 + joinSpace - length2Final;
					}
					if(length3 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length3Final = length3 - depth2 + joinSpace;
					} else if(length3 - depth2 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - depth2 + joinSpace - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - depth2 + joinSpace - length3AFinal;
					}

				} else if(length1 > standardLength && length2 > standardLength) {
					if(length1 > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - length1Final;
					}
					if(length2 - depth1 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth1 + joinSpace;
					} else if(length2 - depth1 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length2AFinal = standardLength;
						length2Final = length2 - depth1 + joinSpace - length2AFinal;
					} else {
						// Set left as 600
						length2Final = 600;
						length2AFinal = length2 - depth1 + joinSpace - length2Final;
					}
					length3Final = length3 - depth2 + joinSpace;
					
				} else if(length1 > standardLength && length3 > standardLength) {
					if(length1 > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - length1Final;
					}
					length2Final = length2 - depth1 + joinSpace;
					if(length3 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length3Final = length3 - depth2 + joinSpace;
					} else if(length3 - depth2 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - depth2 + joinSpace - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - depth2 + joinSpace - length3AFinal;
					}
					
				} else if(length2 > standardLength && length3 > standardLength) {
					length1Final = length1;
					if(length2 - depth1 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth1 + joinSpace;
					} else if(length2 - depth1 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length2AFinal = standardLength;
						length2Final = length2 - depth1 + joinSpace - length2AFinal;
					} else {
						// Set left as 600
						length2Final = 600;
						length2AFinal = length2 - depth1 + joinSpace - length2Final;
					}
					if(length3 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length3Final = length3 - depth2 + joinSpace;
					} else if(length3 - depth2 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - depth2 + joinSpace - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - depth2 + joinSpace - length3AFinal;
					}
					
				} else if(length1 > standardLength) {
					if(length1 > maxBeforeSplit) {
						// Set right as standardLength
						length1AFinal = standardLength;
						length1Final = length1 - length1AFinal;
					} else {
						// Set left as 600
						length1Final = 600;
						length1AFinal = length1 - length1Final;
					}
					length2Final = length2 - depth1 + joinSpace;
					length3Final = length3 - depth2 + joinSpace;
					
				} else if(length2 > standardLength) {
					length1Final = length1;
					if(length2 - depth1 + joinSpace <= standardLength) {
						// Only need one piece
						length2Final = length2 - depth1 + joinSpace;
					} else if(length2 - depth1 + joinSpace > maxBeforeSplit) {
						// Set right as standardLength
						length2AFinal = standardLength;
						length2Final = length2 - depth1 + joinSpace - length2AFinal;
					} else {
						// Set left as 600
						length2Final = 600;
						length2AFinal = length2 - depth1 + joinSpace - length2Final;
					}
					length3Final = length3 - depth2 + joinSpace;
					
				} else if(length3 > standardLength) {
					length1Final = length1;
					length2Final = length2 - depth1 + joinSpace;
					if(length3 - depth2 + joinSpace <= standardLength) {
						// Only need one piece
						length3Final = length3 - depth2 + joinSpace;
					} else if(length3 - depth2 + joinSpace > maxBeforeSplit) {
						// Set left as standardLength
						length3Final = standardLength;
						length3AFinal = length3 - depth2 + joinSpace - length3Final;
					} else {
						// Set right as 600
						length3AFinal = 600;
						length3Final = length3 - depth2 + joinSpace - length3AFinal;
					}
				}

			}

		} else {
			if(joinType == 'RightLeft') {
				length1Final = length1;
				length2Final = length2 - depth1 + joinSpace - depth3 + joinSpace;
				length3Final = length3;
			} else if(joinType == 'LeftRight') {
				length1Final = length1 - depth2 + joinSpace;
				length2Final = length2;
				length3Final = length3 - depth2 + joinSpace;
			} else if(joinType == 'Left') {
				length1Final = length1 - depth2 + joinSpace;
				length2Final = length2 - depth3 + joinSpace;
				length3Final = length3;
			} else if(joinType == 'Right') {
				length1Final = length1;
				length2Final = length2 - depth1 + joinSpace;
				length3Final = length3 - depth2 + joinSpace;
			}
		}

		// Make sure that the lengths are ok
		if(length1 >= (depth2 + minLength) && length2 >= (depth1 + depth3 + minUGap) && length3 >= (depth2 + minLength)) {
			getPrice();
		}
	}

	function validateMeasurement($this) {
		var min = parseInt($this.attr('min'), 10),
		max = parseInt($this.attr('max'), 10),
		origVal = $this.val(),
		val = parseInt(origVal, 10);

		// If input was valid
		if(origVal == val && val >= min && val <= max) {
			removeError($this);

			// Save value
			if($this.parent().hasClass('straight-length') || $this.parent().hasClass('l-left-length') || $this.parent().hasClass('u-left-length')) {
				length1 = val;
			} else if($this.parent().hasClass('l-right-length') || $this.parent().hasClass('u-centre-length')) {
				length2 = val;
			} else if($this.parent().hasClass('u-right-length')) {
				length3 = val;
			} else if($this.parent().hasClass('straight-depth') || $this.parent().hasClass('l-left-depth') || $this.parent().hasClass('u-left-depth')) {
				depth1 = val;
			} else if($this.parent().hasClass('l-right-depth') || $this.parent().hasClass('u-centre-depth')) {
				depth2 = val;
			} else if($this.parent().hasClass('u-right-depth')) {
				depth3 = val;
			}

			// Look up price if there's enough info
			if(benchtopShape == 'Straight') {
				calculateStraightLength();

			} else if(benchtopShape == 'L-Shaped') {
				if(length1 && depth1 && length2 && depth2) {
					calculateLLength();

					// Show left error
					if(length1 < (depth2 + minLength)) {
						validationError(3, $benchtopPlanner.find('.step-3'), 'The left length is too short, it must be at least ' + (depth2 + minLength) + ' millimetres.');
					// Show right error
					} else if(length2 < (depth1 + minLength)) {
						validationError(3, $benchtopPlanner.find('.step-3'), 'The right length is too short, it must be at least ' + (depth1 + minLength) + ' millimetres.');
					}
				}

			} else if(benchtopShape == 'U-Shaped') {
				if(length1 && depth1 && length2 && depth2 && length3 && depth3) {
					calculateULength();

					// Show left error
					if(length1 < (depth2 + minLength)) {
						validationError(3, $benchtopPlanner.find('.step-3'), 'The left length is too short, it must be at least ' + (depth2 + minLength) + ' millimetres.');
					// Show centre error
					} else if(length2 < (depth1 + depth3 + minUGap)) {
						// Highlight box which needs fixing
						$benchtopPlanner.find('.step-3 .shown .u-centre-length input').addClass('error');
						validationError(3, $benchtopPlanner.find('.step-3'), 'The centre length is too short, it must be at least ' + (depth1 + depth3 + minUGap) + ' millimetres so there is space for the drawers and doors in your kitchen to open.');
					// Show right error
					} else if(length3 < (depth2 + minLength)) {
						validationError(3, $benchtopPlanner.find('.step-3'), 'The right length is too short, it must be at least ' + (depth2 + minLength) + ' millimetres.');
					}
				}
			}

		} else {
			addError($this, 'Please enter a valid measurement - number only, between ' + min + ' and ' + max + ' millimetres.');
		}
	}

	function validateRadioMeasurement($this) {
		if($this.closest('.user-input').hasClass('straight-depth') || $this.closest('.user-input').hasClass('l-left-depth') || $this.closest('.user-input').hasClass('u-left-depth')) {
			depth1 = parseInt($this.val(), 10);
		} else if($this.closest('.user-input').hasClass('l-right-depth')) {
			depth2 = parseInt($this.val(), 10);
		} else if($this.closest('.user-input').hasClass('u-right-depth')) {
			depth3 = parseInt($this.val(), 10);
		}

		// Look up price if there's enough info
		if(benchtopShape == 'Straight') {
			calculateStraightLength();

		} else if(benchtopShape == 'L-Shaped') {
			if(length1 && depth1 && length2 && depth2 && length1 >= (depth2 + minLength) && length2 >= (depth1 + minLength)) {
				calculateLLength();
			}

		} else if(benchtopShape == 'U-Shaped') {
			if(length1 && depth1 && length2 && depth2 && length3 && depth3 && length1 >= (depth2 + minLength) && length2 >= (depth1 + depth3 + minUGap) && length3 >= (depth2 + minLength)) {
				calculateULength();
			}
		}
	}

	function validationError(i, $this, msg) {
		window.scrollTo(0, 0);

		if($this.hasClass('.step')) {
			$this.find('.form-error').addClass('shown').html('<p>' + msg + '</p>');
		} else {
			$this.closest('.step').find('.form-error').addClass('shown').html('<p>' + msg + '</p>');
		}

		currentStep = i;

		if(stepProgress > currentStep) {
			updateProgress(currentStep);
		}
	}

	function calculateSize(){
		totalSquareMM = 0;
		if(benchtopShape == 'Straight') {
			if(length1 && depth1) {
				totalSquareMM = length1 * depth1;
			}
		} else if(benchtopShape == 'L-Shaped') {
			if(length1 && depth1 && length2 && depth2) {
				// Calculate L-shape area: left piece + right piece - overlap
				var leftPieceArea = length1 * depth1;
				var rightPieceArea = length2 * depth2;
				var overlapArea = depth1 * depth2;
				totalSquareMM = leftPieceArea + rightPieceArea - overlapArea;
			}
		} else if(benchtopShape == 'U-Shaped') {
			if(length1 && depth1 && length2 && depth2 && length3 && depth3) {
				// Calculate U-shape area: left piece + center piece + right piece - overlaps
				var leftPieceArea = length1 * depth1;
				var centerPieceArea = length2 * depth2;
				var rightPieceArea = length3 * depth3;
				var leftOverlapArea = depth1 * depth2;
				var rightOverlapArea = depth2 * depth3;
				totalSquareMM = leftPieceArea + centerPieceArea + rightPieceArea - leftOverlapArea - rightOverlapArea;
			}
		}

		// Calculate waterfall areas separately (waterfall height is always 870mm)
		const waterfallHeight = 870;
		waterfallArea = 0;
		leftWaterfallArea = 0;
		rightWaterfallArea = 0;
		
		if(leftWaterfall) {
			if(benchtopShape == 'Straight') {
				leftWaterfallArea = depth1 * waterfallHeight;
			} else if(benchtopShape == 'L-Shaped') {
				leftWaterfallArea = depth1 * waterfallHeight;
			} else if(benchtopShape == 'U-Shaped') {
				leftWaterfallArea = depth1 * waterfallHeight;
			}
		}
		
		if(rightWaterfall) {
			if(benchtopShape == 'Straight') {
				rightWaterfallArea = depth1 * waterfallHeight;
			} else if(benchtopShape == 'L-Shaped') {
				rightWaterfallArea = depth2 * waterfallHeight;
			} else if(benchtopShape == 'U-Shaped') {
				rightWaterfallArea = depth3 * waterfallHeight;
			}
		}
		
		// Keep combined area for backward compatibility
		waterfallArea = leftWaterfallArea + rightWaterfallArea;

		getMaterialPrice();
	}

	function validateSteps(upTo) {
		for(var i = 1; i <= upTo; i++) {
			// Shape
			if(i == 1) {
				var $choice = $benchtopPlanner.find('.step-1 .choice');

				if(!$choice.hasClass('selected')) {
					validationError(i, $choice, 'Please choose a shape.');
					return false;
				}

			// Breakfast Bar
			} else if(i == 2) {
				var $choice = $benchtopPlanner.find('.step-2 .choice');

				if(!$choice.hasClass('selected')) {
					validationError(i, $choice, 'Please choose if you would like a breakfast bar.');
					return false;
				}
				
				// Also validate the breakfast bar side if it's a L shape with a breakfast bar
				if(benchtopShape == 'L-Shaped' && breakfastBar) {
					if(!breakfastBarSide) {
						validationError(i, $choice, 'Please choose the breakfast bar side.');
						return false;
					}
				} else if(benchtopShape == 'U-Shaped' && breakfastBar) {
					if(!breakfastBarSide) {
						validationError(i, $choice, 'Please choose the breakfast bar side.');
						return false;
					}
				}

			// Measurements
			} else if(i == 3) {
				var $step3 = $benchtopPlanner.find('.step-3');

				if(firstLoad){
					firstLoad = false;					
				}
				else{
					// Save out measurements on next step (they should already be saved, but good to check in case they're auto-filled etc)
					$step3.find('.shown input[type=number]').each(function() {
						validateMeasurement($(this));
					});
				}
				
				// Save out measurements on next step
				$step3.find('.shown input[type=radio]:checked').each(function() {
					validateRadioMeasurement($(this));
				});

				if(benchtopShape == 'Straight') {
					if(length1 == null || depth1 == null) {
						validationError(i, $step3, 'Please enter your measurements - make sure that both length and depth have been entered.');
						return false;
					}

					// Update review step with measurements
					$benchtopPlanner.find('.step-9 .straight-length').text(length1 + 'mm');
					$benchtopPlanner.find('.step-9 .straight-depth').text(depth1 + 'mm');

				} else if(benchtopShape == 'L-Shaped') {
					if(length1 == null || depth1 == null || length2 == null || depth2 == null) {
						validationError(i, $step3, 'Please enter your measurements - make sure that all lengths and depths have been entered.');
						return false;
					}

					if(!(length1 >= (depth2 + minLength) && length2 >= (depth1 + minLength))) {
						validationError(i, $step3, 'Please make sure that the left and right lengths are at least ' + minLength + 'mm longer than the opposite depth.');
						return false;
					}

					// Update review step with measurements
					$benchtopPlanner.find('.step-9 .l-left-length').text(length1 + 'mm');
					$benchtopPlanner.find('.step-9 .l-left-depth').text(depth1 + 'mm');
					$benchtopPlanner.find('.step-9 .l-right-length').text(length2 + 'mm');
					$benchtopPlanner.find('.step-9 .l-right-depth').text(depth2 + 'mm');

				} else if(benchtopShape == 'U-Shaped') {
					if(length1 == null || depth1 == null || length2 == null || depth2 == null || length3 == null || depth3 == null) {
						validationError(i, $step3, 'Please enter your measurements - make sure that all lengths and depths have been entered.');
						return false;
					}

					if(!(length1 >= (depth2 + minLength) && length3 >= (depth2 + minLength))) {
						validationError(i, $step3, 'Please make sure that the all length measurements are at least ' + minLength + 'mm longer than the opposite depth.');
						return false;
					}

					if(!(length2 >= (depth1 + depth3 + minUGap))) {
						// Highlight box which needs fixing
						$benchtopPlanner.find('.step-3 .shown .u-centre-length input').addClass('error');
						validationError(i, $step3, 'The centre length is too short, it must be at least ' + (depth1 + depth3 + minUGap) + ' millimetres so there is space for the drawers and doors in your kitchen to open.');
						return false;
					}

					// Update review step with measurements
					$benchtopPlanner.find('.step-9 .u-left-length').text(length1 + 'mm');
					$benchtopPlanner.find('.step-9 .u-left-depth').text(depth1 + 'mm');
					$benchtopPlanner.find('.step-9 .u-centre-length').text(length2 + 'mm');
					$benchtopPlanner.find('.step-9 .u-centre-depth').text(depth2 + 'mm');
					$benchtopPlanner.find('.step-9 .u-right-length').text(length3 + 'mm');
					$benchtopPlanner.find('.step-9 .u-right-depth').text(depth3 + 'mm');
				}

				// Load colour images. The colour swatches (custom-benchtops-7) render
				// into .step-7, not .step-6 (which is the Join / Cut-outs step), so the
				// laminate delay-load <img>s only get their src set when we target
				// .step-7 here — otherwise they stay blank.
				if(loadColourImages) {
					loadColourImages = false;

					$benchtopPlanner.find('.step-7 img.delay-load').each(function() {
						doImageLoad($(this));
					});
				}
			// Material
			} else if(i == 4) {
				var $choice = $benchtopPlanner.find('.step-4 .choice');

				if(!$choice.hasClass('selected')) {
					validationError(i, $choice, 'Please choose a material.');
					return false;
				}
				
			// Join
			} else if(i == 6) {
				var $choice = $benchtopPlanner.find('.step-6 .choice');

				// Skip join re-validation while restoring a saved plan: the plan was
				// already valid when saved, but the join-position DOM selection isn't
				// reconstructed on load, so this check would otherwise fail and block
				// the jump to the review step — leaving the user stuck behind the
				// "Loading your saved plan…" overlay (which only tears down at step 9).
				if(benchMaterial == 'Laminate' && !loadingSavedPlan) {
					if(benchtopShape == 'L-Shaped' && !breakfastBar && !forceJoin) {
						if(!$choice.hasClass('selected')) {
							validationError(i, $choice, 'Please choose the join position.');
							return false;
						}
					} else if(benchtopShape == 'U-Shaped') {
						if(!$choice.hasClass('selected')) {
							validationError(i, $choice, 'Please choose the join position.');
							return false;
						}
					}
				}

			// Colour
			} else if(i == 7) {
				// var $choice = $benchtopPlanner.find('.step-7 .choice');

				if(!colour) {
					validationError(i, $choice, 'Please choose a colour.');
					return false;
				}
			// Installation (only for stone materials)
			}else if(i == 8) {
				// Skip installation validation for laminate materials, and while
				// restoring a saved plan: the plan was already valid when saved, the
				// install fields aren't guaranteed to be reconstructed on load, and
				// failing here would strand the user behind the "Loading your saved
				// plan…" overlay (which only tears down once step 9 renders).
				if(benchMaterial == 'Laminate' || loadingSavedPlan) {
					return true;
				}

				var $step8 = $benchtopPlanner.find('.step-8'),
					// needInstallation = $benchtopPlanner.find('input[name=install-assistance]:checked').val() == 'Yes',
					contactName = $.trim($benchtopPlanner.find('#install-contact-name').val()),
					contactNumber = $.trim($benchtopPlanner.find('#install-contact-number').val()),
					postcode = $.trim($benchtopPlanner.find('#install-postcode').val());

				// Contact name and number are always required
				if(contactName === ''){
					validationError(i, $step8, 'Please enter a contact name.');
					return false;
				}
				if(contactNumber === ''){
					validationError(i, $step8, 'Please enter a contact number.');
					return false;
				}

				// If installation is requested, postcode is required
				if(needInstallation && postcode === ''){
					validationError(i, $step8, 'Please enter a postcode for installation.');
					return false;
				}
				
				// If installation is requested and postcode is provided, validate it exists in available postcodes
				if(needInstallation && postcode !== ''){
					var postcodeValid = false;
					if(typeof window !== 'undefined' && Array.isArray(window.benchtopTravellingPostcodes)){
						var postcodeInt = parseInt(postcode, 10);
						if(!isNaN(postcodeInt)){
							// Check if postcode exists in the available postcodes array
							postcodeValid = window.benchtopTravellingPostcodes.some(function(availablePostcode){
								return parseInt(availablePostcode, 10) === postcodeInt;
							});
						}
					}
					
					if(!postcodeValid){
						validationError(i, $step8, 'We don\'t recognise that postcode please contact us');
						return false;
					}
				}
			}
		}
		return true;
	}

	// Load end finishing product
	function loadEndFinishing(update) {

		Shopify.getProduct('benchtop-end-finishing', function(product) {
			endFinishingProduct = product;

			for(var i = 0; i < product.variants.length; i++) {
				if(i == 0) {
					endFinishingID = product.variants[i].id;
					endFinishingPrice = product.variants[i].price;
				} else if(i == 1) {
					endFinishingLongID = product.variants[i].id;
					endFinishingLongPrice = product.variants[i].price;
				}
			}

			if(update) {
				calculateEndFinishingPrice();
			}
		});
	}

	function loadPolishingProducts(update) {
		Shopify.getProduct('benchtop-end-polishing', function(product) {
			polishingProduct = product;
			for(var i = 0; i < product.variants.length; i++) {
				if(i == 0) {
					polishingID = product.variants[i].id;
					polishingPrice = product.variants[i].price;
				} else if(i == 1) {
					polishingLongID = product.variants[i].id;
					polishingLongPrice = product.variants[i].price;
				}
			}
			if(update) {
				calculatePolishingPrice();
			}
		});

		Shopify.getProduct('benchtop-end-waterfall', function(product) {
			waterfallProduct = product;
			if(product.variants && product.variants.length) {
				for(var i = 0; i < product.variants.length; i++) {
					var variant = product.variants[i];
					var title = (variant.title || '').toLowerCase();
					var option1 = (variant.option1 || '').toLowerCase();
					if(title.includes('standard') || option1 === 'standard') {
						waterfallStandardID = variant.id;
						waterfallStandardPrice = variant.price;
					} else if(title.includes('large') || option1 === 'large') {
						waterfallLargeID = variant.id;
						waterfallLargePrice = variant.price;
					}
				}
				// Fallback to first variant if no Standard/Large variants found
				if(!waterfallStandardID && !waterfallLargeID) {
					waterfallStandardID = product.variants[0].id;
					waterfallStandardPrice = product.variants[0].price;
					waterfallLargeID = product.variants[0].id;
					waterfallLargePrice = product.variants[0].price;
				} else if(!waterfallStandardID) {
					waterfallStandardID = waterfallLargeID;
					waterfallStandardPrice = waterfallLargePrice;
				} else if(!waterfallLargeID) {
					waterfallLargeID = waterfallStandardID;
					waterfallLargePrice = waterfallStandardPrice;
				}
				// Keep legacy refs pointing to Standard for backward compatibility
				waterfallID = waterfallStandardID;
				waterfallPrice = waterfallStandardPrice;
			}
			if(update) {
				calculatePolishingPrice();
			}
		});
	}

	function loadCutoutProducts(update){
		// Load cutout product with mounting variants
		Shopify.getProduct('benchtop-cutout', function(product) {
			cutoutProduct = product;
			if(product.variants && product.variants.length){
				// Find Top mounted and Under mounted variants
				for(var i = 0; i < product.variants.length; i++) {
					var variant = product.variants[i];
					if(variant.title.toLowerCase().includes('top mounted') || variant.option1 === 'Top mounted') {
						cutoutTopID = variant.id;
						cutoutTopPrice = variant.price;
					} else if(variant.title.toLowerCase().includes('under mounted') || variant.option1 === 'Under mounted') {
						cutoutUnderID = variant.id;
						cutoutUnderPrice = variant.price;
					}
				}
				// Fallback to first variant if no specific mounting variants found
				if(!cutoutTopID && !cutoutUnderID) {
					cutoutID = product.variants[0].id;
					cutoutPrice = product.variants[0].price;
					cutoutTopID = product.variants[0].id;
					cutoutTopPrice = product.variants[0].price;
					cutoutUnderID = product.variants[0].id;
					cutoutUnderPrice = product.variants[0].price;
				} else {
					// Set the default cutoutID to top mounted for backward compatibility
					cutoutID = cutoutTopID;
					cutoutPrice = cutoutTopPrice;
				}
			}
			if(update){
				calculateCutoutsPrice();
			}
		});

		Shopify.getProduct('benchtop-taphole', function(product) {
			tapholeProduct = product;
			if(product.variants && product.variants.length){
				tapholeID = product.variants[0].id;
				tapholePrice = product.variants[0].price;
			}
			if(update){
				calculateCutoutsPrice();
			}
		});
		Shopify.getProduct('benchtop-cutout-window', function(product) {
			windowCutoutProduct = product;
			if(product.variants && product.variants.length){
				windowCutoutID = product.variants[0].id;
				windowCutoutPrice = product.variants[0].price;
			}
			if(update){
				calculateCutoutsPrice();
			}
		});
	}

	function calculateCutoutsPrice() {
		stoneCutoutsPrice = 0;
		
		// Calculate sink/tap cutout price
		if(sinkTapCutout && sinkTapQty > 0) {
			var sinkTapPrice = 0;
			if(sinkTapMount === 'Top mounted' && cutoutTopPrice != null) {
				sinkTapPrice = cutoutTopPrice;
			} else if(sinkTapMount === 'Under mounted' && cutoutUnderPrice != null) {
				sinkTapPrice = cutoutUnderPrice;
			} else if(cutoutPrice != null) {
				// Fallback to original cutout price
				sinkTapPrice = cutoutPrice;
			}
			stoneCutoutsPrice += sinkTapPrice * sinkTapQty;
		}
		
		// Calculate hob cutout price (hob is always top mounted)
		if(hobCutout && hobQty > 0) {
			var hobPrice = 0;
			if(cutoutTopPrice != null) {
				hobPrice = cutoutTopPrice;
			} else if(cutoutPrice != null) {
				// Fallback to original cutout price
				hobPrice = cutoutPrice;
			}
			stoneCutoutsPrice += hobPrice * hobQty;
		}
		
		// Calculate air switch cutout price (using taphole product)
		if(airSwitchCutout && airSwitchQty > 0 && tapholePrice != null) {
			stoneCutoutsPrice += tapholePrice * airSwitchQty;
		}
		
		// Update the total price
		updatePrice();
	}

	function loadStoneJoin(update){
		Shopify.getProduct('benchtop-join-stone', function(product) {
			stoneJoinProduct = product;
			if(product.variants && product.variants.length){
				stoneJoinID = product.variants[0].id;
				stoneJoinPrice = product.variants[0].price;
			}
			if(update){
				updatePrice();
			}
		});
	}

	function loadInstallationProducts(update){
		// Installation base fee with/without joints
		Shopify.getProduct('benchtop-installation-fee', function(product){
			installFeeProduct = product;
			// Assume variants: option 'With Joints' Yes/No or two variants in order
			if(product.variants && product.variants.length){
				installFeeIDNoJoints = product.variants[0].id;
				installFeePriceNoJoints = product.variants[0].price;
				if(product.variants[1]){
					installFeeIDWithJoints = product.variants[1].id;
					installFeePriceWithJoints = product.variants[1].price;
				}
			}
			refreshInstallationFeesAlreadyInCart();
			if(update){calculateInstallationPrice();}
		});
		// Installation travel fee, variants by postcode option values
		Shopify.getProduct('benchtop-installation-travel-fee', function(product){
			installTravelProduct = product;
			if(product.variants && product.variants.length){
				installTravelDefaultID = product.variants[0].id;
			}
			refreshInstallationFeesAlreadyInCart();
			if(update){ calculateInstallationPrice();}
		});
	}

	// Check the live Shopify cart for an existing installation fee or travel
	// call-out variant (added by a previous benchtop). When found, the front-end
	// Step 9 total drops those line items so the displayed price matches what
	// the cart will actually charge.
	function refreshInstallationFeesAlreadyInCart() {
		var feeVariantIds = [installFeeIDWithJoints, installFeeIDNoJoints, installTravelDefaultID]
			.filter(function(v){ return v != null; })
			.map(String);

		if(feeVariantIds.length === 0) {
			return;
		}

		fetch('/cart.js')
		.then(function(r){ return r.json(); })
		.then(function(cart){
			var present = false;
			if(cart && Array.isArray(cart.items)) {
				present = cart.items.some(function(it){
					return feeVariantIds.indexOf(String(it.variant_id)) !== -1;
				});
			}
			if(present !== installationFeesAlreadyInCart) {
				installationFeesAlreadyInCart = present;
				calculateInstallationPrice();
			}
		})
		.catch(function(){ /* leave flag as-is on network error */ });
	}
	function calculateCutoutsPrice(){
		if(benchMaterial != 'Laminate'){
			// Count from state variables rather than DOM
			cutoutQty = 0;
			tapholeQty = 0;
			windowCutoutQty = 0;

			// Common cutouts for all shapes
			cutoutQty += (sinkTapCutout ? sinkTapQty : 0) + (hobCutout ? hobQty : 0);
			tapholeQty += airSwitchCutout ? airSwitchQty : 0;

			var cutoutTotal = 0, tapholeTotal = 0, windowTotal = 0;
			if(cutoutProduct){
				// Sink/Tap cutout — the top-mounted and under-mounted variants are
				// priced differently, so price it by the selected mount.
				if(sinkTapCutout && sinkTapQty > 0){
					var sinkTapUnit = cutoutPrice;
					if(sinkTapMount === 'Under mounted' && cutoutUnderPrice != null){
						sinkTapUnit = cutoutUnderPrice;
					} else if(sinkTapMount === 'Top mounted' && cutoutTopPrice != null){
						sinkTapUnit = cutoutTopPrice;
					}
					if(sinkTapUnit != null){ cutoutTotal += sinkTapUnit * sinkTapQty; }
				}
				// Hob cutout is always top mounted.
				if(hobCutout && hobQty > 0){
					var hobUnit = (cutoutTopPrice != null) ? cutoutTopPrice : cutoutPrice;
					if(hobUnit != null){ cutoutTotal += hobUnit * hobQty; }
				}
			}
			if(tapholeProduct && tapholePrice != null){
				tapholeTotal = tapholeQty * tapholePrice;
			}
			if(windowCutoutProduct && windowCutoutPrice != null){
				windowTotal = windowCutoutQty * windowCutoutPrice;
			}
			stoneCutoutsPrice = cutoutTotal + tapholeTotal + windowTotal;
			updatePrice();
		}
	}

	function calculatePolishingPrice() {
		if(benchMaterial != 'Laminate') {
			var left = 0,
			right = 0,
			wall = 0,
			leftWF = 0,
			rightWF = 0;

			polishingQty = 0;
			polishingLongQty = 0;
			waterfallQty = 0;

			if(leftPolishedTreated && !leftWaterfall) left = 1;
			if(rightPolishedTreated && !rightWaterfall) right = 1;
			if(leftWaterfall) leftWF = 1;
			if(rightWaterfall) rightWF = 1;
			
			if(wallStraightPolishingBack) wall += 1;
			if(wallLPolishingBackLeft) wall += 1;
			if(wallLPolishingBackRight) wall += 1;
			if(wallLPolishingBackRightBB) wall += 1;
			if(wallLPolishingBackLeftBB) wall += 1;
			if(wallUPolishingBackLeft) wall += 1;
			if(wallUPolishingBackCentre) wall += 1;
			if(wallUPolishingBackRight) wall += 1;
			if(wallUPolishingBackCentreBBOnLeft) wall += 1;
			if(wallUPolishingBackRightBB) wall += 1;
			if(wallUPolishingBackLeftBB) wall += 1;
			if(wallUPolishingBackCentreBBRJoin) wall += 1;
			
			// Count polishing ends (non-waterfall) and waterfall ends separately.
			// Polishing uses its own threshold (longEndPolishing = 1000):
			// length/depth <= 1000 → standard polishing, > 1000 → long polishing.
			// On top of user-selected ends and BB-auto-set wall ends, every
			// inside/front face carries a default polishing charge — one per
			// section (1 Straight, 2 L-Shaped, 3 U-Shaped), standard or long
			// depending on that section's length vs longEndPolishing.
			if(benchtopShape == 'Straight') {
				if(depth1 <= longEndPolishing) {
					polishingQty = left + right;
				} else {
					polishingLongQty = left + right;
				}
				if(length1 <= longEndPolishing) {
					polishingQty += wall;
				} else {
					polishingLongQty += wall;
				}
				if(length1 <= longEndPolishing) {
					polishingQty += 1;
				} else {
					polishingLongQty += 1;
				}
			} else if(benchtopShape == 'L-Shaped') {
				if(depth1 <= longEndPolishing) {
					polishingQty = left;
				} else {
					polishingLongQty = left;
				}
				if(depth2 <= longEndPolishing) {
					polishingQty += right;
				} else {
					polishingLongQty += right;
				}
				if(length1 <= longEndPolishing) {
					polishingQty += wall;
				} else {
					polishingLongQty += wall;
				}
				if(length1 <= longEndPolishing) {
					polishingQty += 1;
				} else {
					polishingLongQty += 1;
				}
				if(length2 <= longEndPolishing) {
					polishingQty += 1;
				} else {
					polishingLongQty += 1;
				}
			} else if(benchtopShape == 'U-Shaped') {
				if(depth1 <= longEndPolishing) {
					polishingQty = left;
				} else {
					polishingLongQty = left;
				}
				if(depth3 <= longEndPolishing) {
					polishingQty += right;
				} else {
					polishingLongQty += right;
				}
				if(length1 <= longEndPolishing) {
					polishingQty += wall;
				} else {
					polishingLongQty += wall;
				}
				if(length1 <= longEndPolishing) {
					polishingQty += 1;
				} else {
					polishingLongQty += 1;
				}
				if(length2 <= longEndPolishing) {
					polishingQty += 1;
				} else {
					polishingLongQty += 1;
				}
				if(length3 <= longEndPolishing) {
					polishingQty += 1;
				} else {
					polishingLongQty += 1;
				}
			}
			waterfallQty = leftWF + rightWF;

			// Waterfall ends incur a short polishing charge on top of the waterfall
			// service / material — the cut still needs to be polished where the
			// waterfall meets the benchtop. Always counted as standard (short)
			// polishing regardless of depth.
			polishingQty += leftWF + rightWF;

			// Prices only apply if the products have been loaded
			var polishingTotal = 0,
				waterfallTotal = 0;
			if(polishingProduct && polishingPrice != null) {
				polishingTotal += polishingPrice * polishingQty;
			}
			if(polishingProduct && polishingLongPrice != null) {
				polishingTotal += polishingLongPrice * polishingLongQty;
			}
			// Guard on the prices themselves, not on waterfallProduct: goToNextStep() nulls
			// waterfallProduct when navigating back to step <=3 but does not reset
			// waterfallStandardPrice / waterfallLargePrice. The cart-add path uses the
			// Standard/Large IDs directly, so guarding the review on waterfallProduct
			// silently drops the fab/install fee from the Step 9 total while the cart
			// still charges it (CAB-425 comment 450410).
			if(leftWaterfall) {
				var leftWfWidth = depth1;
				var leftWfPrice = (leftWfWidth <= 600 ? waterfallStandardPrice : waterfallLargePrice);
				if(leftWfPrice != null) waterfallTotal += leftWfPrice;
			}
			if(rightWaterfall) {
				var rightWfWidth = benchtopShape == 'Straight' ? depth1 : (benchtopShape == 'L-Shaped' ? depth2 : depth3);
				var rightWfPrice = (rightWfWidth <= 600 ? waterfallStandardPrice : waterfallLargePrice);
				if(rightWfPrice != null) waterfallTotal += rightWfPrice;
			}

			// Update final price accumulators
			// Note: finalPrice is computed in updatePrice; here we only add to an accumulator
			stonePolishingPrice = polishingTotal + waterfallTotal;
			updatePrice();
		}
	}


	// Populate stone colors by tier on step 7
	function populateStoneColorsByTier() {
		const $starterContainer = $benchtopPlanner.find('.step-7 .starter-colors-container');
		const $premiumContainer = $benchtopPlanner.find('.step-7 .premium-colors-container');
		const $professionalContainer = $benchtopPlanner.find('.step-7 .professional-colors-container');
		
		// Clear existing colors
		$starterContainer.empty();
		$premiumContainer.empty();
		$professionalContainer.empty();
		
		// Populate starter colors
		starterColors.forEach(color => {
			const $colorOption = createColorOption(color, 'starter');
			$starterContainer.append($colorOption);
		});
		
		// Populate premium colors
		premiumColors.forEach(color => {
			const $colorOption = createColorOption(color, 'premium');
			$premiumContainer.append($colorOption);
		});
		
		// Populate professional colors
		professionalColors.forEach(color => {
			const $colorOption = createColorOption(color, 'professional');
			$professionalContainer.append($colorOption);
		});
		
		// Add click handlers for all stone colors
		$benchtopPlanner.find('.step-7 .stone-color-option').on('click', function() {
			const $this = $(this);
			const colorName = $this.data('color-name');
			const colorTierValue = $this.data('color-tier');
			
			// Update selection state - remove selected from all tiers
			$benchtopPlanner.find('.step-7 .stone-color-option').removeClass('selected');
			$this.addClass('selected');
			
			// Store selected color and tier
			colour = colorName;
			colorTier = colorTierValue;
			
			console.log('Stone color selected:', colour, 'Tier:', colorTier);
			
			// Recalculate pricing based on selected tier
			updatePrice();
		});

		// Set selected class for saved colour
		if(colour) {
			$benchtopPlanner.find('.step-7 .stone-color-option').each(function() {
				const $option = $(this);
				if($option.data('color-name') === colour) {
					$option.addClass('selected');
				}
			});
		}
		
		console.log('All tier colors populated');
	}

	// Helper function to create color option HTML
	function createColorOption(color, tier) {
		return $(`
			<div class="grid__item large--one-third medium--one-half stone-color-option" 
				 data-color-id="${color.id}" 
				 data-color-handle="${color.handle}" 
				 data-color-name="${color.name}"
				 data-color-tier="${tier}">
				<div class="choice">
					<div class="grid__image">
						${color.imageUrl ? `<img src="${color.imageUrl}" alt="${color.name}" loading="lazy">` : '<img src="/assets/no-image-large.png" alt="No image">'}
					</div>
					<h3>${color.name}</h3>
				</div>
			</div>
		`);
	}
	
	// Toggle between laminate and stone colors on step 7
	function toggleStep7Colors() {
		const $laminateColors = $benchtopPlanner.find('.step-7 .laminate-colors');
		const $stoneColors = $benchtopPlanner.find('.step-7 .stone-colors');
		
		if(benchMaterial === 'Laminate') {
			$laminateColors.show();
			$stoneColors.hide();
		} else {
			$laminateColors.hide();
			$stoneColors.show();
			
			// Populate tier colors if not already done
			if(!materialColorsLoaded && (starterColors.length === 0 && premiumColors.length === 0 && professionalColors.length === 0)) {
				fetchAllTierColors();
			} else if(starterColors.length > 0 || premiumColors.length > 0 || professionalColors.length > 0) {
				populateStoneColorsByTier();
			}
		}
	}

	// Update waterfall preview images on the polishing step
	function updateWaterfallImages(){
		const toggleWaterfallImages = ($element) => {
			if($element.length && $element.hasClass('shown')){
				$element.find('img').removeClass('shown');
				$element.removeClass('wf-l wf-r wf-lr');
				if(leftWaterfall && rightWaterfall){
					$element.find('img.wf-lr').addClass('shown');
					$element.addClass('wf-lr');
				}else if(leftWaterfall){
					$element.find('img.wf-l').addClass('shown');
					$element.addClass('wf-l');
				}else if(rightWaterfall){
					$element.find('img.wf-r').addClass('shown');
					$element.addClass('wf-r');
				}else{
					$element.find('img.no-wf').addClass('shown');
				}			
			}
		}
		var $step5 = $benchtopPlanner.find('.step-5');
		// Straight
		var $straight = $step5.find('.material-stone .if-straight');
		toggleWaterfallImages($straight);
			
		// Straight with breakfast bar
		var $straightBB = $step5.find('.material-stone .if-straight-bb');
		toggleWaterfallImages($straightBB);

		var $step6 = $benchtopPlanner.find('.step-6');
		// Straight
		var $straightCutouts = $step6.find('.if-cut-outs .if-straight');
		toggleWaterfallImages($straightCutouts);

		var $straightCutoutsBB = $step6.find('.if-cut-outs .if-straight-bb');
		toggleWaterfallImages($straightCutoutsBB);

		const $lshape = $step5.find('.material-stone .if-l');
		toggleWaterfallImages($lshape);

		const $lshapeBBL = $step5.find('.material-stone .if-l-bb-l');
		toggleWaterfallImages($lshapeBBL);

		const $lshapeBBR = $step5.find('.material-stone .if-l-bb-r');
		toggleWaterfallImages($lshapeBBR);

		const $lshapeCutouts = $step6.find('.if-cut-outs .if-l');
		toggleWaterfallImages($lshapeCutouts);

		const $lshapeCutoutsBBL = $step6.find('.if-cut-outs .if-l-bb-l');
		toggleWaterfallImages($lshapeCutoutsBBL);

		const $lshapeCutoutsBBR = $step6.find('.if-cut-outs .if-l-bb-r');
		toggleWaterfallImages($lshapeCutoutsBBR);

		const $ushape = $step5.find('.material-stone .if-u');
		toggleWaterfallImages($ushape);

		const $ushapeBBL = $step5.find('.material-stone .if-u-bb-l');
		toggleWaterfallImages($ushapeBBL);

		const $ushapeBBR = $step5.find('.material-stone .if-u-bb-r');
		toggleWaterfallImages($ushapeBBR);

		const $ushapeCutouts = $step6.find('.if-cut-outs .if-u');
		toggleWaterfallImages($ushapeCutouts);

		const $ushapeCutoutsBBL = $step6.find('.if-cut-outs .if-u-bb-l');
		toggleWaterfallImages($ushapeCutoutsBBL);

		const $ushapeCutoutsBBR = $step6.find('.if-cut-outs .if-u-bb-r');
		toggleWaterfallImages($ushapeCutoutsBBR);
	}

	function calculateInstallationPrice(){
		installationFeePrice = 0;
		installationTravelPrice = 0;
		// Always include the install fee + travel in the planner total when the
		// customer ticks "Yes" for installation, so Step 9 reflects the full
		// cost of THIS benchtop. The "one installation fee per cart" rule
		// (CAB-425 comment 450820) is enforced separately at cart-add time by
		// dedupeInstallationFeesFromQueue, which drops the fee variants from
		// the queue if the cart already has them.
		if(benchMaterial != 'Laminate' && needInstallation){
			// Base fee: with joints if joinQty > 0
			var hasJoints = (joinQty > 0);
			if(installFeeProduct){
				installationFeePrice = hasJoints && installFeePriceWithJoints != null ? installFeePriceWithJoints : (installFeePriceNoJoints || 0);
			}
			// Travel fee: from window.benchtopTravellingFees config (JSON object with postcode as key, cost as value)
			if(typeof window !== 'undefined' && window.benchtopTravellingFees && typeof window.benchtopTravellingFees === 'object' && installPostcode){
				var postcodeInt = parseInt(installPostcode, 10);
				var travelFees = window.benchtopTravellingFees;

				if(!isNaN(postcodeInt)){
					// Find matching postcode by comparing as integers
					var foundKey = Object.keys(travelFees).find(function(key){
						return parseInt(key, 10) === postcodeInt;
					});

					if(foundKey){
						installationTravelPrice = travelFees[foundKey] * 1.15 || 0;
					}else{
						// No matching postcode found - validation should have caught this
						installationTravelPrice = 0;
					}
				}
			}
		}
		installationPrice = installationFeePrice + installationTravelPrice * 100;
		updatePrice();
	}

	// Load join product
	function loadJoin(update) {
		Shopify.getProduct('benchtop-join', function(product) {
			joinProduct = product;
			joinID = product.variants[0].id;
			joinPrice = product.variants[0].price;
			if(update) {
				updatePrice();
			}
		});
		Shopify.getProduct('benchtop-glue-as-part-of-join-kit', function(product) {
			glueProduct = product;
			glueID = product.variants[0].id;
			gluePrice = product.variants[0].price;
			if(update) {
				updatePrice();
			}
		});
	}

	// Lazy load images
	function loadImages() {
		// Only load images for the relevant shape
		if(benchtopShape == 'Straight') {
			$benchtopPlanner.find('.if-straight img.delay-load, .if-straight-bb img.delay-load').each(function() {
				doImageLoad($(this));
			});

		} else if(benchtopShape == 'L-Shaped') {
			$benchtopPlanner.find('.if-l img.delay-load, .if-l-bb-l img.delay-load, .if-l-bb-r img.delay-load, .if-l-join-l-forced img.delay-load, .if-l-join-r-forced img.delay-load').each(function() {
				doImageLoad($(this));
			});

		} else if(benchtopShape == 'U-Shaped') {
			$benchtopPlanner.find('.if-u img.delay-load, .if-u-bb-l img.delay-load, .if-u-bb-r img.delay-load').each(function() {
				doImageLoad($(this));
			});
		}

		$('.wall-finishing-label').append(` (${$('#wall-finishing').closest('.step-4').find('>div.shown div.shown').find('div:contains("Wall")').length})`);

	}

	function doImageLoad($image) {
		// Load images
		$image.attr('srcset', $image.data('srcset')).attr('src', $image.data('src')).removeClass('delay-load');
	}

	function getPrice() {
		var handle1 = 'custom-benchtop-',
		handle1A = 'custom-benchtop-',
		handle2 = 'custom-benchtop-',
		handle2A = 'custom-benchtop-',
		handle3 = 'custom-benchtop-',
		handle3A = 'custom-benchtop-';

		if(depth1 > 600) {
			handle1 += 'w-';
			handle1A += 'w-';
		}

		if(depth2 > 600) {
			handle2 += 'w-';
			handle2A += 'w-';
		}

		if(depth3 > 600) {
			handle3 += 'w-';
			handle3A += 'w-';
		}

		handle1 += Math.floor(length1Final/100) * 100;
		handle2 += Math.floor(length2Final/100) * 100;
		handle3 += Math.floor(length3Final/100) * 100;

		if(length1AFinal) {
			handle1A += Math.floor(length1AFinal/100) * 100;
		}

		if(length2AFinal) {
			handle2A += Math.floor(length2AFinal/100) * 100;
		}

		if(length3AFinal) {
			handle3A += Math.floor(length3AFinal/100) * 100;
		}

		// Check if handle is cached
		if(handle1 in measurementsCache) {
			formatPrice1(measurementsCache[handle1]);

		// Handle not cached, look up via AJAX
		} else {
			Shopify.getProduct(handle1, function(product) {
				measurementsCache[handle1] = product;
				formatPrice1(product);
			});
		}

		if(length1AFinal) {
			// Check if handle is cached
			if(handle1A in measurementsCache) {
				formatPrice1(measurementsCache[handle1A], true);

			// Handle not cached, look up via AJAX
			} else {
				Shopify.getProduct(handle1A, function(product) {
					measurementsCache[handle1A] = product;
					formatPrice1(product, true);
				});
			}
		}

		if(benchtopShape == 'L-Shaped' && length2Final && depth2) {
			// Check if handle is cached
			if(handle2 in measurementsCache) {
				formatPrice2(measurementsCache[handle2]);

			// Handle not cached, look up via AJAX
			} else {
				Shopify.getProduct(handle2, function(product) {
					measurementsCache[handle2] = product;
					formatPrice2(product);
				});
			}

			if(length2AFinal) {
				// Check if handle is cached
				if(handle2A in measurementsCache) {
					formatPrice2(measurementsCache[handle2A], true);

				// Handle not cached, look up via AJAX
				} else {
					Shopify.getProduct(handle2A, function(product) {
						measurementsCache[handle2A] = product;
						formatPrice2(product, true);
					});
				}
			}
		}

		if(benchtopShape == 'U-Shaped' && length2Final && depth2 && length3Final && depth3) {
			// Check if handle is cached
			if(handle2 in measurementsCache) {
				formatPrice2(measurementsCache[handle2]);

			// Handle not cached, look up via AJAX
			} else {
				Shopify.getProduct(handle2, function(product) {
					measurementsCache[handle2] = product;
					formatPrice2(product);
				});
			}

			if(length2AFinal) {
				// Check if handle is cached
				if(handle2A in measurementsCache) {
					formatPrice2(measurementsCache[handle2A], true);

				// Handle not cached, look up via AJAX
				} else {
					Shopify.getProduct(handle2A, function(product) {
						measurementsCache[handle2A] = product;
						formatPrice2(product, true);
					});
				}
			}

			// Check if handle is cached
			if(handle3 in measurementsCache) {
				formatPrice3(measurementsCache[handle3]);

			// Handle not cached, look up via AJAX
			} else {
				Shopify.getProduct(handle3, function(product) {
					measurementsCache[handle3] = product;
					formatPrice3(product);
				});
			}

			if(length3AFinal) {
				// Check if handle is cached
				if(handle3A in measurementsCache) {
					formatPrice3(measurementsCache[handle3A], true);

				// Handle not cached, look up via AJAX
				} else {
					Shopify.getProduct(handle3A, function(product) {
						measurementsCache[handle3A] = product;
						formatPrice3(product, true);
					});
				}
			}
		}

		// Stone pricing never comes from the laminate piece products above —
		// formatPrice() returns early for non-Laminate, so those lookups can't
		// refresh stone totals when measurements change after the material
		// step. Recompute the material (size → tier price) and the polishing
		// charges (standard vs long depends on the new lengths) here instead.
		if(benchMaterial != 'Laminate') {
			calculateSize();
			if(stepProgress > 3) {
				calculatePolishingPrice();
			}
		}
	}

	function formatPrice() {
		var allPiecesFound = false;
		if(benchMaterial != 'Laminate') {
			return;
		}
		if(benchtopShape == 'Straight') {
			if(length1AFinal) {
				if(benchtop1Price && benchtop1APrice) {
					benchtopsPrice = benchtop1Price + benchtop1APrice;
					allPiecesFound = true;

					// Show join step
					$progress.find('.if-join').addClass('shown');
					$step5Next.attr('href', '#step-6');
				}

			} else {
				benchtopsPrice = benchtop1Price;
				allPiecesFound = true;
				
				// Hide join step
				$progress.find('.if-join').removeClass('shown');
				if(benchMaterial == 'Laminate') {					
					$step5Next.attr('href', '#step-7');
				} else {

					$step5Next.attr('href', '#step-6');
				}
			}

		} else if(benchtopShape == 'L-Shaped') {
			if(length1AFinal && length2AFinal) {
				// Other prices found already
				if(benchtop1Price && benchtop1APrice && benchtop2Price && benchtop2APrice) {
					benchtopsPrice = benchtop1Price + benchtop1APrice + benchtop2Price + benchtop2APrice;
					allPiecesFound = true;
				}
			} else if(length1AFinal) {
				// Other prices found already
				if(benchtop1Price && benchtop1APrice && benchtop2Price) {
					benchtopsPrice = benchtop1Price + benchtop1APrice + benchtop2Price;
					allPiecesFound = true;
				}
			} else if(length2AFinal) {
				// Other prices found already
				if(benchtop1Price && benchtop2Price && benchtop2APrice) { 
					benchtopsPrice = benchtop1Price + benchtop2Price + benchtop2APrice;
					allPiecesFound = true;
				}
			} else {
				// Other price found already
				if(benchtop1Price && benchtop2Price) { 
					benchtopsPrice = benchtop1Price + benchtop2Price;
					allPiecesFound = true;
				}
			}

		} else if(benchtopShape == 'U-Shaped') {
			if(length1AFinal && length2AFinal && length3AFinal) {
				// Other prices found already
				if(benchtop1Price && benchtop1APrice && benchtop2Price && benchtop2APrice && benchtop3Price && benchtop3APrice) {
					benchtopsPrice = benchtop1Price + benchtop1APrice + benchtop2Price + benchtop2APrice + benchtop3Price + benchtop3APrice;
					allPiecesFound = true;
				}
			} else if(length1AFinal && length2AFinal) {
				// Other prices found already
				if(benchtop1Price && benchtop1APrice && benchtop2Price && benchtop2APrice && benchtop3Price) {
					benchtopsPrice = benchtop1Price + benchtop1APrice + benchtop2Price + benchtop2APrice + benchtop3Price;
					allPiecesFound = true;
				}
			} else if(length1AFinal && length3AFinal) {
				// Other prices found already
				if(benchtop1Price && benchtop1APrice && benchtop2Price && benchtop3Price && benchtop3APrice) {
					benchtopsPrice = benchtop1Price + benchtop1APrice + benchtop2Price + benchtop3Price + benchtop3APrice;
					allPiecesFound = true;
				}
			} else if(length2AFinal && length3AFinal) {
				// Other prices found already
				if(benchtop1Price && benchtop2Price && benchtop2APrice && benchtop3Price && benchtop3APrice) {
					benchtopsPrice = benchtop1Price + benchtop2Price + benchtop2APrice + benchtop3Price + benchtop3APrice;
					allPiecesFound = true;
				}
			} else if(length1AFinal) {
				// Other prices found already
				if(benchtop1Price && benchtop1APrice && benchtop2Price && benchtop3Price) {
					benchtopsPrice = benchtop1Price + benchtop1APrice + benchtop2Price + benchtop3Price;
					allPiecesFound = true;
				}
			} else if(length2AFinal) {
				// Other prices found already
				if(benchtop1Price && benchtop2Price && benchtop2APrice && benchtop3Price) {
					benchtopsPrice = benchtop1Price + benchtop2Price + benchtop2APrice + benchtop3Price;
					allPiecesFound = true;
				}
			} else if(length3AFinal) {
				// Other prices found already
				if(benchtop1Price && benchtop2Price && benchtop3Price && benchtop3APrice) {
					benchtopsPrice = benchtop1Price + benchtop2Price + benchtop3Price + benchtop3APrice;
					allPiecesFound = true;
				}
			} else {
				// Other prices found already
				if(benchtop1Price && benchtop2Price && benchtop3Price) {
					benchtopsPrice = benchtop1Price + benchtop2Price + benchtop3Price;
					allPiecesFound = true;
				}
			}
		}

		if(allPiecesFound) {
			// If end finishings have been chosen already, recalculate (because the price is different depending on the depth)
			if(stepProgress > 3 && (endFinishingQty > 0 || endFinishingLongQty > 0)) {
				calculateEndFinishingPrice();
			} else {
				// (Stone never reaches this block — see the early return above.
				// Its measurement-change recalc lives at the end of getPrice.)
				updatePrice();
			}
		}
	}

	function formatPrice1(product, isSecond) {
		var isSecond = (typeof isSecond === 'undefined') ? false : isSecond,
		variantLength,
		variantPos,
		variant;

		if(isSecond) {
			variantLength = length1AFinal;
		} else {
			variantLength = length1Final;
		}
		variantPos = variantLength % 100;

		if(variantPos <= product.variants.length) {
			variant = product.variants[variantPos];
			
			// If the title is correct (no reason why it shouldn't be)
			if(variant.title == variantLength + 'mm') {
				if(isSecond) {
					benchtop1AID = variant.id;
					benchtop1APrice = variant.price;
				} else {
					benchtop1ID = variant.id;
					benchtop1Price = variant.price;
				}

				formatPrice();
			}
		}
	}

	function formatPrice2(product, isSecond) {
		var isSecond = (typeof isSecond === 'undefined') ? false : isSecond,
		variantLength,
		variantPos,
		variant;

		if(isSecond) {
			variantLength = length2AFinal;
		} else {
			variantLength = length2Final;
		}
		variantPos = variantLength % 100;

		if(variantPos <= product.variants.length) {
			variant = product.variants[variantPos];
			
			// If the title is correct (no reason why it shouldn't be)
			if(variant.title == variantLength + 'mm') {
				if(isSecond) {
					benchtop2AID = variant.id;
					benchtop2APrice = variant.price;
				} else {
					benchtop2ID = variant.id;
					benchtop2Price = variant.price;
				}

				formatPrice();
			}
		}
	}

	function formatPrice3(product, isSecond) {
		var isSecond = (typeof isSecond === 'undefined') ? false : isSecond,
		variantLength,
		variantPos,
		variant;

		if(isSecond) {
			variantLength = length3AFinal;
		} else {
			variantLength = length3Final;
		}
		variantPos = variantLength % 100;

		if(variantPos <= product.variants.length) {
			variant = product.variants[variantPos];
			
			// If the title is correct (no reason why it shouldn't be)
			if(variant.title == variantLength + 'mm') {
				if(isSecond) {
					benchtop3AID = variant.id;
					benchtop3APrice = variant.price;
				} else {
					benchtop3ID = variant.id;
					benchtop3Price = variant.price;
				}

				formatPrice();
			}
		}
	}
	function calculateEndFinishingPrice() {
		var left = 0,
		right = 0,
		wall = 0;


		// Check end finishing price etc has been loaded
		if(endFinishingProduct) {
			endFinishingQty = 0;
			endFinishingLongQty = 0;

			if(leftFinished && rightFinished) {
				left = 1;
				right = 1;
			} else if(leftFinished) {
				left = 1;
			} else if(rightFinished) {
				right = 1;
			}


			if(wallFinished){
				//wall =  $('.step-4').find('>div.shown div.shown').find('div:contains("Wall")').length; //$('#wall-finishing').closest('.step-4').find('>div.shown div.shown').find('div:contains("Wall")').length;
				//console.log(wall);
			}

			if(wallStraightFinishingBack) {
				wall += 1;
			}
			if(wallLFinishingBackLeft){
				wall += 1;
			}
			if(wallLFinishingBackRight){
				wall += 1;
			}
			if(wallLFinishingBackRightBB){
				wall += 1;
			}
			if(wallLFinishingBackLeftBB){
				wall += 1;
			}
			if(wallUFinishingBackLeft){
				wall += 1;
			}
			if(wallUFinishingBackCentre){
				wall += 1;
			}
			if(wallUFinishingBackRight){
				wall += 1;
			}
			if(wallUFinishingBackCentreBBOnLeft){
				wall += 1;
			}
			if(wallUFinishingBackRightBB){
				wall += 1;
			}
			if(wallUFinishingBackLeftBB){
				wall += 1;
			}
			if(wallUFinishingBackCentreBBRJoin){
				wall += 1;
			}


			if(benchtopShape == 'Straight') {
				if(depth1 < longEndFinishing) {
					endFinishingsPrice = endFinishingPrice * (left + right);
					endFinishingQty = (left + right);
				} else {
					endFinishingsPrice = endFinishingLongPrice * (left + right);
					endFinishingLongQty = (left + right);
				}

				if(length1 < longEndFinishing){
					endFinishingsPrice += endFinishingPrice * wall;
					endFinishingQty += wall;
				} else {
					endFinishingsPrice += endFinishingLongPrice * wall;
					endFinishingLongQty += wall;
				}

			} else if(benchtopShape == 'L-Shaped') {
				if(depth1 < longEndFinishing) {
					endFinishingsPrice = endFinishingPrice * left;
					endFinishingQty = left;
				} else {
					endFinishingsPrice = endFinishingLongPrice * left;
					endFinishingLongQty = left;
				}

				if(depth2 < longEndFinishing) {
					endFinishingsPrice += endFinishingPrice * right;
					endFinishingQty += right;
				} else {
					endFinishingsPrice += endFinishingLongPrice * right;
					endFinishingLongQty += right;
				}

				if(length1 < longEndFinishing){
					endFinishingsPrice += endFinishingPrice * wall;
					endFinishingQty += wall;
				} else {
					endFinishingsPrice += endFinishingLongPrice * wall;
					endFinishingLongQty += wall;
				}

			} else if(benchtopShape == 'U-Shaped') {
				if(depth1 < longEndFinishing) {
					endFinishingsPrice = endFinishingPrice * left;
					endFinishingQty = left;
				} else {
					endFinishingsPrice = endFinishingLongPrice * left;
					endFinishingLongQty = left;
				}

				if(depth3 < longEndFinishing) {
					endFinishingsPrice += endFinishingPrice * right;
					endFinishingQty += right;
				} else {
					endFinishingsPrice += endFinishingLongPrice * right;
					endFinishingLongQty += right;
				}

				if(length1 < longEndFinishing){
					endFinishingsPrice += endFinishingPrice * wall;
					endFinishingQty += wall;
				} else {
					endFinishingsPrice += endFinishingLongPrice * wall;
					endFinishingLongQty += wall;
				}
			}

			updatePrice();
		} else {
			loadEndFinishing(true);
		}
	}

	function updatePrice() {
		if(benchMaterial == 'Laminate') {
			finalPrice = benchtopsPrice + endFinishingsPrice + installationPrice;
			// Reset count
			joinQty = 0;
			glueQty = 0;
			benchtopPieces = 0;

			// Count joins
			if(benchtopShape == 'L-Shaped') {
				joinQty = 3;
				glueQty = 1;
			} else if(benchtopShape == 'U-Shaped') {
				joinQty = 6;
				glueQty = 1;
			}

			if(length1Final) {
				benchtopPieces = benchtopPieces + 1;
			}

			if(length1AFinal) {
				joinQty = joinQty + 3;
				glueQty = glueQty + 1;
				benchtopPieces = benchtopPieces + 1;
			}

			if(length2Final) {
				benchtopPieces = benchtopPieces + 1;
			}

			if(length2AFinal) {
				joinQty = joinQty + 3;
				glueQty = glueQty + 1;
				benchtopPieces = benchtopPieces + 1;
			}

			if(length3Final) {
				benchtopPieces = benchtopPieces + 1;
			}

			if(length3AFinal) {
				joinQty = joinQty + 3;
				glueQty = glueQty + 1;
				benchtopPieces = benchtopPieces + 1;
			}

			// Show individual pieces on last page
			if(stepProgress >= 6) {
				// Show pieces section
				if(length1AFinal || length2AFinal || length3AFinal) {
					$benchtopPieces.addClass('shown');

					var benchtopPiecesText = '',
					benchtopJoinNote = ' <span class="cart__note no-wrap">(includes extra 20mm for join)</span>',
					benchtopJoin2Note = ' <span class="cart__note no-wrap">(includes extra 40mm for joins)</span>';


					if(length1AFinal) {
						benchtopPiecesText += '<span class="piece">';
						if(benchtopShape == 'Straight') {
							benchtopPiecesText += 'Left';
						} else {
							benchtopPiecesText += 'Left 1';
						}
						benchtopPiecesText += ' &ndash; ' + length1Final + 'mm</span>';

						benchtopPiecesText += '<span class="piece">';
						if(benchtopShape == 'Straight') {
							benchtopPiecesText += 'Right';
						} else {
							benchtopPiecesText += 'Left 2';
						}
						benchtopPiecesText += ' &ndash; ' + length1AFinal + 'mm';

					} else if(length1Final) {
						benchtopPiecesText += '<span class="piece">Left &ndash; ' + length1Final + 'mm';
					}

					if((benchtopShape == 'L-Shaped' && joinType == 'Left') || (benchtopShape == 'U-Shaped' && joinType == 'LeftRight') || (benchtopShape == 'U-Shaped' && joinType == 'Left')) {
						benchtopPiecesText += benchtopJoinNote;
					}

					benchtopPiecesText += '</span>';


					if(length2AFinal) {
						benchtopPiecesText += '<span class="piece">';
						if(benchtopShape == 'L-Shaped') {
							benchtopPiecesText += 'Right 1';
						} else if(benchtopShape == 'U-Shaped') {
							benchtopPiecesText += 'Centre 1';
						}
						benchtopPiecesText += ' &ndash; ' + length2Final + 'mm';
						if((benchtopShape == 'L-Shaped' && joinType == 'Right') || (benchtopShape == 'U-Shaped' && joinType == 'RightLeft') || (benchtopShape == 'U-Shaped' && joinType == 'Right')) {
							benchtopPiecesText += benchtopJoinNote;
						}
						benchtopPiecesText += '</span>';

						benchtopPiecesText += '<span class="piece">';
						if(benchtopShape == 'L-Shaped') {
							benchtopPiecesText += 'Right 2';
						} else if(benchtopShape == 'U-Shaped') {
							benchtopPiecesText += 'Centre 2';
						}
						benchtopPiecesText += ' &ndash; ' + length2AFinal + 'mm';
						if(benchtopShape == 'U-Shaped' && joinType == 'RightLeft') {
							benchtopPiecesText += benchtopJoinNote;
						}

					} else if(length2Final) {
						benchtopPiecesText += '<span class="piece">';
						if(benchtopShape == 'L-Shaped') {
							benchtopPiecesText += 'Right';
						} else if(benchtopShape == 'U-Shaped') {
							benchtopPiecesText += 'Centre';
						}
						benchtopPiecesText += ' &ndash; ' + length2Final + 'mm';

						if((benchtopShape == 'L-Shaped' && joinType == 'Right') || (benchtopShape == 'U-Shaped' && joinType == 'Right')) {
							benchtopPiecesText += benchtopJoinNote;
						} else if(benchtopShape == 'U-Shaped' && joinType == 'RightLeft') {
							benchtopPiecesText += benchtopJoin2Note;
						}
					}

					if(benchtopShape == 'U-Shaped' && joinType == 'Left') {
						benchtopPiecesText += benchtopJoinNote;
					}

					benchtopPiecesText += '</span>';


					if(length3AFinal) {
						benchtopPiecesText += '<span class="piece">Right 1 &ndash; ' + length3Final + 'mm';
						if((benchtopShape == 'U-Shaped' && joinType == 'LeftRight') || (benchtopShape == 'U-Shaped' && joinType == 'Right')) {
							benchtopPiecesText += benchtopJoinNote;
						}
						benchtopPiecesText += '</span>';
						benchtopPiecesText += '<span class="piece">Right 2 &ndash; ' + length3AFinal + 'mm';
					} else if(length3Final) {
						benchtopPiecesText += '<span class="piece">Right &ndash; ' + length3Final + 'mm';
						if((benchtopShape == 'U-Shaped' && joinType == 'LeftRight') || (benchtopShape == 'U-Shaped' && joinType == 'Right')) {
							benchtopPiecesText += benchtopJoinNote;
						}
					}

					benchtopPiecesText += '</span>';


					$benchtopPieces.find('p').html(benchtopPiecesText);

				// Hide pieces section
				} else {
					$benchtopPieces.removeClass('shown');
				}
			}

			// Add join price
			if(joinQty > 0) {
				// Check join product has been loaded
				if(joinProduct) {
					finalPrice += ((joinPrice * joinQty) + (gluePrice * glueQty));
				} else {
					loadJoin(true);
					return false;
				}
			}

			finalPriceFormatted = Shopify.formatMoney(finalPrice, moneyFormat);
			
			$progress.find('p.price').html(finalPriceFormatted).parent('.price-info').addClass('shown');
			$benchtopPlanner.find('.step-9 p.price').text(finalPriceFormatted);
		} else {
			// For stone, include polishing/waterfall price, cut-outs, installation, and joins using stone join product
			finalPrice = benchtopsPrice + leftWaterfallMaterialPrice + rightWaterfallMaterialPrice + stonePolishingPrice + stoneCutoutsPrice + installationPrice;

			joinQty = 0;
			glueQty = 0;
			benchtopPieces = 0;

			// Count joins
			if(benchtopShape == 'L-Shaped') {
				joinQty = 1;
			} else if(benchtopShape == 'U-Shaped') {
				joinQty = 2;
			}

			if(length1Final) {
				benchtopPieces = benchtopPieces + 1;
			}

			if(length1AFinal) {
				joinQty = joinQty + 1;
				benchtopPieces = benchtopPieces + 1;
			}

			if(length2Final) {
				benchtopPieces = benchtopPieces + 1;
			}

			if(length2AFinal) {
				joinQty = joinQty + 1;
				benchtopPieces = benchtopPieces + 1;
			}

			if(length3Final) {
				benchtopPieces = benchtopPieces + 1;
			}

			if(length3AFinal) {
				joinQty = joinQty + 1;
				benchtopPieces = benchtopPieces + 1;
			}

			if(joinQty > 0) {
				if(stoneJoinProduct) {
					finalPrice += (stoneJoinPrice * joinQty);
				} else {
					loadStoneJoin(true);
					return false;
				}
			}
			finalPriceFormatted = Shopify.formatMoney(finalPrice, moneyFormat);
			
			$progress.find('p.price').html(finalPriceFormatted).parent('.price-info').addClass('shown');
			$benchtopPlanner.find('.step-9 p.price').text(finalPriceFormatted);
			// Update review details			
			updateReviewDetails()
		}

		
	}

	function updateReviewDetails(){
		// Update review details (called when step 9 is shown or when summary-affecting data changes while on step 9)
		$benchtopPlanner.find('.step-9 .review-material').text(benchMaterial);
		
		// Common cutouts summary (applies to all shapes)
		function summarizeCommonCutouts(){
			var parts = [];
			if(sinkTapCutout) {
				var sinkTapDesc = 'Sink / Tap (' + sinkTapMount + ', Qty: ' + sinkTapQty + ')';
				parts.push(sinkTapDesc);
			}
			if(hobCutout) {
				var hobDesc = 'Hob (' + hobMount + ', Qty: ' + hobQty + ')';
				parts.push(hobDesc);
			}
			if(airSwitchCutout) {
				var airSwitchDesc = 'Air Switch / Water Filter (Qty: ' + airSwitchQty + ')';
				parts.push(airSwitchDesc);
			}
			return parts.length ? parts.join(', ') : 'None';
		}
		
		// Update the common cutout summary
		$benchtopPlanner.find('.step-9 .review-cutout-common').text(summarizeCommonCutouts());
		$benchtopPlanner.find('.step-9 .if-stone-only')[benchMaterial == 'Laminate' ? 'removeClass' : 'addClass']('shown');
		$benchtopPlanner.find('.step-9 .if-laminate-only')[benchMaterial == 'Laminate' ? 'addClass' : 'removeClass']('shown');				

		// Update polishing summary for stone materials
		if(benchMaterial != 'Laminate') {
			var leftPolishText = leftWaterfall ? 'Waterfall' : (leftPolishedTreated ? 'Polished' : 'Unpolished');
			var rightPolishText = rightWaterfall ? 'Waterfall' : (rightPolishedTreated ? 'Polished' : 'Unpolished');
			$benchtopPlanner.find('.step-9 span.end-polishing-left').text(leftPolishText);
			$benchtopPlanner.find('.step-9 span.end-polishing-right').text(rightPolishText);
			
			// Update wall end polishing based on shape. Each shape-specific wall
			// span aggregates the non-BB and BB-variant flags for that position,
			// since the BB radios use different names (e.g.
			// u-polishing-back-centre-bb-on-left → wallUPolishingBackCentreBBOnLeft)
			// and would otherwise leave the review reading "Unpolished" even after
			// the user explicitly picked Polished on a BB layout.
			if(benchtopShape == 'Straight') {
				$benchtopPlanner.find('.step-9 span.end-polishing-wall-straight').text(wallStraightPolishingBack ? 'Polished' : 'Unpolished');
			} else if(benchtopShape == 'L-Shaped') {
				var lWallLeft = wallLPolishingBackLeft || wallLPolishingBackLeftBB;
				var lWallRight = wallLPolishingBackRight || wallLPolishingBackRightBB;
				$benchtopPlanner.find('.step-9 span.end-polishing-wall-l-left').text(lWallLeft ? 'Polished' : 'Unpolished');
				$benchtopPlanner.find('.step-9 span.end-polishing-wall-l-right').text(lWallRight ? 'Polished' : 'Unpolished');
			} else if(benchtopShape == 'U-Shaped') {
				var uWallLeft = wallUPolishingBackLeft || wallUPolishingBackLeftBB;
				var uWallCentre = wallUPolishingBackCentre || wallUPolishingBackCentreBBOnLeft || wallUPolishingBackCentreBBRJoin;
				var uWallRight = wallUPolishingBackRight || wallUPolishingBackRightBB;
				$benchtopPlanner.find('.step-9 span.end-polishing-wall-u-left').text(uWallLeft ? 'Polished' : 'Unpolished');
				$benchtopPlanner.find('.step-9 span.end-polishing-wall-u-centre').text(uWallCentre ? 'Polished' : 'Unpolished');
				$benchtopPlanner.find('.step-9 span.end-polishing-wall-u-right').text(uWallRight ? 'Polished' : 'Unpolished');
			}
		}
		
		// Update color
		$benchtopPlanner.find('.step-9 .review-colour').text(colour || 'Not selected');
		
		$benchtopPlanner.find('.step-9 .review-install-need').text(needInstallation ? 'Yes' : 'No');
		$benchtopPlanner.find('.step-9 .review-install-name').text(installContactName);
		$benchtopPlanner.find('.step-9 .review-install-phone').text(installContactNumber);
		var pc = installPostcode;
		$benchtopPlanner.find('.step-9 .review-install-postcode').text(pc);
		$benchtopPlanner.find('.step-9 .review-install-postcode').closest('p')[pc ? 'removeClass' : 'addClass']('hide-postcode');
	}

	// Tier handles whose prices are calculated client-side from the
	// custom.benchtop_cost + benchtop_planner.markups metafields rather than
	// from per-size variants. The product has only the default variant.
	var TIER_MATERIAL_HANDLES = ['tier-1-product-1', 'tier-2-product-1', 'tier-3-product-1'];

	function tierHandleForColorTier(tier) {
		if(tier == 'premium') return 'tier-2-product-1';
		if(tier == 'professional') return 'tier-3-product-1';
		return 'tier-1-product-1'; // starter / fallback
	}

	function pickMarkup(markups, totalSize) {
		if(!markups || !markups.length) return 0;
		var bracket = markups.find(function(m){
			return totalSize >= m.min && totalSize < m.max;
		});
		return bracket ? bracket.value : 0;
	}

	// size in sqm, cost in dollars/sqm, markup as a fraction (0.8 = +80%).
	// Returns price in cents (consistent with the rest of finalPrice).
	function tierLinePriceCents(size, cost, markup) {
		if(!size || !cost) return 0;
		return Math.round(size * cost * (1 + markup) * 100);
	}

	function getMaterialPrice() {
		const totalSquareM = Math.ceil(totalSquareMM / 1000000 * 100) / 100;
		const leftWfSquareM = leftWaterfallArea > 0 ? Math.ceil(leftWaterfallArea / 1000000 * 100) / 100 : 0;
		const rightWfSquareM = rightWaterfallArea > 0 ? Math.ceil(rightWaterfallArea / 1000000 * 100) / 100 : 0;

		// Reset benchtop + waterfall material prices/ids; they'll be set below
		// once the tier product (and its cost/markups metafields) is available.
		// Old per-size variant suffixes (-1/-2/-3) are gone — all material lines
		// use the single tier handle's default variant.
		waterfallMaterialPrice = 0;
		waterfallMaterialProductID = null;
		leftWaterfallMaterialPrice = 0;
		leftWaterfallMaterialProductID = null;
		rightWaterfallMaterialPrice = 0;
		rightWaterfallMaterialProductID = null;

		if(benchMaterial == 'Laminate') {
			// Laminate flow is unchanged; material price lives elsewhere.
			return;
		}

		const handle = tierHandleForColorTier(colorTier);
		const cached = measurementsCache[handle];
		if(cached && cached.variants && typeof cached.cost !== 'undefined') {
			console.log(`Using cached tier material product: ${handle}`);
			applyTierMaterialPricing(cached, totalSquareM, leftWfSquareM, rightWfSquareM);
		} else {
			console.log(`Fetching tier material product: ${handle}`);
			fetchProductWithMetafields(handle, totalSquareM, leftWfSquareM, rightWfSquareM);
		}
	}

	// Returns the variant id whose Type option matches `typeValue` (Benchtop /
	// Waterfall). Falls back to the first variant if no exact match is found,
	// which keeps the planner usable while a tier product is being migrated to
	// the new Type option.
	function pickTierVariantId(product, typeValue) {
		if(!product || !product.variants || !product.variants.length) return null;
		var wanted = (typeValue || '').toLowerCase();
		var match = product.variants.find(function(v){
			var optValues = (v.selectedOptions || []).map(function(o){
				return [
					(o.name || '').toLowerCase(),
					(o.value || '').toLowerCase()
				];
			});
			var typeOpt = optValues.find(function(pair){ return pair[0] === 'type'; });
			if(typeOpt) return typeOpt[1] === wanted;
			// Fallback: option1 / title.
			if((v.option1 || '').toLowerCase() === wanted) return true;
			return (v.title || '').toLowerCase() === wanted;
		});
		return match ? match.id : product.variants[0].id;
	}

	// Apply size × cost × (1 + markup) pricing per material line. The markup
	// bracket is selected from the SUM of all sizes that share the same tier
	// product handle (main benchtop + left/right waterfalls), so a customer
	// buying more total area gets the lower-markup bracket on every line.
	// The tier-N-product-1 product now has a "Type" option with values
	// "Benchtop" and "Waterfall" — the parent benchtop line uses the Benchtop
	// variant, and the waterfall material lines use the Waterfall variant. That
	// keeps merchandiseId different between parent and waterfall children, so
	// Shopify's bundle / parent-child rules accept them in a single batch.
	function applyTierMaterialPricing(product, mainSize, leftWfSize, rightWfSize) {
		const cost = product.cost;
		const markups = product.markups || [];
		const totalSize = (mainSize || 0) + (leftWfSize || 0) + (rightWfSize || 0);
		const markup = pickMarkup(markups, totalSize);
		const benchtopVariantId = pickTierVariantId(product, 'Benchtop');
		const waterfallVariantId = pickTierVariantId(product, 'Waterfall');

		if(mainSize > 0 && benchtopVariantId) {
			benchtopsPrice = tierLinePriceCents(mainSize, cost, markup);
			materialProductID = benchtopVariantId;
		}

		if(leftWfSize > 0 && waterfallVariantId) {
			leftWaterfallMaterialPrice = tierLinePriceCents(leftWfSize, cost, markup);
			leftWaterfallMaterialProductID = waterfallVariantId;
		}

		if(rightWfSize > 0 && waterfallVariantId) {
			rightWaterfallMaterialPrice = tierLinePriceCents(rightWfSize, cost, markup);
			rightWaterfallMaterialProductID = waterfallVariantId;
		}

		updatePrice();
	}

	function fetchProductWithMetafields(handle, mainSize, leftWfSize, rightWfSize) {
		// Pull the cost (custom.benchtop_cost) and markups (benchtop_planner.markups)
		// metafields alongside the existing benchtop_colours metafield. The first
		// two drive client-side pricing for the tier-N-product-1 family that no
		// longer carries per-size variants.
		const query = `
			query getProduct($handle: String!) {
				product(handle: $handle) {
					id
					title
					handle
					variants(first: 10) {
						edges {
							node {
								id
								title
								price {
									amount
								}
								selectedOptions {
									name
									value
								}
							}
						}
					}
					cost: metafield(namespace: "custom", key: "benchtop_cost") {
						value
						type
					}
					markups: metafield(namespace: "benchtop_planner", key: "markups") {
						value
						type
					}
					colours: metafield(namespace: "custom", key: "benchtop_colours") {
						value
						type
						reference {
							... on Metaobject {
								id
								handle
								type
								fields {
									key
									value
									type
									references(first: 10) {
										edges {
											node {
												... on Metaobject {
													id
													handle
													type
													fields {
														key
														value
														type
														reference {
															... on MediaImage {
																id
																image {
																	url
																	altText
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		`;

		const variables = { handle: handle };

		fetch('/api/2025-10/graphql.json', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'X-Shopify-Storefront-Access-Token': storeFrontApiKey
			},
			body: JSON.stringify({
				query: query,
				variables: variables
			})
		})
		.then(response => response.json())
		.then(data => {
			if(data.data && data.data.product) {
				const graphqlProduct = data.data.product;

				var cost = 0;
				if(graphqlProduct.cost && graphqlProduct.cost.value != null) {
					cost = parseFloat(graphqlProduct.cost.value);
					if(isNaN(cost)) cost = 0;
				}

				var markups = [];
				if(graphqlProduct.markups && graphqlProduct.markups.value) {
					try {
						markups = JSON.parse(graphqlProduct.markups.value);
						if(!Array.isArray(markups)) markups = [];
					} catch(e) {
						console.error('Could not parse benchtop_planner.markups for ' + handle, e);
						markups = [];
					}
				}

				// Convert GraphQL format to Shopify.js format for compatibility.
				// Carry selectedOptions through so pickTierVariantId can match the
				// variant by its Type option (Benchtop / Waterfall).
				const product = {
					id: graphqlProduct.id,
					title: graphqlProduct.title,
					handle: graphqlProduct.handle,
					variants: graphqlProduct.variants.edges.map(edge => {
						const selectedOptions = edge.node.selectedOptions || [];
						const typeOpt = selectedOptions.find(o => (o.name || '').toLowerCase() === 'type');
						return {
							id: edge.node.id,
							title: edge.node.title,
							price: parseFloat(edge.node.price.amount) * 100, // cents (legacy fallback only)
							selectedOptions: selectedOptions,
							option1: typeOpt ? typeOpt.value : (selectedOptions[0] ? selectedOptions[0].value : null)
						};
					}),
					cost: cost,
					markups: markups,
					metafields: {
						custom: {
							benchtop_colours: graphqlProduct.colours
						}
					}
				};

				measurementsCache[handle] = product;
				console.log('Tier material product fetched for pricing (cost=' + cost + ', brackets=' + markups.length + ')');

				applyTierMaterialPricing(product, mainSize, leftWfSize, rightWfSize);
			} else {
				console.error('GraphQL error:', data.errors);
			}
		})
		.catch(error => {
			console.error('Fetch error:', error);
		});
	}

	// Fetch colors from all three tier products
	function fetchAllTierColors(callback) {
		// Check if colors are already loaded
		if(materialColorsLoaded && (starterColors.length > 0 || premiumColors.length > 0 || professionalColors.length > 0)) {
			console.log('Tier colors already loaded, skipping fetch');
			populateStoneColorsByTier();
			if(callback && typeof callback === 'function') {
				callback();
			}
			return;
		}
		
		const tierProducts = [
			{ handle: 'tier-1-product-1', tier: 'starter' },
			{ handle: 'tier-2-product-1', tier: 'premium' },
			{ handle: 'tier-3-product-1', tier: 'professional' }
		];
		
		let completedRequests = 0;
		const totalRequests = tierProducts.length;
		
		// Only reset if not already loaded
		if(!materialColorsLoaded) {
			starterColors = [];
			premiumColors = [];
			professionalColors = [];
		}
		
		tierProducts.forEach(tierProduct => {
			fetchTierProductColors(tierProduct.handle, tierProduct.tier, () => {
				completedRequests++;
				if (completedRequests === totalRequests) {
					// All colors fetched, mark as loaded and populate the UI
					materialColorsLoaded = true;
					populateStoneColorsByTier();
					
					// Execute callback if provided
					if(callback && typeof callback === 'function') {
						callback();
					}
				}
			});
		});
	}

	// Fetch colors from a specific tier product
	function fetchTierProductColors(handle, tier, callback) {
		// Check if this tier product is already cached
		if(measurementsCache[handle] && measurementsCache[handle].tierColors) {
			console.log(`Using cached ${tier} colors for ${handle}`);
			const cachedColors = measurementsCache[handle].tierColors;
			
			// Store colors in the appropriate tier array
			if (tier === 'starter') {
				starterColors = cachedColors;
			} else if (tier === 'premium') {
				premiumColors = cachedColors;
			} else if (tier === 'professional') {
				professionalColors = cachedColors;
			}
			
			callback();
			return;
		}
		const query = `
			query getProduct($handle: String!) {
				product(handle: $handle) {
					id
					handle
					title
					metafield(namespace: "custom", key: "benchtop_colours") {
						type
						value
						reference {
							... on Metaobject {
								id
								handle
								type
								fields {
									key
									value
									references(first: 50) {
										edges {
											node {
												... on Metaobject {
													id
													handle
													type
													fields {
														key
														value
														reference {
															... on MediaImage {
																image {
																	url
																	altText
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		`;

		const variables = { handle: handle };

		fetch(`/api/2024-01/graphql.json`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Shopify-Storefront-Access-Token': storeFrontApiKey,
				'Accept': 'application/json'
			},
			body: JSON.stringify({ query, variables })
		})
		.then(response => response.json())
		.then(data => {
			if (data.data && data.data.product) {
				const graphqlProduct = data.data.product;
				console.log(`Fetching ${tier} colors from ${handle}:`, graphqlProduct);
				
				// Extract colors from metafield
				if (graphqlProduct.metafield && graphqlProduct.metafield.reference) {
					const metaobject = graphqlProduct.metafield.reference;
					const colorsField = metaobject.fields.find(field => field.key === 'colours');
					
					if (colorsField && colorsField.references && colorsField.references.edges) {
						const colors = colorsField.references.edges.map(edge => {
							const colorData = {
								id: edge.node.id,
								handle: edge.node.handle,
								type: edge.node.type,
								name: '',
								imageUrl: '',
								imageAlt: '',
								tier: tier
							};
							
							// Process the fields to extract name and image
							if (edge.node.fields) {
								edge.node.fields.forEach(field => {
									if (field.key === 'name') {
										colorData.name = field.value;
									} else if (field.key === 'image') {
										if (field.reference && field.reference.image && field.reference.image.url) {
											colorData.imageUrl = field.reference.image.url;
											colorData.imageAlt = field.reference.image.altText || colorData.name;
										}
									}
								});
							}
							
							return colorData;
						});
						
						// Store colors in the appropriate tier array
						if (tier === 'starter') {
							starterColors = colors;
						} else if (tier === 'premium') {
							premiumColors = colors;
						} else if (tier === 'professional') {
							professionalColors = colors;
						}
						
						// Cache the colors for future use
						if(!measurementsCache[handle]) {
							measurementsCache[handle] = {};
						}
						measurementsCache[handle].tierColors = colors;
						
						console.log(`${tier} colors loaded and cached:`, colors);
					}
				}
			} else {
				console.error(`GraphQL error for ${handle}:`, data.errors);
			}
			
			callback();
		})
		.catch(error => {
			console.error(`Fetch error for ${handle}:`, error);
			callback();
		});
	}

	function goToNextStep(step) {
		currentStep = step;

		// Update step progress - the only way to move to newer steps is with the next button
		if(currentStep > stepProgress) {
			stepProgress = currentStep;
		}

		// Reset waterfall variables when going back to early steps (1, 2, or 3)
		if(currentStep <= 3) {
			waterfallProduct = null;
			waterfallPrice = null;
			waterfallID = null;
			waterfallQty = 0;
			waterfallArea = 0;
			waterfallMaterialProductID = null;
			waterfallMaterialPrice = 0;
			// Reset separate waterfall variables
			leftWaterfallArea = 0;
			rightWaterfallArea = 0;
			leftWaterfallMaterialProductID = null;
			rightWaterfallMaterialProductID = null;
			leftWaterfallMaterialPrice = 0;
			rightWaterfallMaterialPrice = 0;
		}

		updateProgress();
	}

	function goToNextStepAndValidate(step) {
		if(validateSteps(step - 1)) {
			goToNextStep(step);
			// Trigger the hashchange (this usually happens from the button - since we're skipping the button we have to manually do it)
			location.hash = '#step-' + step;
		}
	}	

	// Full-screen loading overlay shown while a saved plan is being restored.
	// Created lazily on first use so the snippet template doesn't need to ship
	// any extra markup; removed once we land on the review step (step 9).
	function showSavedPlanLoadingOverlay() {
		if(document.querySelector('.benchtop-planner-loading-overlay')) return;

		if(!document.getElementById('benchtop-planner-loading-overlay-style')) {
			var style = document.createElement('style');
			style.id = 'benchtop-planner-loading-overlay-style';
			style.textContent =
				'.benchtop-planner-loading-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.92);z-index:10000;display:flex;flex-direction:column;align-items:center;justify-content:center;font-family:inherit;}' +
				'.benchtop-planner-loading-overlay__spinner{width:56px;height:56px;border:6px solid #e3e3e3;border-top-color:#222;border-radius:50%;animation:bp-loading-spin 0.9s linear infinite;margin-bottom:18px;}' +
				'.benchtop-planner-loading-overlay__text{font-size:16px;color:#222;margin:0;}' +
				'@keyframes bp-loading-spin{to{transform:rotate(360deg);}}';
			document.head.appendChild(style);
		}

		var overlay = document.createElement('div');
		overlay.className = 'benchtop-planner-loading-overlay';
		overlay.setAttribute('role', 'status');
		overlay.setAttribute('aria-live', 'polite');
		overlay.innerHTML =
			'<div class="benchtop-planner-loading-overlay__spinner" aria-hidden="true"></div>' +
			'<p class="benchtop-planner-loading-overlay__text">Loading your saved plan…</p>';
		document.body.appendChild(overlay);
	}

	function hideSavedPlanLoadingOverlay() {
		var overlay = document.querySelector('.benchtop-planner-loading-overlay');
		if(overlay && overlay.parentNode) {
			overlay.parentNode.removeChild(overlay);
		}
		loadingSavedPlan = false;
	}

	function updateProgress() {
		// Scroll to top of page
		window.scrollTo(0, 0);

		// Show/hide steps
		$benchtopPlanner.find('.step-' + currentStep).addClass('shown').siblings().removeClass('shown');

		// Slab thickness shown on the measurement/review diagrams: stone tops
		// are 20mm, laminate tops 30mm. The markup hardcodes 30mm, so correct it
		// for the selected material whenever a step renders.
		$benchtopPlanner.find('.straight-height, .l-height, .u-height')
			.text(benchMaterial == 'Laminate' ? '30mm' : '20mm');

		// Update progress sidebar
		$progress.find('li').removeClass('current').filter(function() {
			return $(this).children('a').attr('href') == '#step-' + currentStep;
		}).addClass('available current').prevAll().addClass('available');

		// Show number of benchtop pieces
		if(currentStep == 6) {
			$benchtopPlanner.find('.step-6 .pieces-count').html(benchtopPieces);
		}

		// Change 'current price' to 'final price'
		if(currentStep == 9) {
			$progress.find('h3.final-price').addClass('shown').siblings('h3.current-price').removeClass('shown');


			//Wall finishing
			// $benchtopPlanner.find('.step-7 span.end-finishing-wall').text(wallFinishedList.join(', '));

			$benchtopPlanner.find('.step-9 span.end-finishing-wall').text(wallFinishedList.length > 0 || breakfastBar ? 'Finished' : 'Unfinished');
			// Polishing wall summary mirrors finishing for stone
			$benchtopPlanner.find('.step-9 span.end-polishing-wall').text(wallPolishedList.length > 0 || breakfastBar ? 'Polished' : 'Unpolished');
			// Toggle laminate vs stone sections
			$benchtopPlanner.find('.step-9 .if-laminate-only')[benchMaterial == 'Laminate' ? 'addClass' : 'removeClass']('shown');
			$benchtopPlanner.find('.step-9 .if-stone-only')[benchMaterial == 'Laminate' ? 'removeClass' : 'addClass']('shown');
			updateReviewDetails();

			// Tear down the saved-plan loading overlay now that the review step
			// is rendered. loadSavedPlan sets loadingSavedPlan + shows the
			// overlay; we wait until step 9 is on screen so the user doesn't
			// see the partially-restored intermediate steps flash by.
			if(loadingSavedPlan) {
				hideSavedPlanLoadingOverlay();
			}

		} else if(stepProgress == 9) {
			$progress.find('h3.final-price').removeClass('shown').siblings('h3.current-price').addClass('shown');
		}

		//Show/hide Open Saved Plan button
		if($benchtopPlanner.find('.step-1').hasClass('shown')){
			$('.open-saved-plan-container').show();
		}
		if(!$benchtopPlanner.find('.step-1').hasClass('shown')){
			$('.open-saved-plan-container').hide();
		}

		//Show/hide Print button
		if($benchtopPlanner.find('.step-9').hasClass('shown')){
			$('a.btn-print').show();
		}
		if(!$benchtopPlanner.find('.step-9').hasClass('shown')){
			$('a.btn-print').hide();
		}
	}

	function updateReviewImage() {
		if(dontReloadReviewImage) {
			dontReloadReviewImage = false;
			return false;
		}

		if(benchMaterial == 'Laminate') {
			$benchtopPlanner.find('.step.step-9').removeClass('material-stone')
		}
		else{
			$benchtopPlanner.find('.step.step-9').addClass('material-stone');
		}

		if(benchMaterial == 'Laminate') {
		// If colour has been chosen
			if(colour) {
				// Build up review image
				reviewImage = 'bp-7';

				if(benchtopShape == 'Straight') {
					reviewImage += '-straight';

					if(breakfastBar) {
						reviewImage += '-bb';
					}

					if(!leftFinished) {
						reviewImage += '-unclashed';
					}

				} else if(benchtopShape == 'L-Shaped') {
					reviewImage += '-l-shape';

					if(breakfastBar) {
						reviewImage += '-bb';

						if(breakfastBarSide == 'Left') {
							reviewImage += '-l';
						} else if(breakfastBarSide == 'Right') {
							reviewImage += '-r';
						}
					}

					if(leftFinished && !rightFinished) {
						reviewImage += '-unclashed-r';
					} else if(!leftFinished && rightFinished) {
						reviewImage += '-unclashed-l';
					} else if(!leftFinished && !rightFinished) {
						reviewImage += '-unclashed';
					}

					if(!breakfastBar) {
						if(joinType == 'Left') {
							reviewImage += '-join-l';
						} else if(joinType == 'Right') {
							reviewImage += '-join-r';
						}
					}

				} else if(benchtopShape == 'U-Shaped') {
					reviewImage += '-u-shape';

					if(breakfastBar) {
						reviewImage += '-bb';

						if(breakfastBarSide == 'Left') {
							reviewImage += '-l';
						} else if(breakfastBarSide == 'Right') {
							reviewImage += '-r';
						}
					}

					if(leftFinished && !rightFinished) {
						reviewImage += '-unclashed-r';
					} else if(!leftFinished && rightFinished) {
						reviewImage += '-unclashed-l';
					} else if(!leftFinished && !rightFinished) {
						reviewImage += '-unclashed';
					}

					if(joinType == 'RightLeft') {
						reviewImage += '-join-rl';
					} else if(joinType == 'LeftRight') {
						reviewImage += '-join-lr';
					} else if(joinType == 'Left') {
						reviewImage += '-join-l';
					} else if(joinType == 'Right') {
						reviewImage += '-join-r';
					}
				}

				reviewImage += '-' + colour.toLowerCase().replace(/ /g,'-');

				reviewImageTag = '<img src="' + finalImageSrc.replace(/bp-7-straight-sonora-black/g, reviewImage) + '" srcset="' + finalImageSrcset.replace(/bp-7-straight-sonora-black/g, reviewImage) + '"';

				if(benchtopShape == 'Straight') {
					reviewImageTag += ' width="' + finalImageWidth + '"';
				} else if(benchtopShape == 'L-Shaped') {
					reviewImageTag += ' width="' + finalImageWidthL + '"';
				} else if(benchtopShape == 'U-Shaped') {
					reviewImageTag += ' width="' + finalImageWidthU + '"';
				}

				reviewImageTag += ' alt="Benchtop Preview">';

				if(benchtopShape == 'Straight') {
					if(!reviewImageDone) {
						reviewImageDone = true;
						$finalImage.prepend(reviewImageTag);
					} else {
						$finalImage.find('img').replaceWith(reviewImageTag);
					}
				} else if(benchtopShape == 'L-Shaped') {
					if(!reviewImageLDone) {
						reviewImageLDone = true;
						$finalImageL.prepend(reviewImageTag);
					} else {
						$finalImageL.find('img').replaceWith(reviewImageTag);
					}
				} else if(benchtopShape == 'U-Shaped') {
					if(!reviewImageUDone) {
						reviewImageUDone = true;
						$finalImageU.prepend(reviewImageTag);
					} else {
						$finalImageU.find('img').replaceWith(reviewImageTag);
					}
				}
			}
		}
		else{
			reviewImage = 'sbp';

			if(benchtopShape == 'Straight') {
				reviewImage += '-straight';

				if(breakfastBar) {
					reviewImage += '-bb';
				}

				if(leftWaterfall || rightWaterfall) {
					$('.straight-wf-height').addClass('shown')
				} else {
					$('.straight-wf-height').removeClass('shown')
				}

			} else if(benchtopShape == 'L-Shaped') {
				reviewImage += '-lshape';

				if(breakfastBar) {
					reviewImage += '-bb';

					if(breakfastBarSide == 'Left') {
						reviewImage += '-l';
					} else if(breakfastBarSide == 'Right') {
						reviewImage += '-r';
					}
				}

				if(leftWaterfall || rightWaterfall) {
					$('.l-wf-height').addClass('shown')
				} else {
					$('.l-wf-height').removeClass('shown')
				}
			} else if(benchtopShape == 'U-Shaped') {
				reviewImage += '-ushape';

				if(breakfastBar) {
					reviewImage += '-bb';

					if(breakfastBarSide == 'Left') {
						reviewImage += '-l';
					} else if(breakfastBarSide == 'Right') {
						reviewImage += '-r';
					}
				}

				if(leftWaterfall || rightWaterfall) {
					$('.u-wf-height').addClass('shown')
				} else {
					$('.u-wf-height').removeClass('shown')
				}
			}

			$benchtopPlanner.find('.step.step-9').removeClass('wf-l wf-r wf-lr');
			if(leftWaterfall && rightWaterfall) {
				reviewImage += '-wf-lr';
				$benchtopPlanner.find('.step.step-9').addClass('wf-lr');
			} else if(leftWaterfall) {
				reviewImage += '-wf-l';
				$benchtopPlanner.find('.step.step-9').addClass('wf-l');
			} else if(rightWaterfall) {
				reviewImage += '-wf-r';
				$benchtopPlanner.find('.step.step-9').addClass('wf-r');
			}

			reviewImage += '-2x';

			reviewImageTag = '<img src="' + finalImageSrc.replace(/bp-7-straight-sonora-black/g, reviewImage) + '" srcset="' + finalImageSrcset.replace(/bp-7-straight-sonora-black-2x/g, reviewImage) + '"';

			if(benchtopShape == 'Straight') {
				reviewImageTag += ' width="' + finalImageWidth + '"';
			} else if(benchtopShape == 'L-Shaped') {
				reviewImageTag += ' width="' + finalImageWidthL + '"';
			} else if(benchtopShape == 'U-Shaped') {
				reviewImageTag += ' width="' + finalImageWidthU + '"';
			}

			reviewImageTag += ' alt="Benchtop Preview">';

			if(benchtopShape == 'Straight') {
				if(!reviewImageDone) {
					reviewImageDone = true;
					$finalImage.prepend(reviewImageTag);
				} else {
					$finalImage.find('img').replaceWith(reviewImageTag);
				}
			} else if(benchtopShape == 'L-Shaped') {
				if(!reviewImageLDone) {
					reviewImageLDone = true;
					$finalImageL.prepend(reviewImageTag);
				} else {
					$finalImageL.find('img').replaceWith(reviewImageTag);
				}
			} else if(benchtopShape == 'U-Shaped') {
				if(!reviewImageUDone) {
					reviewImageUDone = true;
					$finalImageU.prepend(reviewImageTag);
				} else {
					$finalImageU.find('img').replaceWith(reviewImageTag);
				}
			}
		}
	}

	function clearMeasurementsStep() {
		$benchtopPlanner.find('.step-3 input[type=radio]').prop('checked', false);

		var $measurementInput = $benchtopPlanner.find('.step-3 input[type=number]');

		// Loop through inputs
		$measurementInput.each(function() {
			var $this = $(this);
			// Reset to default depth if it's a depth input
			if($this.parent().hasClass('straight-depth') || $this.parent().hasClass('l-left-depth') || $this.parent().hasClass('l-right-depth') || $this.parent().hasClass('u-left-depth') || $this.parent().hasClass('u-centre-depth') || $this.parent().hasClass('u-right-depth')) {
				$this.val(defaultDepth);
			// Otherwise clear
			} else {
				$this.val('');
			}
			// Remove existing errors
			$this.removeClass('error');
		});
	}

	function clearEndFinishingsStep() {
		leftFinished = false;
		rightFinished = false;
		
		wallFinished = false;

		wallStraightFinishingBack = false,

		wallLFinishingBackLeft = false,
		wallLFinishingBackRight = false,

		wallLFinishingBackRightBB = false,
		wallLFinishingBackLeftBB = false,

		wallUFinishingBackLeft = false,
		wallUFinishingBackCentre = false,
		wallUFinishingBackRight = false,


		wallUFinishingBackCentreBBOnLeft = false,
		wallUFinishingBackRightBB = false,

		wallUFinishingBackLeftBB = false,
		wallUFinishingBackCentreBBRJoin = false,


		// Reset radio buttons
		$benchtopPlanner.find('.step-4 input[type=radio]').eq(0).prop('checked', true);
		$benchtopPlanner.find('.step-4 input[name=straight-finishing-left]').eq(0).prop('checked', true);
		$benchtopPlanner.find('.step-4 input[name=straight-finishing-right]').eq(0).prop('checked', true);
		$benchtopPlanner.find('.step-4 input[name=l-finishing-left]').eq(0).prop('checked', true);
		$benchtopPlanner.find('.step-4 input[name=l-finishing-right]').eq(0).prop('checked', true);
		$benchtopPlanner.find('.step-4 input[name=u-finishing-left]').eq(0).prop('checked', true);
		$benchtopPlanner.find('.step-4 input[name=u-finishing-right]').eq(0).prop('checked', true);

		// Show unclashed image
		$benchtopPlanner.find('.step-4 img.unclashed-both').addClass('shown').siblings().removeClass('shown');

		// Reset review info
		$benchtopPlanner.find('.step-9 span.end-finishing-left').text('Unfinished');
		$benchtopPlanner.find('.step-9 span.end-finishing-right').text('Unfinished');
		$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Unfinished');
	}

	function clearEndPolishingsStep() {
		// Reset variables
		leftPolishedTreated = false;
		rightPolishedTreated = false;
		leftWaterfall = false;
		rightWaterfall = false;
		wallPolished = false;
		wallStraightPolishingBack = false;
		wallLPolishingBackLeft = false;
		wallLPolishingBackRight = false;
		wallLPolishingBackRightBB = false;
		wallLPolishingBackLeftBB = false;
		wallUPolishingBackLeft = false;
		wallUPolishingBackCentre = false;
		wallUPolishingBackRight = false;
		wallUPolishingBackCentreBBOnLeft = false;
		wallUPolishingBackRightBB = false;
		wallUPolishingBackLeftBB = false;
		wallUPolishingBackCentreBBRJoin = false;
		wallPolishedList = [];

		// Reset radio buttons on step 5 stone polishing
		var $s5 = $benchtopPlanner.find('.step-5');
		$s5.find('.material-stone input[name=straight-polishing-left]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=straight-polishing-right]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=straight-polishing-back]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=l-polishing-left]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=l-polishing-right]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=l-polishing-back-left]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=l-polishing-back-right]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=l-polishing-back-right-bb]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=l-polishing-back-left-bb]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=u-polishing-left]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=u-polishing-right]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=u-polishing-back-left]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=u-polishing-back-centre]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=u-polishing-back-right]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=u-polishing-back-centre-bb-on-left]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=u-polishing-back-right-bb]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=u-polishing-back-left-bb]').eq(0).prop('checked', true);
		$s5.find('.material-stone input[name=u-polishing-back-centre-bb-on-right]').eq(0).prop('checked', true);

		// Reset preview images to no-waterfall state
		$s5.find('.material-stone .if-straight img, .material-stone .if-straight-bb img').removeClass('shown');
		$s5.find('.material-stone .if-straight img.no-wf, .material-stone .if-straight-bb img.no-wf').addClass('shown');
		$s5.find('.material-stone .if-straight, .material-stone .if-straight-bb').removeClass('wf-l wf-r wf-lr');

		// Reset review text
		$benchtopPlanner.find('.step-9 span.end-polishing-left').text('Unpolished');
		$benchtopPlanner.find('.step-9 span.end-polishing-right').text('Unpolished');
		$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Unpolished');
	}

	// Reset forced join (if needed)
	function resetForcedJoin() {
		if(forceJoin) {
			if(benchtopShape == 'L-Shaped') {
				joinType = 'Left';

			} else if(benchtopShape == 'U-Shaped') {
				joinType = 'RightLeft';
			}

			forceJoin = false;

			// Clear join info
			if(stepProgress > 4) {
				$benchtopPlanner.find('.step-5 .choice').removeClass('selected');
			}

			// Hide forced join options, show standard options
			$benchtopPlanner.find('.step-5 .if-l').addClass('shown');
			$benchtopPlanner.find('.step-5 .if-l-join-l-forced, .step-5 .if-l-join-r-forced').removeClass('shown');
		}
	}

	// AGB rule: only one installation fee + travel call-out per cart, regardless of
	// how many benchtops the customer adds (CAB-425 comment 450820). If those
	// variants are already in the cart from a previous benchtop, drop them from
	// the queue before pushing this benchtop's items.
	function dedupeInstallationFeesFromQueue(callback) {
		var feeVariantIds = [installFeeIDWithJoints, installFeeIDNoJoints, installTravelDefaultID]
			.filter(function(v){ return v != null; })
			.map(String);

		if(feeVariantIds.length === 0 || addtoCartQueue.length === 0) {
			callback();
			return;
		}

		fetch('/cart.js')
		.then(function(r){ return r.json(); })
		.then(function(cart){
			var present = false;
			if(cart && Array.isArray(cart.items)) {
				present = cart.items.some(function(it){
					return feeVariantIds.indexOf(String(it.variant_id)) !== -1;
				});
				if(present) {
					addtoCartQueue = addtoCartQueue.filter(function(item){
						return feeVariantIds.indexOf(String(item.id)) === -1;
					});
				}
			}
			// Keep the front-end flag in sync with the live cart so the next
			// price recalc (and any subsequent benchtop) sees the right state.
			installationFeesAlreadyInCart = present;
			callback();
		})
		.catch(function(){ callback(); });
	}

	// Add to cart
	function ajaxAddtoCart() {
		if(addtoCartQueue.length) {
			dedupeInstallationFeesFromQueue(function(){
				if(!addtoCartQueue.length) {
					// Everything in this benchtop was already in the cart (only fees);
					// fall through to the post-process branch below.
					ajaxAddtoCart();
					return;
				}

				// Organize all items - parent first, then children
				const { parentItem, childItems } = organizeCartItems();

				// Check if we already have a cart
				checkExistingCart((existingCartId) => {
					if(existingCartId) {
						// Cart exists, add all items to existing cart
						window.currentCartId = existingCartId;
						if(parentItem) {
							addAllItemsToExistingCart([parentItem, ...childItems]);
						} else {
							addAllItemsToExistingCart(childItems);
						}
					} else {
						// No cart exists, create new one
						if(parentItem) {
							createCartWithParent(parentItem, childItems);
						} else {
							createNewCart();
						}
					}
				}, parentItem);
			});
		} else {
			// All items added successfully
			if(addAnother) {
				window.location.href = '/collections/custom-benchtops';
			} else {
				$benchtopPlanner.find('.step-9 .action-buttons button').prop('disabled', false).removeClass('is-adding');
				$('.js-drawer-open-right').click(); //open minicart drawer
			}
		}
	}

	function checkExistingCart(callback, parentItem) {
		// First check if we have a stored cart ID
		// if(window.currentCartId) {
		// 	callback(window.currentCartId);
		// 	return;
		// }

		// Fallback to traditional cart check
		fetch('/cart.js')
		.then(response => response.json())
		.then(cart => {
			if(cart && cart.token) {
				// Convert Shopify cart token to GraphQL cart ID format								
				if(cart.token.includes('?key=')) {
					const cartId = `gid://shopify/Cart/${cart.token}`;
					callback(cartId);
				}
				else{
					// Create a temporary cart by adding first product via cart/add.js
					if(parentItem) {
						const formData = new FormData();
						formData.append('id', parentItem.merchandiseId.replace('gid://shopify/ProductVariant/', ''));
						formData.append('quantity', 1);
						
						fetch('/cart/add.js', {
							method: 'POST',
							body: formData
						})
						.then(response => response.json())
						.then(data => {
							// Capture the unique line key from the add response so we
							// remove THIS exact temp line, not just any line that happens
							// to share the variant id. Removing by variant id was duplicating
							// previously-added benchtops that used the same parent variant
							// (CAB-425 comment 450820).
							const tempLineKey = data && data.key;
							// Now get the cart token
							fetch('/cart.js')
							.then(response => response.json())
							.then(cart => {
								if(cart && cart.token) {
									const cartId = `gid://shopify/Cart/${cart.token}`;

									// Remove the temporary item we just added
									fetch('/cart/change.js', {
										method: 'POST',
										headers: {
											'Content-Type': 'application/json',
										},
										body: JSON.stringify({
											id: tempLineKey || parentItem.merchandiseId.replace('gid://shopify/ProductVariant/', ''),
											quantity: 0
										})
									})
									.then(() => {
										callback(cartId);
									})
									.catch(error => {
										console.log('Error removing temporary item:', error);
										callback(cartId); // Still proceed with cart ID
									});
								} else {
									callback(null);
								}
							})
							.catch(error => {
								console.log('Error getting cart after temp add:', error);
								callback(null);
							});
						})
						.catch(error => {
							console.log('Error creating temporary cart:', error);
							callback(null);
						});
					} else {
						callback(null);
					}
				}				
			} else {
				callback(null);
			}
		})
		.catch(error => {
			console.log('No existing cart found or error checking cart:', error);
			callback(null);
		});
	}

	function addAllItemsToExistingCart(allItems) {
		if(allItems.length === 0) {
			finishCartProcess();
			return;
		}

		// Separate parent and children
		const parentItem = allItems[0]; // First item is the parent
		const childItems = allItems.slice(1); // Rest are children

		// Step 1: Add parent item first
		addParentToExistingCart(parentItem, childItems);
	}

	// Stable signature of a CartLineInput's attributes used to identify the
	// exact line we just added (the cartLinesAdd response returns the FULL cart,
	// so matching by merchandiseId alone returns the previously-added benchtop's
	// line when both benchtops share a parent variant — see CAB-425 comment 450820).
	function attributesSignature(attrs) {
		if(!attrs || !attrs.length) return '';
		return attrs.slice()
			.sort(function(a, b){ return a.key < b.key ? -1 : (a.key > b.key ? 1 : 0); })
			.map(function(a){ return a.key + '=' + a.value; })
			.join('|');
	}

	function findLineMatchingItem(edges, item) {
		var wantSig = attributesSignature(item.attributes);
		// Prefer a line that matches BOTH merchandiseId and the exact attribute set;
		// if multiple match, pick the last (Shopify appends newly-added lines).
		var matches = (edges || []).filter(function(edge){
			return edge.node.merchandise.id === item.merchandiseId
				&& attributesSignature(edge.node.attributes) === wantSig;
		});
		if(matches.length) return matches[matches.length - 1];
		// Fallback: last line with matching merchandiseId.
		var byMerch = (edges || []).filter(function(edge){
			return edge.node.merchandise.id === item.merchandiseId;
		});
		return byMerch.length ? byMerch[byMerch.length - 1] : null;
	}

	function addParentToExistingCart(parentItem, childItems) {
		const mutation = `
			mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
				cartLinesAdd(cartId: $cartId, lines: $lines) {
					cart {
						id
						lines(first: 250) {
							edges {
								node {
									id
									quantity
									attributes {
										key
										value
									}
									merchandise {
										... on ProductVariant {
											id
											title
											product {
												title
											}
										}
									}
								}
							}
						}
					}
					userErrors {
						field
						message
					}
				}
			}
		`;

		const variables = {
			cartId: window.currentCartId,
			lines: [parentItem]
		};

		executeGraphQLMutation(mutation, variables, (data) => {
			if(data.cartLinesAdd.userErrors.length === 0) {
				console.log('Parent item added to existing cart:', data.cartLinesAdd.cart);

				// Find the line we just added by matching both merchandise id AND
				// the full attribute set, falling back to the last line with that
				// merchandise. Without this, attaching children to the first match
				// would re-attach them to a previous benchtop's parent and the cart
				// would render as a duplicated benchtop.
				const addedLines = data.cartLinesAdd.cart.lines.edges;
				const parentLine = findLineMatchingItem(addedLines, parentItem);
				const parentLineId = parentLine ? parentLine.node.id : null;

				// Step 2: Add child items with parent reference
				if(childItems.length > 0 && parentLineId) {
					addChildrenToExistingCart(childItems, parentLineId, parentItem.merchandiseId);
				} else {
					finishCartProcess();
				}
			} else {
				handleCartError(data.cartLinesAdd.userErrors);
			}
		});
	}

	function addChildrenToExistingCart(childItems, parentLineId, parentMerchandiseId) {
		// Only STONE benchtops are bundled: each child line gets a parent
		// reference so the lines render grouped under the parent benchtop.
		// LAMINATE benchtops are NOT bundled — every line is added at top level.
		// (Stone also can't nest a child sharing the parent's variant id; Shopify
		// rejects it with "Only one level of nesting is allowed" — CAB-425 — though
		// distinct Benchtop/Waterfall variants mean that normally won't arise.)
		const childLines = childItems.map(item => {
			// Laminate: no bundling — add as a top-level line.
			if(benchMaterial === 'Laminate') {
				return { ...item };
			}
			// Stone: nest under the parent, unless this child shares the parent's
			// variant id (same-variant nesting is rejected by Shopify).
			if(parentMerchandiseId && item.merchandiseId === parentMerchandiseId) {
				return { ...item };
			}
			return { ...item, parent: { lineId: parentLineId } };
		});

		const mutation = `
			mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
				cartLinesAdd(cartId: $cartId, lines: $lines) {
					cart {
						id
						lines(first: 250) {
							edges {
								node {
									id
									quantity
									merchandise {
										... on ProductVariant {
											id
											title
											product {
												title
											}
										}
									}
								}
							}
						}
					}
					userErrors {
						field
						message
					}
				}
			}
		`;

		const variables = {
			cartId: window.currentCartId,
			lines: childLines
		};

		executeGraphQLMutation(mutation, variables, (data) => {
			if(data.cartLinesAdd.userErrors.length === 0) {
				console.log('Child items added to existing cart:', data.cartLinesAdd.cart);
				finishCartProcess();
			} else {
				handleCartError(data.cartLinesAdd.userErrors);
			}
		});
	}

	function createCartWithParent(parentItem, childItems) {
		// Step 1: Create cart with parent item only
		const mutation = `
			mutation cartCreate($input: CartInput!) {
				cartCreate(input: $input) {
					cart {
						id
						lines(first: 250) {
							edges {
								node {
									id
									quantity
									attributes {
										key
										value
									}
									merchandise {
										... on ProductVariant {
											id
											title
											product {
												title
											}
										}
									}
								}
							}
						}
					}
					userErrors {
						field
						message
					}
				}
			}
		`;

		const variables = {
			input: {
				lines: [parentItem],
				attributes: [
					{
						key: 'cart_plan_type',
						value: 'benchtop'
					}
				]
			}
		};

		if(customerEmail) {
			variables.input.buyerIdentity = {
				email: customerEmail
			};
		}

		executeGraphQLMutation(mutation, variables, (data) => {
			if(data.cartCreate.userErrors.length === 0) {
				window.currentCartId = data.cartCreate.cart.id;
				// Store cart ID for persistence
				localStorage.setItem('shopify_graphql_cart_id', data.cartCreate.cart.id);
				console.log('Cart created with parent item:', data.cartCreate.cart);

				// Find the line we just added by matching attributes; cartCreate's
				// response is the new cart's full line list (only one line on first
				// create, but be consistent with addParentToExistingCart).
				const addedLines = data.cartCreate.cart.lines.edges;
				const parentLine = findLineMatchingItem(addedLines, parentItem);
				const parentLineId = parentLine ? parentLine.node.id : null;

				// Step 2: Add all child items in one batch
				if(childItems.length > 0 && parentLineId) {
					addChildItemsBatch(childItems, parentLineId, parentItem.merchandiseId);
				} else {
					// No child items, we're done
					finishCartProcess();
				}
			} else {
				handleCartError(data.cartCreate.userErrors);
			}
		});
	}

	function addChildItemsBatch(childItems, parentLineId, parentMerchandiseId) {
		// Only STONE benchtops are bundled: each child line gets a parent
		// reference so the lines render grouped under the parent benchtop.
		// LAMINATE benchtops are NOT bundled — every line is added at top level.
		// (Stone also can't nest a child sharing the parent's variant id; Shopify
		// rejects it with "Only one level of nesting is allowed" — CAB-425 — though
		// distinct Benchtop/Waterfall variants mean that normally won't arise.)
		const childLines = childItems.map(item => {
			// Laminate: no bundling — add as a top-level line.
			if(benchMaterial === 'Laminate') {
				return { ...item };
			}
			// Stone: nest under the parent, unless this child shares the parent's
			// variant id (same-variant nesting is rejected by Shopify).
			if(parentMerchandiseId && item.merchandiseId === parentMerchandiseId) {
				return { ...item };
			}
			return { ...item, parent: { lineId: parentLineId } };
		});

		const mutation = `
			mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
				cartLinesAdd(cartId: $cartId, lines: $lines) {
					cart {
						id
						lines(first: 250) {
							edges {
								node {
									id
									quantity
									merchandise {
										... on ProductVariant {
											id
											title
											product {
												title
											}
										}
									}
								}
							}
						}
					}
					userErrors {
						field
						message
					}
				}
			}
		`;

		const variables = {
			cartId: window.currentCartId,
			lines: childLines
		};

		executeGraphQLMutation(mutation, variables, (data) => {
			if(data.cartLinesAdd.userErrors.length === 0) {
				console.log('All child items added successfully:', data.cartLinesAdd.cart);
				finishCartProcess();
			} else {
				handleCartError(data.cartLinesAdd.userErrors);
			}
		});
	}

	function finishCartProcess() {
		// Clear the queue since everything was processed
		addtoCartQueue = [];
		
		if(addAnother) {
			window.location.href = '/collections/custom-benchtops';
		} else {
			$benchtopPlanner.find('.step-9 .action-buttons button').prop('disabled', false).removeClass('is-adding');
			$('.js-drawer-open-right').click(); //open minicart drawer
		}
	}

	function createNewCart() {
		// Fallback for when no parent is identified
		const item = addtoCartQueue.pop();
		const cartLine = convertToCartLine(item);
		
		const mutation = `
			mutation cartCreate($input: CartInput!) {
				cartCreate(input: $input) {
					cart {
						id
						lines(first: 250) {
							edges {
								node {
									id
								}
							}
						}
					}
					userErrors {
						field
						message
					}
				}
			}
		`;

		const variables = {
			input: {
				lines: [cartLine],
				attributes: [
					{
						key: 'cart_plan_type',
						value: 'benchtop'
					}
				]
			}
		};
		if(customerEmail) {
			variables.input.buyerIdentity = {
				email: customerEmail
			};
		}

		executeGraphQLMutation(mutation, variables, (data) => {
			if(data.cartCreate.userErrors.length === 0) {
				window.currentCartId = data.cartCreate.cart.id;
				// Store cart ID for persistence
				localStorage.setItem('shopify_graphql_cart_id', data.cartCreate.cart.id);
				console.log('Cart created successfully');
				// Continue with remaining items
				ajaxAddtoCart();
			} else {
				handleCartError(data.cartCreate.userErrors);
			}
		});
	}


function organizeCartItems() {
	// Process all items from the queue
	const allItems = [...addtoCartQueue];
	addtoCartQueue = []; // Clear the queue

	// Count how many queued items share each variant id.
	const variantCounts = {};
	allItems.forEach(item => {
		variantCounts[item.id] = (variantCounts[item.id] || 0) + 1;
	});

	// Items eligible to be the bundle parent.
	const laminatePieceIds = [
		benchtop1ID,
		benchtop1AID,
		benchtop2ID,
		benchtop2AID,
		benchtop3ID,
		benchtop3AID
	].filter(id => id != null);

	const benchtopItemIds = [
		...laminatePieceIds,
		materialProductID
	]
		.filter(id => id != null)
		.map(id => String(id));

	// Enforce the plan type when items are prepared for Shopify.
	// This also covers plans saved before _Plan_Type was introduced.
	allItems.forEach(item => {
		if(benchtopItemIds.indexOf(String(item.id)) !== -1) {
			item.properties = item.properties || {};
			item.properties['_Plan_Type'] = 'Custom Benchtop';
		}
	});

	function isParentEligible(item) {
		if(item.id === materialProductID) return true;

		return benchMaterial === 'Laminate' &&
			laminatePieceIds.indexOf(item.id) !== -1;
	}

		// Prefer a parent whose variant id is UNIQUE in this queue, so every child
		// resolves to a different variant and nests cleanly — this keeps all pieces
		// grouped for the common symmetric L/U laminate case where equal-length
		// runs collapse onto the same length-based variant. Fall back to the first
		// eligible item when none is unique (e.g. every run is the same length);
		// the child-add functions then add the unavoidable same-variant pieces as
		// standalone lines. Subsequent same-variant items still fall through to
		// childItems rather than being dropped.
		let parentIndex = allItems.findIndex(item => isParentEligible(item) && variantCounts[item.id] === 1);
		if(parentIndex === -1) {
			parentIndex = allItems.findIndex(isParentEligible);
		}

		let parentItem = null;
		const childItems = [];
		allItems.forEach((item, index) => {
			if(index === parentIndex) {
				parentItem = convertToCartLine(item);
			} else {
				childItems.push(convertToCartLine(item));
			}
		});

		return { parentItem, childItems };
	}

	function convertToCartLine(item) {
		const cartLine = {
			merchandiseId: String(item.id).startsWith('gid://') ? String(item.id) : `gid://shopify/ProductVariant/${item.id}`,
			quantity: item.quantity || 1
		};

		// Add properties as attributes
		if(item.properties && Object.keys(item.properties).length > 0) {
			cartLine.attributes = Object.entries(item.properties).map(([key, value]) => ({
				key: key,
				value: String(value)
			}));
		}

		return cartLine;
	}

	function executeGraphQLMutation(mutation, variables, onSuccess) {
		fetch('/api/2025-10/graphql.json', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Shopify-Storefront-Access-Token': storeFrontApiKey,
				'Accept': 'application/json'
			},
			body: JSON.stringify({
				query: mutation,
				variables: variables
			})
		})
		.then(response => response.json())
		.then(data => {
			if(data.errors) {
				console.error('GraphQL errors:', data.errors);
				handleCartError(data.errors);
			} else {
				onSuccess(data.data);
			}
		})
		.catch(error => {
			console.error('Cart operation failed:', error);
			handleCartError([{message: 'Network error occurred'}]);
		});
	}

	function handleCartError(errors) {
		console.error('Cart errors:', errors);
		$benchtopPlanner.find('.step-9 .action-buttons button').prop('disabled', false).removeClass('is-adding');
		
		const errorMessage = errors.length > 0 ? errors[0].message : 'Unknown error occurred';
		alert(`Error adding benchtop to cart: ${errorMessage}. Please try again.`);
	}

	// Debug function to check cart status
	function debugCartStatus() {
		console.log('=== Cart Debug Info ===');
		console.log('window.currentCartId:', window.currentCartId);
		console.log('localStorage cart ID:', localStorage.getItem('shopify_graphql_cart_id'));
		
		fetch('/cart.js')
		.then(response => response.json())
		.then(cart => {
			console.log('Traditional cart (/cart.js):', cart);
			console.log('Traditional cart items:', cart.item_count);
		})
		.catch(error => {
			console.log('No traditional cart found:', error);
		});
	}

	function hideLoadOptions() {
		// Unselect
		$savedPlan.find('.open-saved-plan').removeClass('selected');

		// Close popup
		$fullOverlay.removeClass('shown');
		$loadOptions.removeClass('shown');
	}

	function hideSaveOptions() {
		// Close popup
		$fullOverlay.removeClass('shown');
		$saveOptions.removeClass('shown');
	}

	function hideLogin() {
		// Close popup
		$fullOverlay.removeClass('shown');
		$customerForm.removeClass('shown');
	}

	function hideRegister() {
		// Go back to login screen
		$register.removeClass('shown');
		$login.addClass('shown');

		// Close popup
		$fullOverlay.removeClass('shown');
		$customerForm.removeClass('shown');
	}

	function hideWarning() {
		// Close popup
		$fullOverlay.removeClass('shown');
		$warning.removeClass('shown');

		goToNextStepAndValidate(5);
	}

	// Next button
	$benchtopPlanner.find('a.next').on('click', function(e) {
		var $this = $(this),
		nextStep = $this.attr('href').replace('#step-', '');
		
		if(validateSteps(nextStep - 1)) {
			goToNextStep(nextStep);
		} else {
			e.preventDefault();
		}
	});

	// On measurement input
	$benchtopPlanner.find('.step-3 input[type=number]').on('keyup', function() {
		var $this = $(this);

		resetForcedJoin();

		// Keep the timer running on box switch (so that typing in the new box doesn't prevent the old box saving)
		// If same box
		if(currentlyEditing == $this.attr('id')) {
			clearTimeout(typingTimer);
		// If new box, save the new box
		} else {
			currentlyEditing = $this.attr('id');
		}

		// Validate a bit faster if there's an error already (otherwise it feels clunky)
		if($this.hasClass('error')) {
			typingTimer = setTimeout(function() {
				validateMeasurement($this);
			}, 800);
		} else {
			typingTimer = setTimeout(function() {
				validateMeasurement($this);
			}, 2000);
		}
	});

	// Measurement radio buttons
	$benchtopPlanner.find('.step-3 input[type=radio]').on('change', function() {
		var $this = $(this);
		resetForcedJoin();
		validateRadioMeasurement($this);

			if($('.step-3 .shown input[value=650]:checked').length > 0){
				$('.bb-650-message').removeClass('hide');
			}
			else{
				$('.bb-650-message').addClass('hide');
			}

			if($('.step-3 .shown input[value=900]:checked').length > 0){
				$('.bb-99-message').removeClass('hide');
			}
			else{
				$('.bb-99-message').addClass('hide');
			}

	});

	// End finishing radio buttons
	$benchtopPlanner.find('.step-5 input[type=radio]').on('change', function() {
		var $this = $(this),
		endFinished = $this.val(),
		endFinishedName = $this.attr('name');

		if(endFinished == 'Left Finished') {
			leftFinished = true;
			$benchtopPlanner.find('.step-9 span.end-finishing-left').text('Finished');

			if(rightFinished) {
				$this.closest('.diagram').find('img.clashed').addClass('shown').siblings().removeClass('shown');
			} else {
				$this.closest('.diagram').find('img.unclashed-r').addClass('shown').siblings().removeClass('shown');
			}

		} else if(endFinished == 'Left Unfinished') {
			leftFinished = false;
			$benchtopPlanner.find('.step-9 span.end-finishing-left').text('Unfinished');

			if(rightFinished) {
				$this.closest('.diagram').find('img.unclashed-l').addClass('shown').siblings().removeClass('shown');
			} else {
				$this.closest('.diagram').find('img.unclashed-both').addClass('shown').siblings().removeClass('shown');
			}

		} else if(endFinished == 'Right Finished') {
			rightFinished = true;
			$benchtopPlanner.find('.step-9 span.end-finishing-right').text('Finished');

			if(leftFinished) {
				$this.closest('.diagram').find('img.clashed').addClass('shown').siblings().removeClass('shown');
			} else {
				$this.closest('.diagram').find('img.unclashed-l').addClass('shown').siblings().removeClass('shown');
			}

		} else if(endFinished == 'Right Unfinished') {
			rightFinished = false;
			$benchtopPlanner.find('.step-9 span.end-finishing-right').text('Unfinished');

			if(leftFinished) {
				$this.closest('.diagram').find('img.unclashed-r').addClass('shown').siblings().removeClass('shown');
			} else {
				$this.closest('.diagram').find('img.unclashed-both').addClass('shown').siblings().removeClass('shown');
			}
		}


		//Wall finishing
		if(endFinished == 'Wall Finished') {
			wallFinished = true;

			$benchtopPlanner.find('.step-9 span.end-finishing-wall-wrapper').addClass('shown');

			if(endFinishedName == 'straight-finishing-back'){
				wallStraightFinishingBack = true;
				wallFinishedList.push('straight-finishing-back');
			}

			if(endFinishedName == 'l-finishing-back-left'){
				$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Finished (l-finishing-back-left)');
				wallLFinishingBackLeft = true;
				wallFinishedList.push('l-finishing-back-left');
			}

			if(endFinishedName == 'l-finishing-back-right'){
				$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Finished (l-finishing-back-right)');
				wallLFinishingBackRight = true;
				wallFinishedList.push('l-finishing-back-right');
			}

			if(endFinishedName == 'l-finishing-back-right-bb'){
				$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Finished (l-finishing-back-right-bb)');
				wallLFinishingBackRightBB = true;
				wallFinishedList.push('l-finishing-back-right');
			}

			if(endFinishedName == 'l-finishing-back-left-bb'){
				$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Finished (l-finishing-back-left-bb)');
				wallLFinishingBackLeftBB = true;
				wallFinishedList.push('l-finishing-back-left');
			}

			if(endFinishedName == 'u-finishing-back-left'){
				$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Finished (u-finishing-back-left)');
				wallUFinishingBackLeft = true;
				wallFinishedList.push('u-finishing-back-left');
			}

			if(endFinishedName == 'u-finishing-back-centre'){
				$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Finished (u-finishing-back-centre)');
				wallUFinishingBackCentre = true;
				wallFinishedList.push('u-finishing-back-centre');
			}

			if(endFinishedName == 'u-finishing-back-right'){
				$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Finished (u-finishing-back-right)');
				wallUFinishingBackRight = true;
				wallFinishedList.push('u-finishing-back-right');
			}

			if(endFinishedName == 'u-finishing-back-centre-bb-on-left'){
				$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Finished (u-finishing-back-centre-bb)');
				wallUFinishingBackCentreBBOnLeft = true;
				wallFinishedList.push('u-finishing-back-centre');
			}

			if(endFinishedName == 'u-finishing-back-right-bb'){
				$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Finished (u-finishing-back-right-bb)');
				wallUFinishingBackRightBB = true;
				wallFinishedList.push('u-finishing-back-right');
			}

			if(endFinishedName == 'u-finishing-back-left-bb'){
				$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Finished (u-finishing-back-left-bb)');
				wallUFinishingBackLeftBB = true;
				wallFinishedList.push('u-finishing-back-left');
			}

			if(endFinishedName == 'u-finishing-back-centre-bb-on-right'){
				$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Finished (u-finishing-back-centre-bb)');
				wallUFinishingBackCentreBBRJoin = true;
				wallFinishedList.push('u-finishing-back-centre');
			}

		}
		if(endFinished == 'Wall Unfinished') {
			wallFinished = false;
			
			$benchtopPlanner.find('.step-9 span.end-finishing-wall').text('Unfinished');

			if(endFinishedName == 'straight-finishing-back'){
				wallStraightFinishingBack = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'straight-finishing-back');
			}

			if(endFinishedName == 'l-finishing-back-left'){
				wallLFinishingBackLeft = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'l-finishing-back-left');
			}

			if(endFinishedName == 'l-finishing-back-right'){
				wallLFinishingBackRight = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'l-finishing-back-right');
			}

			if(endFinishedName == 'l-finishing-back-right-bb'){
				wallLFinishingBackRightBB = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'l-finishing-back-right');
			}

			if(endFinishedName == 'l-finishing-back-left-bb'){
				wallLFinishingBackLeftBB = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'l-finishing-back-left');
			}

			if(endFinishedName == 'u-finishing-back-left'){
				wallUFinishingBackLeft = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'u-finishing-back-left');
			}

			if(endFinishedName == 'u-finishing-back-centre'){
				wallUFinishingBackCentre = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'u-finishing-back-centre');
			}

			if(endFinishedName == 'u-finishing-back-right'){
				wallUFinishingBackRight = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'u-finishing-back-right');
			}

			if(endFinishedName == 'u-finishing-back-centre-bb-on-left'){
				wallUFinishingBackCentreBBOnLeft = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'u-finishing-back-centre');
			}

			if(endFinishedName == 'u-finishing-back-right-bb'){
				wallUFinishingBackRightBB = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'u-finishing-back-right');
			}

			if(endFinishedName == 'u-finishing-back-left-bb'){
				wallUFinishingBackLeftBB = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'u-finishing-back-left');
			}

			if(endFinishedName == 'u-finishing-back-centre-bb-on-right'){
				wallUFinishingBackCentreBBRJoin = false;
				wallFinishedList = wallFinishedList.filter(e => e !== 'u-finishing-back-centre');
			}
		}
		// Update price
		calculateEndFinishingPrice();

		// Update the review image (only runs if step 6 has been completed)
		updateReviewImage();
	});

	// Stone polishing/waterfall radio buttons (material-stone area)
	$benchtopPlanner.find('.step-5 .material-stone input[type=radio]').on('change', function() {
		var $this = $(this),
		endPolished = $this.val(),
		endPolishedName = $this.attr('name');

		if(endPolished == 'Polished') {
			if(endPolishedName.includes('left')) {
				leftPolishedTreated = true;
				leftWaterfall = false;
				$benchtopPlanner.find('.step-9 span.end-polishing-left').text('Polished');
			}
			if(endPolishedName.includes('right')) {
				rightPolishedTreated = true;
				rightWaterfall = false;
				$benchtopPlanner.find('.step-9 span.end-polishing-right').text('Polished');
			}
		} else if(endPolished == 'Waterfall') {
			if(endPolishedName.includes('left')) {
				leftPolishedTreated = false;
				leftWaterfall = true;
				$benchtopPlanner.find('.step-9 span.end-polishing-left').text('Waterfall');
			}
			if(endPolishedName.includes('right')) {
				rightPolishedTreated = false;
				rightWaterfall = true;
				$benchtopPlanner.find('.step-9 span.end-polishing-right').text('Waterfall');
			}
		} else if(endPolished == 'Unpolished') {
			if(endPolishedName.includes('left')) {
				leftPolishedTreated = false;
				leftWaterfall = false;
				$benchtopPlanner.find('.step-9 span.end-polishing-left').text('Unpolished');
			}
			if(endPolishedName.includes('right')) {
				rightPolishedTreated = false;
				rightWaterfall = false;
				$benchtopPlanner.find('.step-9 span.end-polishing-right').text('Unpolished');
			}
		}

		// Wall polishing
		if(endPolished == 'Wall Polished') {
			wallPolished = true;
			$benchtopPlanner.find('.step-9 span.end-polishing-wall-wrapper').addClass('shown');

			if(endPolishedName == 'straight-polishing-back'){
				wallStraightPolishingBack = true;
				wallPolishedList.push('straight-polishing-back');
			}
			if(endPolishedName == 'l-polishing-back-left'){
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Polished (l-polishing-back-left)');
				wallLPolishingBackLeft = true;
				wallPolishedList.push('l-polishing-back-left');
			}
			if(endPolishedName == 'l-polishing-back-right'){
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Polished (l-polishing-back-right)');
				wallLPolishingBackRight = true;
				wallPolishedList.push('l-polishing-back-right');
			}
			if(endPolishedName == 'l-polishing-back-right-bb'){
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Polished (l-polishing-back-right-bb)');
				wallLPolishingBackRightBB = true;
				wallPolishedList.push('l-polishing-back-right');
			}
			if(endPolishedName == 'l-polishing-back-left-bb'){
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Polished (l-polishing-back-left-bb)');
				wallLPolishingBackLeftBB = true;
				wallPolishedList.push('l-polishing-back-left');
			}
			if(endPolishedName == 'u-polishing-back-left'){
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Polished (u-polishing-back-left)');
				wallUPolishingBackLeft = true;
				wallPolishedList.push('u-polishing-back-left');
			}
			if(endPolishedName == 'u-polishing-back-centre'){
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Polished (u-polishing-back-centre)');
				wallUPolishingBackCentre = true;
				wallPolishedList.push('u-polishing-back-centre');
			}
			if(endPolishedName == 'u-polishing-back-right'){
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Polished (u-polishing-back-right)');
				wallUPolishingBackRight = true;
				wallPolishedList.push('u-polishing-back-right');
			}
			if(endPolishedName == 'u-polishing-back-centre-bb-on-left'){
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Polished (u-polishing-back-centre-bb)');
				wallUPolishingBackCentreBBOnLeft = true;
				wallPolishedList.push('u-polishing-back-centre');
			}
			if(endPolishedName == 'u-polishing-back-right-bb'){
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Polished (u-polishing-back-right-bb)');
				wallUPolishingBackRightBB = true;
				wallPolishedList.push('u-polishing-back-right');
			}
			if(endPolishedName == 'u-polishing-back-left-bb'){
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Polished (u-polishing-back-left-bb)');
				wallUPolishingBackLeftBB = true;
				wallPolishedList.push('u-polishing-back-left');
			}
			if(endPolishedName == 'u-polishing-back-centre-bb-on-right'){
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Polished (u-polishing-back-centre-bb)');
				wallUPolishingBackCentreBBRJoin = true;
				wallPolishedList.push('u-polishing-back-centre');
			}
		}

		if(endPolished == 'Wall Unpolished') {
			wallPolished = false;
			$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Unpolished');
			if(endPolishedName == 'straight-polishing-back'){
				wallStraightPolishingBack = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'straight-polishing-back');
			}
			if(endPolishedName == 'l-polishing-back-left'){
				wallLPolishingBackLeft = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'l-polishing-back-left');
			}
			if(endPolishedName == 'l-polishing-back-right'){
				wallLPolishingBackRight = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'l-polishing-back-right');
			}
			if(endPolishedName == 'l-polishing-back-right-bb'){
				wallLPolishingBackRightBB = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'l-polishing-back-right');
			}
			if(endPolishedName == 'l-polishing-back-left-bb'){
				wallLPolishingBackLeftBB = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'l-polishing-back-left');
			}
			if(endPolishedName == 'u-polishing-back-left'){
				wallUPolishingBackLeft = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'u-polishing-back-left');
			}
			if(endPolishedName == 'u-polishing-back-centre'){
				wallUPolishingBackCentre = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'u-polishing-back-centre');
			}
			if(endPolishedName == 'u-polishing-back-right'){
				wallUPolishingBackRight = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'u-polishing-back-right');
			}
			if(endPolishedName == 'u-polishing-back-centre-bb-on-left'){
				wallUPolishingBackCentreBBOnLeft = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'u-polishing-back-centre');
			}
			if(endPolishedName == 'u-polishing-back-right-bb'){
				wallUPolishingBackRightBB = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'u-polishing-back-right');
			}
			if(endPolishedName == 'u-polishing-back-left-bb'){
				wallUPolishingBackLeftBB = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'u-polishing-back-left');
			}
			if(endPolishedName == 'u-polishing-back-centre-bb-on-right'){
				wallUPolishingBackCentreBBRJoin = false;
				wallPolishedList = wallPolishedList.filter(e => e !== 'u-polishing-back-centre');
			}
		}

		// Recalculate polishing price on change.
		calculatePolishingPrice();
		// Toggling Waterfall on a side changes leftWaterfall/rightWaterfall,
		// which feeds leftWaterfallArea/rightWaterfallArea (computed in
		// calculateSize). Without re-running calculateSize, those areas stay
		// at their last-computed value (often 0 if waterfall was off when the
		// user picked their colour) and the cart push at line ~6248 skips the
		// waterfall material because `leftWaterfallArea > 0` is false. Also
		// re-runs getMaterialPrice so the bulk-discount markup picks up the
		// new total size across benchtop + waterfall lines.
		calculateSize();
		updateWaterfallImages();
		updateReviewImage();
	});

	// Installation assistance toggle
	$benchtopPlanner.on('change', 'input[name=install-assistance]', function(){
		var need = $(this).val() === 'Yes';
		needInstallation = need;
		$benchtopPlanner.find('.install-postcode')[need ? 'removeClass' : 'addClass']('hide');
		installContactName = $.trim($benchtopPlanner.find('#install-contact-name').val());
		installContactNumber = $.trim($benchtopPlanner.find('#install-contact-number').val());
		installPostcode = $.trim($benchtopPlanner.find('#install-postcode').val());
		calculateInstallationPrice();
	});

	$benchtopPlanner.on('input', '#install-contact-name, #install-contact-number, #install-postcode', function(){
		installContactName = $.trim($benchtopPlanner.find('#install-contact-name').val());
		installContactNumber = $.trim($benchtopPlanner.find('#install-contact-number').val());
		installPostcode = $.trim($benchtopPlanner.find('#install-postcode').val());
		
		// Clear any existing postcode error when user starts typing
		if($(this).attr('id') === 'install-postcode'){
			$benchtopPlanner.find('.step-8 .note.form-error').removeClass('shown').text('');
		}
		
		calculateInstallationPrice();
	});
	
	// Add blur validation for postcode to show immediate feedback
	$benchtopPlanner.on('blur', '#install-postcode', function(){
		var postcode = $.trim($(this).val());
		var $step8 = $benchtopPlanner.find('.step-8');
		
		if(postcode !== '' && needInstallation){
			var postcodeValid = false;
			if(typeof window !== 'undefined' && Array.isArray(window.benchtopTravellingPostcodes)){
				var postcodeInt = parseInt(postcode, 10);
				if(!isNaN(postcodeInt)){
					// Check if postcode exists in the available postcodes array
					postcodeValid = window.benchtopTravellingPostcodes.some(function(availablePostcode){
						return parseInt(availablePostcode, 10) === postcodeInt;
					});
				}
			}
			
			if(!postcodeValid){
				$step8.find('.note.form-error').addClass('shown').text('We don\'t recognise that postcode please contact us');
			}else{
				$step8.find('.note.form-error').removeClass('shown').text('');
			}
		}
	});
	// Step 6 cut-outs checkboxes
	$benchtopPlanner.find('.step-6 input[type=checkbox]').on('change', function(){
		var $this = $(this),
		name = $this.attr('name'),
		checked = $this.is(':checked');

		// Common cutout checkboxes (handled by specific event handlers above)
		if(name == 'cutout-sink-tap') sinkTapCutout = checked;
		if(name == 'cutout-hob') hobCutout = checked;
		if(name == 'cutout-air-switch') airSwitchCutout = checked;

		calculateCutoutsPrice();
	});

	// Progress navigation
	$progress.find('a').on('click', function(e) {
		var $this = $(this),
		$parentLi = $this.parent('li'),
		index = $this.closest('ol').find('li').index($parentLi);

		if($parentLi.hasClass('available') && !$parentLi.hasClass('current')) {
			// Need to validate if jumping forward
			if(validateSteps(index)) {
				currentStep = index + 1;
				updateProgress();
			} else {
				e.preventDefault();
			}

		} else {
			e.preventDefault();
		}
	});

	// On forwards/back click
	$(window).on('hashchange', function(e) {

		// Get hash from URL, replace '#' with '.'
		var newStep = location.hash.replace(/^#step-/, '');

		// Only do something if the hash is different
		if(newStep != currentStep) {

			// If blank, go to first step
			if(newStep == "") {
				newStep = 1;
			}

			// Check if step is available
			if(newStep <= stepProgress) {
				if(validateSteps(newStep - 1)) {
					currentStep = newStep;
					updateProgress();
				} else {
					e.preventDefault();
				}
			}
		}
	});

	// Choice
	$('body').on('click', '.benchtop-planner .choice', function() {
		var $this = $(this),
		choiceText = $this.find('h3').text();

		// Remove any existing errors
		$benchtopPlanner.find('.form-error').removeClass('shown');

		// Mark choice as selected
		$this.addClass('selected').parent('.grid__item').siblings().find('.choice').removeClass('selected');

		// Shape
		if(currentStep == 1) {
			benchtopShape = choiceText;

			// Oh no! They changed the shape after completing other steps - reset to default!
			if(stepProgress > 1) {
				// Reset previous choices
				breakfastBar = false;
				breakfastBarSide = null;
				benchtopsPrice = 0;
				endFinishingsPrice = 0;
				endFinishingQty = 0;
				endFinishingLongQty = 0;
				joinQty = 0;
				glueQty = 0;
				benchtopPieces = 0;
				benchtop1ID = null;
				benchtop1Price = null;
				length1 = null;
				length1Final = null;
				depth1 = null;
				benchtop1AID = null;
				benchtop1APrice = null;
				length1AFinal = null;
				benchtop2ID = null;
				benchtop2Price = null;
				length2 = null;
				length2Final = null;
				depth2 = null;
				benchtop2AID = null;
				benchtop2APrice = null;
				length2AFinal = null;
				benchtop3ID = null;
				benchtop3Price = null;
				length3 = null;
				length3Final = null;
				depth3 = null;
				benchtop3AID = null;
				benchtop3APrice = null;
				length3AFinal = null;
				leftFinished = false;
				rightFinished = false;
				joinType = 'Left';
				forceJoin = false;
				colour = null;
				// Reset wall finishing variables
				wallFinished = false;
				wallFinishedList = [];
				wallStraightFinishingBack = false;
				wallLFinishingBackLeft = false;
				wallLFinishingBackRight = false;
				wallLFinishingBackRightBB = false;
				wallLFinishingBackLeftBB = false;
				wallUFinishingBackLeft = false;
				wallUFinishingBackCentre = false;
				wallUFinishingBackRight = false;
				wallUFinishingBackCentreBBOnLeft = false;
				wallUFinishingBackRightBB = false;
				wallUFinishingBackLeftBB = false;
				wallUFinishingBackCentreBBRJoin = false;

				// Reset polishing variables
				leftPolishedTreated = false;
				rightPolishedTreated = false;
				leftWaterfall = false;
				rightWaterfall = false;
				wallPolished = false;
				wallPolishedList = [];
				wallStraightPolishingBack = false;
				wallLPolishingBackLeft = false;
				wallLPolishingBackRight = false;
				wallLPolishingBackRightBB = false;
				wallLPolishingBackLeftBB = false;
				wallUPolishingBackLeft = false;
				wallUPolishingBackCentre = false;
				wallUPolishingBackRight = false;
				wallUPolishingBackCentreBBOnLeft = false;
				wallUPolishingBackRightBB = false;
				wallUPolishingBackLeftBB = false;
				wallUPolishingBackCentreBBRJoin = false;

				// Reset polishing/waterfall quantities. The booleans above feed
				// these qtys via calculatePolishingPrice(), but that only runs on
				// polishing-radio change events. After a shape change the radios
				// reset to "no polish" by default, so the user never triggers a
				// change — leaving stale qtys from the prior shape in the cart push.
				polishingQty = 0;
				polishingLongQty = 0;
				waterfallQty = 0;

				// Reset pricing variables
				stonePolishingPrice = 0;
				stoneCutoutsPrice = 0;
				finalPrice = 0;
				finalPriceFormatted = null;

				// Hide price
				$progress.find('.price-info').removeClass('shown');

				// Unselect all previous choices (except for the one just clicked!)
				$this.closest('.step').siblings().find('.choice').removeClass('selected');

				// Reset steps back to straight default
				$benchtopPlanner.find('.if-straight-bb, .if-l, .if-l-bb, .if-l-bb-l, .if-l-bb-r, .if-l-join-l-forced, .if-l-join-r-forced, .if-u, .if-u-bb, .if-u-bb-l, .if-u-bb-r').removeClass('shown');
				$benchtopPlanner.find('.if-straight, .unless-straight-bb').addClass('shown');

				// Reset measurement inputs
				clearMeasurementsStep();

				// Reset end finishing radio buttons (set first option to true)
				clearEndFinishingsStep();

				// Reset polishing values
				clearEndPolishingsStep();

				// Reset progress
				currentStep = 1;
				stepProgress = 1;
				$progress.find('li').eq(0).siblings().removeClass('available');
			}

			if(benchtopShape == 'Straight') {
				// Always set .if-straight/.if-straight-any to shown on Straight pick.
				// Previously gated on shapeChanged so the block was a no-op on the
				// default first-time Straight selection — but the HTML defaults don't
				// include `shown` on every .if-straight-any element (e.g. the step-9
				// End Polishing <p>), so they stayed hidden until the user switched
				// shapes. The L/U branches below run unconditionally; Straight should
				// match for consistency.
				$benchtopPlanner.find('.if-l, .if-l-any, .if-u, .if-u-any').removeClass('shown');
				$benchtopPlanner.find('.if-straight, .if-straight-any').addClass('shown');

				if(shapeChanged) {
					// Hide join step
					$progress.find('.if-join').removeClass('shown');
					$step5Next.attr('href', '#step-6');
				}

			} else if(benchtopShape == 'L-Shaped') {
				$benchtopPlanner.find('.if-straight, .if-straight-any, .if-u, .if-u-any').removeClass('shown');
				$benchtopPlanner.find('.if-l, .if-l-any').addClass('shown');

				// Show join step
				$progress.find('.if-join').addClass('shown');
				$step5Next.attr('href', '#step-6');
				shapeChanged = true;

				// Load join product
				loadJoin(false);

			} else if(benchtopShape == 'U-Shaped') {
				$benchtopPlanner.find('.if-straight, .if-straight-any, .if-l, .if-l-any').removeClass('shown');
				$benchtopPlanner.find('.if-u, .if-u-any').addClass('shown');

				// Show join step
				$progress.find('.if-join').addClass('shown');
				$step5Next.attr('href', '#step-6');
				shapeChanged = true;

				// Load join product
				loadJoin(false);

				// Set 'Right Left' join as the default because it's available for all configurations
				joinType = 'RightLeft';
			}

			// Lazy load images for chosen shape
			loadImages();

			// Go to next step
			goToNextStepAndValidate(2);

		// Breakfast bar
		} else if(currentStep == 2) {

			// Clear existing measurements if the measurements step has already been viewed
			if(stepProgress > 2) {
				benchtopsPrice = 0;
				endFinishingsPrice = 0;
				endFinishingQty = 0;
				endFinishingLongQty = 0;
				joinQty = 0;
				glueQty = 0;
				benchtopPieces = 0;
				benchtop1ID = null;
				benchtop1Price = null;
				length1 = null;
				length1Final = null;
				benchtop1AID = null;
				benchtop1APrice = null;
				length1AFinal = null;
				benchtop2ID = null;
				benchtop2Price = null;
				length2 = null;
				length2Final = null;
				benchtop2AID = null;
				benchtop2APrice = null;
				length2AFinal = null;
				benchtop3ID = null;
				benchtop3Price = null;
				length3 = null;
				length3Final = null;
				benchtop3AID = null;
				benchtop3APrice = null;
				length3AFinal = null;
				leftFinished = false;
				rightFinished = false;

				// Reset polishing/waterfall state too — toggling Standard ↔ Breakfast
				// Bar changes geometry, so prior polishing selections must be re-entered.
				// Without this, polishingQty/polishingLongQty stay at their stale values
				// (the radios reset to "no polish" by default, so a confirming click
				// fires no change event and calculatePolishingPrice never re-runs).
				leftPolishedTreated = false;
				rightPolishedTreated = false;
				leftWaterfall = false;
				rightWaterfall = false;
				polishingQty = 0;
				polishingLongQty = 0;
				waterfallQty = 0;
				stonePolishingPrice = 0;

				clearMeasurementsStep();
				clearEndFinishingsStep();
				clearEndPolishingsStep();

				// Hide price
				$progress.find('.price-info').removeClass('shown');
			}

			// Clear depths (these are overwritten depending on choice)
			depth1 = null;
			depth2 = null;
			depth3 = null;

			if(choiceText == 'Standard Benchtop') {
				breakfastBar = false;
				depth1 = defaultDepth;
				
				// Reset breakfast bar wall polishing variables
				wallLPolishingBackLeftBB = false;
				wallLPolishingBackRightBB = false;
				wallUPolishingBackLeftBB = false;
				wallUPolishingBackRightBB = false;
				if(benchtopShape == 'Straight') {
					$benchtopPlanner.find('.if-straight-bb').removeClass('shown');
					$benchtopPlanner.find('.if-straight, .unless-straight-bb').addClass('shown');
				} else if(benchtopShape == 'L-Shaped') {
					depth2 = defaultDepth;
					$benchtopPlanner.find('.if-l-bb, .if-l-bb-l, .if-l-bb-r').removeClass('shown');
					$benchtopPlanner.find('.if-l').addClass('shown');
				} else if(benchtopShape == 'U-Shaped') {
					depth2 = defaultDepth;
					depth3 = defaultDepth;
					$benchtopPlanner.find('.if-u-bb, .if-u-bb-l, .if-u-bb-r').removeClass('shown');
					$benchtopPlanner.find('.if-u').addClass('shown');
				}


				$('.bb-650-message').addClass('hide');
				$('.bb-99-message').addClass('hide');

				// Go to next step
				goToNextStepAndValidate(3);
			} else if(choiceText == 'Breakfast Bar') {
				breakfastBar = true;
				if(benchtopShape == 'Straight') {
					$benchtopPlanner.find('.if-straight, .unless-straight-bb').removeClass('shown');
					$benchtopPlanner.find('.if-straight-bb').addClass('shown');

					// The Straight BB layout shows .straight-polishing-back-rolled (a
					// static "Polished" indicator) instead of the back-wall radio. That
					// rolled edge is the BB itself and is always polished, so mirror
					// the L/U behaviour and flip the back-wall flag so polishingQty
					// and the cart property pick it up.
					wallStraightPolishingBack = true;

					// Go to next step
					goToNextStepAndValidate(3);
				} else if(benchtopShape == 'L-Shaped') {
					$benchtopPlanner.find('.if-l-bb').addClass('shown');
					if(breakfastBarSide == 'Left') {
						depth2 = defaultDepth;
						$benchtopPlanner.find('.if-l, .if-l-bb-r').removeClass('shown');
						$benchtopPlanner.find('.if-l-bb-l').addClass('shown');

						// Auto-polish the BB-side wall. In if-l-bb-l the LEFT side
						// becomes the rolled BB edge (.l-polishing-back-left-rolled),
						// so the *left* wall flag is the one to set — not the right.
						wallLPolishingBackLeftBB = true;
					} else if(breakfastBarSide == 'Right') {
						depth1 = defaultDepth;
						$benchtopPlanner.find('.if-l, .if-l-bb-l').removeClass('shown');
						$benchtopPlanner.find('.if-l-bb-r').addClass('shown');

						// Auto-polish the BB-side wall (right rolled edge).
						wallLPolishingBackRightBB = true;
					} else {
						// Don't reload the review image because the BB side isn't chosen yet
						dontReloadReviewImage = true;
					}
				} else if(benchtopShape == 'U-Shaped') {
					$benchtopPlanner.find('.if-u-bb').addClass('shown');
					if(breakfastBarSide == 'Left') {
						depth2 = defaultDepth;
						depth3 = defaultDepth;
						$benchtopPlanner.find('.if-u, .if-u-bb-r').removeClass('shown');
						$benchtopPlanner.find('.if-u-bb-l').addClass('shown');
						
						// Automatically set wall polishing for breakfast bar
						wallUPolishingBackLeftBB = true;
					} else if(breakfastBarSide == 'Right') {
						depth1 = defaultDepth;
						depth2 = defaultDepth;
						$benchtopPlanner.find('.if-u, .if-u-bb-l').removeClass('shown');
						$benchtopPlanner.find('.if-u-bb-r').addClass('shown');
						
						// Automatically set wall polishing for breakfast bar
						wallUPolishingBackRightBB = true;
					} else {
						// Don't reload the review image because the BB side isn't chosen yet
						dontReloadReviewImage = true;
					}
				}
			} else if(choiceText == 'Breakfast Bar on Left') {
				breakfastBarSide = 'Left';

				if(benchtopShape == 'L-Shaped') {
					joinType = 'Right';
					depth2 = defaultDepth;
					$benchtopPlanner.find('.if-l, .if-l-bb-r').removeClass('shown');
					$benchtopPlanner.find('.if-l-bb-l').addClass('shown');

					// Auto-polish the BB-side wall (left rolled edge).
					wallLPolishingBackLeftBB = true;
				} else if(benchtopShape == 'U-Shaped') {
					depth2 = defaultDepth;
					depth3 = defaultDepth;
					$benchtopPlanner.find('.if-u, .if-u-bb-r').removeClass('shown');
					$benchtopPlanner.find('.if-u-bb-l').addClass('shown');
					
					// Automatically set wall polishing for breakfast bar
					wallUPolishingBackLeftBB = true;
				}

				// Go to next step
				goToNextStepAndValidate(3);
			} else if(choiceText == 'Breakfast Bar on Right') {
				breakfastBarSide = 'Right';

				if(benchtopShape == 'L-Shaped') {
					joinType = 'Left';
					depth1 = defaultDepth;
					$benchtopPlanner.find('.if-l, .if-l-bb-l').removeClass('shown');
					$benchtopPlanner.find('.if-l-bb-r').addClass('shown');

					// Auto-polish the BB-side wall (right rolled edge).
					wallLPolishingBackRightBB = true;
				} else if(benchtopShape == 'U-Shaped') {
					depth1 = defaultDepth;
					depth2 = defaultDepth;
					$benchtopPlanner.find('.if-u, .if-u-bb-l').removeClass('shown');
					$benchtopPlanner.find('.if-u-bb-r').addClass('shown');
					
					// Automatically set wall polishing for breakfast bar
					wallUPolishingBackRightBB = true;
				}

				// Go to next step
				goToNextStepAndValidate(3);
			}

		// Material
		} else if(currentStep == 4) {
			benchMaterial = choiceText;
			if(benchMaterial == 'Laminate') {
				$benchtopPlanner.find('.step-5 .material-laminate').addClass('shown');
				$benchtopPlanner.find('.step-5 .material-stone').removeClass('shown');
				// Reset polishing states when switching away from stone
				leftPolishedTreated = false;
				rightPolishedTreated = false;
				leftWaterfall = false;
				rightWaterfall = false;
				wallPolished = false;
				wallPolishedList = [];

				// Clear stone material variants too. Otherwise a stale
				// materialProductID re-queues a stone material line during the
				// laminate add-to-cart (the push is guarded by `if(materialProductID)`),
				// which Shopify merges into the existing stone cart line and
				// reparents that stone benchtop under the new laminate bundle.
				materialProductID = null;
				leftWaterfallMaterialProductID = null;
				rightWaterfallMaterialProductID = null;
				$benchtopPlanner.find('.step-9 span.end-polishing-left').text('Unpolished');
				$benchtopPlanner.find('.step-9 span.end-polishing-right').text('Unpolished');
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Unpolished');

				$progress.find('.if-join').addClass('shown');
				$progress.find('.if-cut-outs').removeClass('shown');
				$progress.find('.if-stone-only').removeClass('shown');
				$benchtopPlanner.find('.step-content.if-join').addClass('shown');
				$benchtopPlanner.find('.step-content.if-cut-outs').removeClass('shown');
				$benchtopPlanner.find('.step.if-stone-only').removeClass('shown');

			} else {
				$benchtopPlanner.find('.step-5 .material-laminate').removeClass('shown');
				$benchtopPlanner.find('.step-5 .material-stone').addClass('shown');
				// Ensure default polishing summary
				$benchtopPlanner.find('.step-9 span.end-polishing-left').text('Unpolished');
				$benchtopPlanner.find('.step-9 span.end-polishing-right').text('Unpolished');
				$benchtopPlanner.find('.step-9 span.end-polishing-wall').text('Unpolished');

				$progress.find('.if-join').removeClass('shown');
				$progress.find('.if-cut-outs').addClass('shown');
				$progress.find('.if-stone-only').addClass('shown');
				$benchtopPlanner.find('.step-content.if-join').removeClass('shown');
				$benchtopPlanner.find('.step-content.if-cut-outs').addClass('shown');
				$benchtopPlanner.find('.step.if-stone-only').addClass('shown');
				// Ensure step 5 Next goes to cut-outs (step 6), not colour (step 7)
				// formatPrice() may have set this to #step-7 while benchMaterial was still the default 'Laminate'
				$step5Next.attr('href', '#step-6');

				// Run calculatePolishingPrice now that material is stone so any
				// BB-auto-set wall polishing (e.g. wallLPolishingBackRightBB,
				// set on step 2 before this handler runs) is counted into
				// polishingQty / polishingLongQty. Without this, a BB benchtop
				// whose user never touches a polishing radio would push 0
				// polishing lines despite the auto-selected wall end.
				calculatePolishingPrice();

				// Fetch colors for all three tiers with callback
				fetchAllTierColors(toggleStep7Colors);
			}
			
			// For laminate materials, toggle colors immediately
			if(benchMaterial == 'Laminate') {
				toggleStep7Colors();
			}
			
			// Make sure the correct Step 5 diagram is visible
if(benchtopShape == 'Straight') {
	$benchtopPlanner
		.find('.step-5 .if-straight, .step-5 .if-straight-bb')
		.removeClass('shown');

	if(breakfastBar) {
		$benchtopPlanner.find('.step-5 .if-straight-bb').addClass('shown');
	} else {
		$benchtopPlanner.find('.step-5 .if-straight').addClass('shown');
	}

} else if(benchtopShape == 'L-Shaped') {
	$benchtopPlanner
		.find('.step-5 .if-l, .step-5 .if-l-bb-l, .step-5 .if-l-bb-r')
		.removeClass('shown');

	if(!breakfastBar) {
		$benchtopPlanner.find('.step-5 .if-l').addClass('shown');
	} else if(breakfastBarSide == 'Left') {
		$benchtopPlanner.find('.step-5 .if-l-bb-l').addClass('shown');
	} else if(breakfastBarSide == 'Right') {
		$benchtopPlanner.find('.step-5 .if-l-bb-r').addClass('shown');
	}

} else if(benchtopShape == 'U-Shaped') {
	$benchtopPlanner
		.find('.step-5 .if-u, .step-5 .if-u-bb-l, .step-5 .if-u-bb-r')
		.removeClass('shown');

	if(!breakfastBar) {
		$benchtopPlanner.find('.step-5 .if-u').addClass('shown');
	} else if(breakfastBarSide == 'Left') {
		$benchtopPlanner.find('.step-5 .if-u-bb-l').addClass('shown');
	} else if(breakfastBarSide == 'Right') {
		$benchtopPlanner.find('.step-5 .if-u-bb-r').addClass('shown');
	}
}

			goToNextStepAndValidate(5);			
		// Join position
		} else if(currentStep == 6) {
			if(benchtopShape == 'L-Shaped') {
				if(choiceText == 'Left Join') {
					joinType = 'Left';
				} else if(choiceText == 'Right Join') {
					joinType = 'Right';
				}
			} else if(benchtopShape == 'U-Shaped') {
				if(choiceText == 'Inner Join') {
					joinType = 'RightLeft';
				} else if(choiceText == 'Outer Join') {
					joinType = 'LeftRight';
				} else if(choiceText == 'Left Join') {
					joinType = 'Left';
				} else if(choiceText == 'Right Join') {
					joinType = 'Right';
				}
			}

			// Go to next step
			goToNextStepAndValidate(7);
		
		// Colour
		} else if(currentStep == 7) {
			colour = choiceText;

			$benchtopPlanner.find('.step-9 p.benchtop-colour').text(colour);

			// If U-shaped, change colour of text overlapping the benchtop if it's a light colour
			if(benchtopShape == 'U-Shaped') {
				if(colour.indexOf("White") > -1 || colour.indexOf("Aurora") > -1) {
					$benchtopPlanner.find('.step-7 .if-u-any .diagram').addClass('light-colour');
				} else {
					$benchtopPlanner.find('.step-7 .if-u-any .diagram').removeClass('light-colour');
				}
			}

			// Go to next step - skip installation for laminate
			if(benchMaterial == 'Laminate') {
				goToNextStepAndValidate(9);
			} else {
				calculateSize();				
			}
		}

		// Update the review image (only runs if step 6 has been completed)
		updateReviewImage();
	});
	$benchtopPlanner.find('.step-9 .action-buttons button').on('click', function(e) {
		var $this = $(this),
		qty = parseInt($this.closest('.action-buttons').prev('.js-qty').find('input').val(), 10),
		joinCode1,
		joinCode1A,
		joinCode2,
		joinCode2A,
		joinCode3,
		joinCode3A,
		clashing1 = 'None',
		clashing1A = 'None',
		clashing2 = 'None',
		clashing2A = 'None',
		clashing3 = 'None',
		clashing3A = 'None',
		breakfastBar1 = 'No',
		breakfastBar2 = 'No',
		breakfastBar3 = 'No',
		benchtop1Properties = {},
		benchtop1AProperties = {},
		benchtop2Properties = {},
		benchtop2AProperties = {},
		benchtop3Properties = {},
		benchtop3AProperties = {},
		wallFinishing1 = false,
		wallFinishing2 = false,
		wallFinishing3 = false;

		//Disable add to cart button if enabled in settings
		// if(false  == true){
		// 	Swal.fire({
		// 		text: "SORRY the shop is temporaily closed as we are adjusting prices across our site. We hope to have the store back up and running within the next hour. ",
		// 		icon: 'warning',
		// 	});
		// 	return;
		// }
		
		// Disable button
		$this.prop('disabled', true).addClass('is-adding').siblings('button').prop('disabled', true);

		// Reset
		addtoCartQueue = [];

		// Calculate machine code
		if(benchtopShape == 'L-Shaped') {
			if(joinType == 'Left') {
				if(depth1 == 600) {
					joinCode1 = 'MR';
					joinCode2 = 'FL';
				} else {
					joinCode1 = 'MR' + depth1;
					joinCode2 = 'FL' + depth1;
				}
			} else if(joinType == 'Right') {
				if(depth2 == 600) {
					joinCode1 = 'FR';
					joinCode2 = 'ML';
				} else {
					joinCode1 = 'FR' + depth2;
					joinCode2 = 'ML' + depth2;
				}
			}

		} else if(benchtopShape == 'U-Shaped') {
			if(joinType == 'RightLeft') {
				if(depth2 == 600) {
					joinCode1 = 'FR';
					joinCode2 = 'ML MR';
					joinCode3 = 'FL';
				} else {
					joinCode1 = 'FR' + depth2;
					joinCode2 = 'ML' + depth2 + ' MR' + depth2;
					joinCode3 = 'FL' + depth2;
				}

			} else if(joinType == 'LeftRight') {
				if(depth1 == 600) {
					joinCode1 = 'MR';
					joinCode2 = 'FL';
				} else {
					joinCode1 = 'MR' + depth1;
					joinCode2 = 'FL' + depth1;
				}

				if(depth3 == 600) {
					joinCode2 += ' FR';
					joinCode3 = 'ML';
				} else {
					joinCode2 += ' FR' + depth3;
					joinCode3 = 'ML' + depth3;
				}
				
			} else if(joinType == 'Left') {
				if(depth1 == 600) {
					joinCode1 = 'MR';
					joinCode2 = 'FL';
				} else {
					joinCode1 = 'MR' + depth1;
					joinCode2 = 'FL' + depth1;
				}

				if(depth2 == 600) {
					joinCode2 += ' MR';
					joinCode3 = 'FL';
				} else {
					joinCode2 += ' MR' + depth2;
					joinCode3 = 'FL' + depth2;
				}

			} else if(joinType == 'Right') {
				if(depth2 == 600) {
					joinCode1 = 'FR';
					joinCode2 = 'ML';
				} else {
					joinCode1 = 'FR' + depth2;
					joinCode2 = 'ML' + depth2;
				}

				if(depth3 == 600) {
					joinCode2 += ' FR';
					joinCode3 = 'ML';
				} else {
					joinCode2 += ' FR' + depth3;
					joinCode3 = 'ML' + depth3;
				}
			}
		}

		// Adjust join codes if double pieces
		if(benchtopShape == 'Straight') {
			if(length1AFinal) {
				if(depth1 == 600) {
					joinCode1 = 'JR';
					joinCode1A = 'JL';
				} else {
					joinCode1 = 'JR' + depth1;
					joinCode1A = 'JL' + depth1;
				}
			}

		} else if(benchtopShape == 'L-Shaped' || benchtopShape == 'U-Shaped') {
			if(length1AFinal) {
				if(depth1 == 600) {
					joinCode1A = 'JL ' + joinCode1;
					joinCode1 = 'JR';
				} else {
					joinCode1A = 'JL' + depth1 + ' ' + joinCode1;
					joinCode1 = 'JR' + depth1;
				}
			}

			if(benchtopShape == 'L-Shaped') {
				if(length2AFinal) {
					if(depth2 == 600) {
						joinCode2 = joinCode2 + ' JR';
						joinCode2A = 'JL';
					} else {
						joinCode2 = joinCode2 + ' JR' + depth2;
						joinCode2A = 'JL' + depth2;
					}
				}
			}

			if(benchtopShape == 'U-Shaped') {
				if(length2AFinal) {
					var joinCode2Parts = joinCode2.split(' ');

					if(depth2 == 600) {
						joinCode2 = joinCode2Parts[0] + ' JR';
						joinCode2A = 'JL ' + joinCode2Parts[1];
					} else {
						joinCode2 = joinCode2Parts[0] + ' JR' + depth2;
						joinCode2A = 'JL' + depth2 + ' ' + joinCode2Parts[1];
					}
				}

				if(length3AFinal) {
					if(depth3 == 600) {
						joinCode3 = joinCode3 + ' JR';
						joinCode3A = 'JL';
					} else {
						joinCode3 = joinCode3 + ' JR' + depth3;
						joinCode3A = 'JL' + depth3;
					}
				}
			}
		}

		// Add clashing and breakfast bar info
		if(benchtopShape == 'Straight') {
			if(leftFinished && rightFinished) {
				clashing1 = 'Both Ends';
			} else if(leftFinished) {
				clashing1 = 'Left';
			} else if(rightFinished) {
				clashing1 = 'Right';
			}

			if(wallStraightFinishingBack){
				wallFinishing1 = true;
			}

			if(breakfastBar) {
				breakfastBar1 = 'Yes';
			}

		} else if(benchtopShape == 'L-Shaped') {
			if(leftFinished) {
				clashing1 = 'Left';
			}
			if(rightFinished) {
				clashing2 = 'Right';
			}

			if(joinType == 'Left') {
				if(wallLFinishingBackLeft){
					wallFinishing1 = true
					if(clashing2 == 'Right'){
						clashing2 = 'Both Ends'
					}
					else{
						clashing2 = 'Left'
					}
				}
				if(wallLFinishingBackRight){
					wallFinishing2 = true
				}
			} else if(joinType == 'Right') {
				if(wallLFinishingBackLeft){
					wallFinishing1 = true					
				}
				if(wallLFinishingBackRight){
					wallFinishing2 = true
					if(clashing1 == 'Left'){
						clashing1 = 'Both Ends'
					}
					else{
						clashing1 = 'Right'
					}
				}
			}

			if(breakfastBar) {
				if(breakfastBarSide == 'Left') {
					breakfastBar1 = 'Yes';
					if(wallLFinishingBackRightBB){
						wallFinishing2 = true
						if(clashing1 == 'Left'){
							clashing1 = 'Both Ends'
						}
						else{
							clashing1 = 'Right'
						}
					}
				} else if(breakfastBarSide == 'Right') {
					breakfastBar2 = 'Yes';
					if(wallLFinishingBackLeftBB){
						wallFinishing1 = true
						if(clashing2 == 'Right'){
							clashing2 = 'Both Ends'
						}
						else{
							clashing2 = 'Left'
						}
					}
				}
			}

		} else if(benchtopShape == 'U-Shaped') {
			if(leftFinished) {
				clashing1 = 'Left';
			}
			if(rightFinished) {
				clashing3 = 'Right';
			}

			if(joinType == 'RightLeft') {
				if(wallUFinishingBackLeft){
					wallFinishing1=true
				}
				if(wallUFinishingBackCentre){
					wallFinishing2=true
					if(clashing1 == 'Left'){
						clashing1 = 'Both Ends'
					}
					else{
						clashing1 = 'Right'
					}
					if(clashing3 == 'Right'){
						clashing3 = 'Both Ends'
					}
					else{
						clashing3 = 'Left'
					}
				}
				if(wallUFinishingBackRight){
					wallFinishing3=true
				}	
			} else if(joinType == 'LeftRight') {
				if(wallUFinishingBackLeft){
					wallFinishing1=true
					if(clashing2 == 'Right'){
						clashing2 = 'Both Ends'
					}
					else{
						clashing2 = 'Left'
					}
				}
				if(wallUFinishingBackCentre){
					wallFinishing2=true
				}
				if(wallUFinishingBackRight){
					wallFinishing3=true
					if(clashing2 == 'Left'){
						clashing2 = 'Both Ends'
					}
					else{
						clashing2 = 'Right'
					}
				}					
			} else if(joinType == 'Left') {
				if(wallUFinishingBackLeft){
					wallFinishing1=true
					if(clashing2 == 'Right'){
						clashing2 = 'Both Ends'
					}
					else{
						clashing2 = 'Left'
					}
				}
				if(wallUFinishingBackCentre){
					wallFinishing2=true
					if(clashing3 == 'Right'){
						clashing3 = 'Both Ends'
					}
					else{
						clashing3 = 'Left'
					}
				}
				if(wallUFinishingBackRight){
					wallFinishing3=true
				}							
			} else if(joinType == 'Right') {
				if(wallUFinishingBackLeft){
					wallFinishing1=true					
				}
				if(wallUFinishingBackCentre){
					wallFinishing2=true
					if(clashing1 == 'Left'){
						clashing1 = 'Both Ends'
					}
					else{
						clashing1 = 'Right'
					}
				}
				if(wallUFinishingBackRight){
					wallFinishing3=true
					if(clashing2 == 'Left'){
						clashing2 = 'Both Ends'
					}
					else{
						clashing2 = 'Right'
					}
				}			
			}

			if(breakfastBar) {
				if(breakfastBarSide == 'Left') {
					breakfastBar1 = 'Yes';
					if(joinType == 'RightLeft') {
						if(wallUFinishingBackCentreBBOnLeft){
							wallFinishing2=true
							if(clashing1 == 'Left'){
								clashing1 = 'Both Ends'
							}
							else{
								clashing1 = 'Right'
							}
							if(clashing3 == 'Right'){
								clashing3 = 'Both Ends'
							}
							else{
								clashing3 = 'Left'
							}
						}
						if(wallUFinishingBackRightBB){
							wallFinishing3=true
						}
					} else if(joinType == 'Right') {
						if(wallUFinishingBackCentreBBOnLeft){
							wallFinishing2=true
							if(clashing1 == 'Left'){
								clashing1 = 'Both Ends'
							}
							else{
								clashing1 = 'Right'
							}							
						}
						if(wallUFinishingBackRightBB){
							wallFinishing3=true
							if(clashing2 == 'Left'){
								clashing2 = 'Both Ends'
							}
							else{
								clashing2 = 'Right'
							}
						}		
					}
				} else if(breakfastBarSide == 'Right') {
					breakfastBar3 = 'Yes';
					if(joinType == 'RightLeft') {
						if(wallUFinishingBackLeftBB){
							wallFinishing1=true							
						}
						if(wallUFinishingBackCentreBBRJoin){
							wallFinishing2=true
							if(clashing1 == 'Left'){
								clashing1 = 'Both Ends'
							}
							else{
								clashing1 = 'Right'
							}
							if(clashing3 == 'Right'){
								clashing3 = 'Both Ends'
							}
							else{
								clashing3 = 'Left'
							}
						}
					} else if(joinType == 'Left') {
						if(wallUFinishingBackLeftBB){
							wallFinishing1=true
							if(clashing2 == 'Right'){
								clashing2 = 'Both Ends'
							}
							else{
								clashing2 = 'Left'
							}							
						}
						if(wallUFinishingBackCentreBBRJoin){
							wallFinishing2=true
							if(clashing3 == 'Right'){
								clashing3 = 'Both Ends'
							}
							else{
								clashing3 = 'Left'
							}
						}		
					}
				}
			}
		}

		// Adjust clashings if double pieces
		if(length1AFinal) {
			if(clashing1 == 'Both Ends') {
				clashing1 = 'Left';
				clashing1A = 'Right';
			} else if(clashing1 == 'Right') {
				clashing1 = 'None';
				clashing1A = 'Right';
			}
		}

		if(length2AFinal) {
			if(clashing2 == 'Right') {
				clashing2 = 'None';
				clashing2A = 'Right';
			}
		}

		if(length3AFinal) {
			if(clashing3 == 'Right') {
				clashing3 = 'None';
				clashing3A = 'Right';
			}
		}

		// Add benchtops
		// Only add the main benchtop product for Laminate
		if(benchMaterial == 'Laminate' && benchtop1ID) {
			// If double piece
			if(benchtop1AID) {
				benchtop1Properties = {
					'Depth': depth1 + 'mm',
					'Colour': colour,
					'_Join': joinCode1,
					'_Clashing': clashing1,
					'Shape': benchtopShape,
					'Breakfast Bar': breakfastBar1,
					'_customPrice': true,
					'_Plan_Type': 'Custom Benchtop',
					'_WallFinishing': wallFinishing1
				};

			// If normal piece
			} else {
				if(benchtopShape == 'Straight') {
					benchtop1Properties = {
						'Depth': depth1 + 'mm',
						'Colour': colour,
						'_Clashing': clashing1,
						'Shape': benchtopShape,
						'Breakfast Bar': breakfastBar1,
						'_customPrice': true,
						'_Plan_Type': 'Custom Benchtop',
						'_WallFinishing': wallFinishing1
					};
				} else if(benchtopShape == 'L-Shaped' || benchtopShape == 'U-Shaped') {
					benchtop1Properties = {
						'Depth': depth1 + 'mm',
						'Colour': colour,
						'_Join': joinCode1,
						'_Clashing': clashing1,
						'Shape': benchtopShape,
						'Breakfast Bar': breakfastBar1,
						'_customPrice': true,
						'_Plan_Type': 'Custom Benchtop',
						'_WallFinishing': wallFinishing1
					};
				}
			}

			addtoCartQueue.push({ 
				id: benchtop1ID, 
				quantity: qty,
				properties: benchtop1Properties
			});
		}

		if(benchMaterial == 'Laminate' && benchtop1AID) {
			benchtop1AProperties = {
				'Depth': depth1 + 'mm',
				'Colour': colour,
				'_Join': joinCode1A,
				'_Clashing': clashing1A,
				'Shape': benchtopShape,
				'Breakfast Bar': breakfastBar1,
				'_customPrice': true,
				'_Plan_Type': 'Custom Benchtop',
				'_WallFinishing': wallFinishing1
			};

			addtoCartQueue.push({ 
				id: benchtop1AID,
				quantity: qty,
				properties: benchtop1AProperties
			});
		}

		if(benchMaterial == 'Laminate' && benchtop2ID) {
			benchtop2Properties = {
				'Depth': depth2 + 'mm',
				'Colour': colour,
				'_Join': joinCode2,
				'_Clashing': clashing2,
				'Shape': benchtopShape,
				'Breakfast Bar': breakfastBar2,
				'_customPrice': true,
				'_Plan_Type': 'Custom Benchtop',
				'_WallFinishing': wallFinishing2
			};

			addtoCartQueue.push({ 
				id: benchtop2ID,
				quantity: qty,
				properties: benchtop2Properties
			});
		}

		if(benchMaterial == 'Laminate' && benchtop2AID) {
			benchtop2AProperties = {
				'Depth': depth2 + 'mm',
				'Colour': colour,
				'_Join': joinCode2A,
				'_Clashing': clashing2A,
				'Shape': benchtopShape,
				'Breakfast Bar': breakfastBar2,
				'_customPrice': true,
				'_Plan_Type': 'Custom Benchtop',
				'_WallFinishing': wallFinishing2
			};

			addtoCartQueue.push({ 
				id: benchtop2AID,
				quantity: qty,
				properties: benchtop2AProperties
			});
		}

		if(benchMaterial == 'Laminate' && benchtop3ID) {
			benchtop3Properties = {
				'Depth': depth3 + 'mm',
				'Colour': colour,
				'_Join': joinCode3,
				'_Clashing': clashing3,
				'Shape': benchtopShape,
				'Breakfast Bar': breakfastBar3,
				'_customPrice': true,
				'_Plan_Type': 'Custom Benchtop',
				'_WallFinishing': wallFinishing3
			};

			addtoCartQueue.push({ 
				id: benchtop3ID,
				quantity: qty,
				properties: benchtop3Properties
			});
		}

		if(benchMaterial == 'Laminate' && benchtop3AID) {
			benchtop3AProperties = {
				'Depth': depth3 + 'mm',
				'Colour': colour,
				'_Join': joinCode3A,
				'_Clashing': clashing3A,
				'Shape': benchtopShape,
				'Breakfast Bar': breakfastBar3,
				'_customPrice': true,
				'_Plan_Type': 'Custom Benchtop',
				'_WallFinishing': wallFinishing3
			};

			addtoCartQueue.push({ 
				id: benchtop3AID,
				quantity: qty,
				properties: benchtop3AProperties
			});
		}

		// Add end finishings
		if(endFinishingQty > 0) {
			addtoCartQueue.push({ 
				id: endFinishingID,
				quantity: (endFinishingQty * qty)
			});
		}

		if(endFinishingLongQty > 0) {
			addtoCartQueue.push({ 
				id: endFinishingLongID,
				quantity: (endFinishingLongQty * qty)
			});
		}
		// Add material (stone tiers) as selected variant id. This is a stone-only
		// line — never queue it for a laminate order, even if materialProductID is
		// stale from a previous stone configuration in the same session.
		if(benchMaterial != 'Laminate' && materialProductID){
			// Helper function to format cutout details with mount type and quantity
			function formatCutoutDetails(hasHob, hasTap, hasWindow, hobMount, hobQty, tapQty) {
				var parts = [];
				if(hasHob) {
					var hobDetail = 'Hob/Sink (' + hobMount + ', Qty: ' + hobQty + ')';
					parts.push(hobDetail);
				}
				if(hasTap) {
					var tapDetail = 'Tap/Water Filter (Qty: ' + tapQty + ')';
					parts.push(tapDetail);
				}
				if(hasWindow) parts.push('Window');
				return parts.length ? parts.join(', ') : 'None';
			}

			// Calculate total linear meters of polishing
			var totalPolishingMeters = 0;
			if(benchMaterial != 'Laminate') {
				if(leftPolishedTreated && !leftWaterfall) {
					totalPolishingMeters += (benchtopShape == 'Straight' ? depth1 : (benchtopShape == 'L-Shaped' ? depth1 : depth1)) / 1000;
				}
				if(rightPolishedTreated && !rightWaterfall) {
					totalPolishingMeters += (benchtopShape == 'Straight' ? depth1 : (benchtopShape == 'L-Shaped' ? depth2 : depth3)) / 1000;
				}
			}

			// Get dimension summary
			var dimensionSummary = '';
			if(benchtopShape == 'Straight') {
				dimensionSummary = length1 + 'mm × ' + depth1 + 'mm';
			} else if(benchtopShape == 'L-Shaped') {
				dimensionSummary = 'L1: ' + length1 + '×' + depth1 + 'mm, L2: ' + length2 + '×' + depth2 + 'mm';
			} else if(benchtopShape == 'U-Shaped') {
				dimensionSummary = 'L1: ' + length1 + '×' + depth1 + 'mm, L2: ' + length2 + '×' + depth2 + 'mm, L3: ' + length3 + '×' + depth3 + 'mm';
			}

			// Size in sqm (rounded up to 0.1) — matches the value used for tier
			// pricing and is also stored on the cart line so the back-end can
			// reconcile against client-side cost × markup math.
			var mainMaterialSize = Math.ceil(totalSquareMM / 1000000 * 100) / 100;

			addtoCartQueue.push({
				id: materialProductID,
				quantity: qty,
				properties: {
					// Basic product info
					'_customPrice': true,
					'_Plan_Type': 'Custom Benchtop',
					'_size': mainMaterialSize,
					'Shape': benchtopShape,
					'Colour': colour,
					'Dimensions': dimensionSummary,
					
					// Breakfast bars
					// Breakfast bars (shape-specific)
					...(benchtopShape == 'Straight' ? {
						'Breakfast_Bar_1': breakfastBar1
					} : {}),
					...(benchtopShape == 'L-Shaped' ? {
						'Breakfast_Bar_1': breakfastBar1,
						'Breakfast_Bar_2': breakfastBar2
					} : {}),
					...(benchtopShape == 'U-Shaped' ? {
						'Breakfast_Bar_1': breakfastBar1,
						'Breakfast_Bar_2': breakfastBar2,
						'Breakfast_Bar_3': breakfastBar3
					} : {}),
					
					// End polishing (stone only)
					...(benchMaterial != 'Laminate' ? {
						'_Left_End_Polish': leftPolishedTreated && !leftWaterfall ? 'Polished' : (leftWaterfall ? 'Waterfall' : 'Unpolished'),
						'_Right_End_Polish': rightPolishedTreated && !rightWaterfall ? 'Polished' : (rightWaterfall ? 'Waterfall' : 'Unpolished'),
						'_Left_Waterfall': leftWaterfall ? 'Yes' : 'No',
						'_Right_Waterfall': rightWaterfall ? 'Yes' : 'No',
						
						// Wall end polishing by shape
						...(benchtopShape == 'Straight' ? {
							'_Wall_End_Polish': wallStraightPolishingBack ? 'Polished' : 'Unpolished'
						} : {}),
						...(benchtopShape == 'L-Shaped' ? {
							// OR with the BB-variant flags so the BB-auto-polished
							// rolled edge is reflected on the cart line, matching
							// what updateReviewDetails shows on the review step.
							'_Left_Wall_End_Polish': (wallLPolishingBackLeft || wallLPolishingBackLeftBB) ? 'Polished' : 'Unpolished',
							'_Right_Wall_End_Polish': (wallLPolishingBackRight || wallLPolishingBackRightBB) ? 'Polished' : 'Unpolished'
						} : {}),
						...(benchtopShape == 'U-Shaped' ? {
							'_Left_Wall_End_Polish': (wallUPolishingBackLeft || wallUPolishingBackLeftBB) ? 'Polished' : 'Unpolished',
							'_Centre_Wall_End_Polish': (wallUPolishingBackCentre || wallUPolishingBackCentreBBOnLeft || wallUPolishingBackCentreBBRJoin) ? 'Polished' : 'Unpolished',
							'_Right_Wall_End_Polish': (wallUPolishingBackRight || wallUPolishingBackRightBB) ? 'Polished' : 'Unpolished'
						} : {})
					} : {}),
					
					// Common cutout details (applies to all shapes)
					'_Sink_Tap_Cutout': sinkTapCutout ? 'Yes (' + sinkTapMount + ', Qty: ' + sinkTapQty + ')' : 'No',
					'_Hob_Cutout': hobCutout ? 'Yes (' + hobMount + ', Qty: ' + hobQty + ')' : 'No',
					'_Air_Switch_Cutout': airSwitchCutout ? 'Yes (Qty: ' + airSwitchQty + ')' : 'No',
					
					// Installation details
					'_Installation_Required': needInstallation ? 'Yes' : 'No',
					'_Install_Contact_Name': installContactName || '',
					'_Install_Contact_Phone': installContactNumber || '',
					'_Install_Postcode': installPostcode || '',
				}
			});
		}

		// Add waterfall material products (stone only)
		// Merge into one item with qty 2 when both waterfalls have the same product ID
		if(benchMaterial != 'Laminate') {
			var hasLeft = leftWaterfallArea > 0 && leftWaterfallMaterialProductID;
			var hasRight = rightWaterfallArea > 0 && rightWaterfallMaterialProductID;
			var canMerge = hasLeft && hasRight && leftWaterfallMaterialProductID == rightWaterfallMaterialProductID && leftWaterfallArea == rightWaterfallArea;

			var leftWfSize = hasLeft ? Math.ceil(leftWaterfallArea / 1000000 * 100) / 100 : 0;
			var rightWfSize = hasRight ? Math.ceil(rightWaterfallArea / 1000000 * 100) / 100 : 0;

			if(canMerge) {
				addtoCartQueue.push({
					id: leftWaterfallMaterialProductID,
					quantity: qty * 2,
					properties: {
						'_Plan_Type': 'Custom Benchtop',
						'_Waterfall': 'True',
						'_size': leftWfSize,
						'_customPrice': true, 'Component': 'Waterfall - Left & Right',
						'Colour': colour,
						'_Left_Waterfall': 'Yes',
						'_Right_Waterfall': 'Yes',
						'_Waterfall_Area': Math.ceil(leftWaterfallArea / 1000000 * 100) / 100 + ' sqm (each)',
						'_Waterfall_Side': 'Both'
					}
				});
			} else {
				if(hasLeft) {
					addtoCartQueue.push({
						id: leftWaterfallMaterialProductID,
						quantity: qty,
						properties: {
							'_Plan_Type': 'Custom Benchtop',
							'_Waterfall': 'True',
							'_size': leftWfSize,
							'_customPrice': true, 'Component': 'Waterfall - Left',
							'Colour': colour,
							'_Left_Waterfall': 'Yes',
							'_Right_Waterfall': 'No',
							'_Waterfall_Area': Math.ceil(leftWaterfallArea / 1000000 * 100) / 100 + ' sqm',
							'_Waterfall_Side': 'Left'
						}
					});
				}
				if(hasRight) {
					addtoCartQueue.push({
						id: rightWaterfallMaterialProductID,
						quantity: qty,
						properties: {
							'_Plan_Type': 'Custom Benchtop',
							'_Waterfall': 'True',
							'_size': rightWfSize,
							'_customPrice': true, 'Component': 'Waterfall - Right',
							'Colour': colour,
							'_Left_Waterfall': 'No',
							'_Right_Waterfall': 'Yes',
							'_Waterfall_Area': Math.ceil(rightWaterfallArea / 1000000 * 100) / 100 + ' sqm',
							'_Waterfall_Side': 'Right'
						}
					});
				}
			}
		}

		// Add combined waterfall material product for backward compatibility (if both exist but no separate products)
		if(benchMaterial != 'Laminate' && waterfallArea > 0 && waterfallMaterialProductID && !leftWaterfallMaterialProductID && !rightWaterfallMaterialProductID) {
			addtoCartQueue.push({
				id: waterfallMaterialProductID,
				quantity: qty,
				properties: {
					'_Plan_Type': 'Custom Benchtop',
					'_Waterfall': 'True',
					'_size': Math.ceil(waterfallArea / 1000000 * 100) / 100,
					'_customPrice': true, 'Component': 'Waterfall',
					'Colour': colour,
					'_Left_Waterfall': leftWaterfall ? 'Yes' : 'No',
					'_Right_Waterfall': rightWaterfall ? 'Yes' : 'No',
					'_Waterfall_Area': Math.ceil(waterfallArea / 1000000 * 100) / 100 + ' sqm'
				}
			});
		}

		// Stone-only extras
		if(benchMaterial != 'Laminate'){
			// Polishing standard/long
			if(polishingQty > 0 && polishingID){
				addtoCartQueue.push({
					id: polishingID,
					quantity: polishingQty * qty,
					properties: {
						'_PolishingEnds': polishingQty,
						'_LeftPolished': leftPolishedTreated && !leftWaterfall ? 'Yes' : 'No',
						'_RightPolished': rightPolishedTreated && !rightWaterfall ? 'Yes' : 'No',
						'_WallStraight': wallStraightPolishingBack ? 'Yes' : 'No',
						'_WallLBackLeft': wallLPolishingBackLeft ? 'Yes' : 'No',
						'_WallLBackRight': wallLPolishingBackRight ? 'Yes' : 'No',
						'_WallLBackRightBB': wallLPolishingBackRightBB ? 'Yes' : 'No',
						'_WallLBackLeftBB': wallLPolishingBackLeftBB ? 'Yes' : 'No',
						'_WallUBackLeft': wallUPolishingBackLeft ? 'Yes' : 'No',
						'_WallUBackCentre': wallUPolishingBackCentre ? 'Yes' : 'No',
						'_WallUBackRight': wallUPolishingBackRight ? 'Yes' : 'No',
						'_WallUBackCentreBBOnLeft': wallUPolishingBackCentreBBOnLeft ? 'Yes' : 'No',
						'_WallUBackRightBB': wallUPolishingBackRightBB ? 'Yes' : 'No',
						'_WallUBackLeftBB': wallUPolishingBackLeftBB ? 'Yes' : 'No',
						'_WallUBackCentreBBRJoin': wallUPolishingBackCentreBBRJoin ? 'Yes' : 'No'
					}
				});
			}
			if(polishingLongQty > 0 && polishingLongID){
				addtoCartQueue.push({
					id: polishingLongID,
					quantity: polishingLongQty * qty,
					properties: {
						'_PolishingEndsLong': polishingLongQty,
						'_LeftPolishedLong': leftPolishedTreated && !leftWaterfall && ((benchtopShape=='Straight' && depth1>longEndPolishing) || (benchtopShape=='L-Shaped' && depth1>longEndPolishing) || (benchtopShape=='U-Shaped' && depth1>longEndPolishing)) ? 'Yes' : 'No',
						'_RightPolishedLong': rightPolishedTreated && !rightWaterfall && ((benchtopShape=='Straight' && depth1>longEndPolishing) || (benchtopShape=='L-Shaped' && depth2>longEndPolishing) || (benchtopShape=='U-Shaped' && depth3>longEndPolishing)) ? 'Yes' : 'No'
					}
				});
			}
			// Waterfall service product(s): merge into one line item when both sides use the same variant
			var leftWfWidth = leftWaterfall ? depth1 : null;
			var leftWfVariantID = leftWaterfall ? (leftWfWidth <= 600 ? waterfallStandardID : waterfallLargeID) : null;
			var leftWfSize = leftWaterfall ? (leftWfWidth <= 600 ? 'Standard' : 'Large') : null;

			var rightWfWidth = rightWaterfall ? (benchtopShape == 'Straight' ? depth1 : (benchtopShape == 'L-Shaped' ? depth2 : depth3)) : null;
			var rightWfVariantID = rightWaterfall ? (rightWfWidth <= 600 ? waterfallStandardID : waterfallLargeID) : null;
			var rightWfSize = rightWaterfall ? (rightWfWidth <= 600 ? 'Standard' : 'Large') : null;

			if(leftWfVariantID && rightWfVariantID && leftWfVariantID === rightWfVariantID){
				addtoCartQueue.push({
					id: leftWfVariantID,
					quantity: qty * 2,
					properties: {
						'_LeftWaterfall': 'Yes',
						'_RightWaterfall': 'Yes',
						'_Waterfall_Side': 'Both',
						'_Waterfall_Size': leftWfSize,
						'_Waterfall_Area': (Math.ceil(leftWaterfallArea / 1000000 * 100) / 100) + ' sqm + ' + (Math.ceil(rightWaterfallArea / 1000000 * 100) / 100) + ' sqm'
					}
				});
			} else {
				if(leftWfVariantID){
					addtoCartQueue.push({
						id: leftWfVariantID,
						quantity: qty,
						properties: {
							'_LeftWaterfall': 'Yes',
							'_RightWaterfall': 'No',
							'_Waterfall_Side': 'Left',
							'_Waterfall_Size': leftWfSize,
							'_Waterfall_Area': Math.ceil(leftWaterfallArea / 1000000 * 100) / 100 + ' sqm'
						}
					});
				}
				if(rightWfVariantID){
					addtoCartQueue.push({
						id: rightWfVariantID,
						quantity: qty,
						properties: {
							'_LeftWaterfall': 'No',
							'_RightWaterfall': 'Yes',
							'_Waterfall_Side': 'Right',
							'_Waterfall_Size': rightWfSize,
							'_Waterfall_Area': Math.ceil(rightWaterfallArea / 1000000 * 100) / 100 + ' sqm'
						}
					});
				}
			}
			// Separate Sink/Tap Cutout
			if(sinkTapCutout && sinkTapQty > 0) {
				var sinkTapCutoutVariantID, sinkTapCutoutVariantPrice;
				
				// Select correct variant based on mounting type
				if(sinkTapMount === 'Top mounted' && cutoutTopID) {
					sinkTapCutoutVariantID = cutoutTopID;
					sinkTapCutoutVariantPrice = cutoutTopPrice;
				} else if(sinkTapMount === 'Under mounted' && cutoutUnderID) {
					sinkTapCutoutVariantID = cutoutUnderID;
					sinkTapCutoutVariantPrice = cutoutUnderPrice;
				} else {
					// Fallback to original cutout product
					sinkTapCutoutVariantID = cutoutID;
					sinkTapCutoutVariantPrice = cutoutPrice;
				}
				
				if(sinkTapCutoutVariantID) {
					addtoCartQueue.push({
						id: sinkTapCutoutVariantID,
						quantity: sinkTapQty * qty,
						properties: {
							'Cutout Type': 'Sink/Tap',
							'_Mount_Type': sinkTapMount,
							'_Quantity': sinkTapQty
						}
					});
				}
			}

			// Separate Hob Cutout (always top mounted)
			if(hobCutout && hobQty > 0) {
				var hobCutoutVariantID, hobCutoutVariantPrice;
				
				// Hob is always top mounted
				if(cutoutTopID) {
					hobCutoutVariantID = cutoutTopID;
					hobCutoutVariantPrice = cutoutTopPrice;
				} else {
					// Fallback to original cutout product
					hobCutoutVariantID = cutoutID;
					hobCutoutVariantPrice = cutoutPrice;
				}
				
				if(hobCutoutVariantID) {
					addtoCartQueue.push({
						id: hobCutoutVariantID,
						quantity: hobQty * qty,
						properties: {
							'Cutout Type': 'Hob',
							'_Mount_Type': 'Top mounted', // Hob is always top mounted
							'_Quantity': hobQty
						}
					});
				}
			}
			// Air Switch / Water Filter (using tapholeID)
			if(tapholeQty > 0 && tapholeID){
				addtoCartQueue.push({
					id: tapholeID,
					quantity: tapholeQty * qty,
					properties: {
						'_Air_Switch_Cutout': airSwitchCutout ? 'Yes' : 'No',
						'_Air_Switch_Qty': airSwitchCutout ? airSwitchQty : 0,
						'_Total_Taphole_Qty': tapholeQty
					}
				});
			}
			if(windowCutoutQty > 0 && windowCutoutID){
				addtoCartQueue.push({
					id: windowCutoutID,
					quantity: windowCutoutQty * qty,
					properties: {
						'_StraightBackWindow': straightCutoutWindow ? 'Yes' : 'No',
						'_LBackLeftWindow': lCutoutBackLeftWindow ? 'Yes' : 'No',
						'_LBackRightWindow': lCutoutBackRightWindow ? 'Yes' : 'No',
						'_UBackLeftWindow': uCutoutBackLeftWindow ? 'Yes' : 'No',
						'_UBackCentreWindow': uCutoutBackCentreWindow ? 'Yes' : 'No',
						'_UBackRightWindow': uCutoutBackRightWindow ? 'Yes' : 'No'
					}
				});
			}
			// Installation fees
			// Always push the fee + travel when the customer has asked for
			// installation. The "only one fee per cart" rule (CAB-425 comment
			// 450820) is enforced by dedupeInstallationFeesFromQueue, which
			// re-checks the live cart at cart-add time — using the flag here
			// (or installationFeePrice, which calculateInstallationPrice zeroes
			// when the flag is set) skips the push for the FIRST benchtop too
			// if the cart had stale fee variants from a prior session.
			if(needInstallation){
				var withJoints = joinQty > 0;
				var feeVariantId = withJoints ? installFeeIDWithJoints : installFeeIDNoJoints;
				if(feeVariantId){
					addtoCartQueue.push({
						id: feeVariantId,
						quantity: qty,
						properties: { '_WithJoints': withJoints ? 'Yes' : 'No' } 
					});
				}
				if(installTravelProduct && installTravelDefaultID){
					addtoCartQueue.push({
						id: installTravelDefaultID,
						quantity: qty,
						properties: { '_postcode': installPostcode, '_customPrice': true }
					});
				}
			}
		}

		// Add join(s)
		if(joinQty > 0) {
			if(benchMaterial == 'Laminate'){
				addtoCartQueue.push({ 
					id: joinID,
					quantity: (joinQty * qty)
				});

				
				if(!$('[data-cart-variant-ids]').attr('data-cart-variant-ids').includes(glueID)){
					// Get an array of all data-variant-id values
					const variantIds = $('.ajaxcart__row[data-variant-id]').map(function() {
						return $(this).data('variant-id');
					}).get();
					if(!variantIds.includes(glueID)){
						addtoCartQueue.push({ 
							id: glueID,
							quantity: 1
						});
					}
				}			
			}
			else{
				addtoCartQueue.push({ 
					id: stoneJoinID,
					quantity: (joinQty * qty)
				});
			}
		}

		//Warning popup for customers when they add a saved bench top plan to their shopping cart
		if(addtoCartQueue.length && customerID && !firstSave) {
			Swal.fire({
			text: 'Warning. if you have made any changes to your final cabinet plan you need to DOUBLE CHECK that your bench tops will still fit',
			  icon: 'warning',
			}).then((result) => {
			  if (result.isConfirmed) {
				if($this.hasClass('add-another')) {
					addAnother = true;
				}
				ajaxAddtoCart();
			  }
			});
			return;
		}

		else if(addtoCartQueue.length) {
			if($this.hasClass('add-another')) {
				addAnother = true;
			}
			ajaxAddtoCart();
		}

		e.preventDefault();
	});
	
	$savedPlan.find('.open-saved-plan').on('click', function() {
		var $this = $(this),
		$allChoices = $savedPlan.find('.products-list'),
		choiceText = $this.text();


		// Mark choice as selected
		$this.addClass('selected').parent('.grid__item').siblings().find('.open-saved-plan').removeClass('selected');

		if(choiceText == 'Create New Plan') {
			if(totalPlan >= totalAllowed) {
				return swal.fire("You can not add more plans.",`The maximum allowrence for saved plan is ${totalAllowed}.`,"warning");
			}
			createNewPlan();
		} else if(choiceText == 'Open Saved Plan') {
			if(customerID) {
				if(!$allChoices.hasClass('is-loading')) {
					if(totalPlan > 0) {
						return window.location.href = '/account';
					}
					findPlanToLoad();
				}
			} else {
				// Show login popup
				$fullOverlay.addClass('shown');
				$customerForm.addClass('shown');
			}
		}
	});

	//Planner summary save button
	$(document).on('click', '.planner-summary-btn-save', function(e) {
		e.preventDefault();

		$saveButton = $('.btn-save');
		
		// Only run if not already running
		if(!$saveButton.hasClass('is-saving')) {
			if(customerID) {
				savePlan();
			} else {
				// Show login popup
				$fullOverlay.addClass('shown');
				$customerForm.addClass('shown');
				$login.addClass('register-shown');
				savePlanAfterLogin = true;
			}
		}
	});


	// Login form submit
	$login.find('form').find('.btn-login').on('click', function(e) {
		var $this = $login.find('form'),
		$loginButton = $this.find('button.btn-login'),
		$formError = $this.find('.form-error'),
		$email = $this.find('input#login-email'),
		$password = $this.find('input#login-password'),
		sendForm = true;

		e.preventDefault();

		// Clear old errors
		$formError.removeClass('shown').empty();
		$email.removeClass('error');
		$password.removeClass('error');

		if($email.val() == '') {
			addFormError($email, 'Please enter your email address.');
			sendForm = false;

		} else if(!$email.val().match(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)) {
			addFormError($email, 'Please check your email address is valid.');
			sendForm = false;
		}

		if($password.val() == '') {
			addFormError($password, 'Please enter a password.');
			sendForm = false;
		}

		if(sendForm) {
			$loginButton.prop('disabled', true).addClass('is-loading');

			// Send login form
			$.ajax({
				method: 'POST',
				url: '/account/login',
				data: $this.serialize(),
				dataType: 'html',
				timeout: 15000,
				cache: false
			}).done(function(response) {
				var $response = $(response),
				$responseTextLinks = $response.find('.site-header--text-links'),
				$responseMobileLinks = $response.find('.mobile-customer-nav'),
				$responseDesktopLinks = $response.find('.header-content .account-links'),
				$responsePlanOptions = $response.find('select#plan-to-load').children(),
				$responseCustomerID = $response.find('#ajax-customer-id'),
				$responsePlanID = $response.find('#ajax-plan-id'),
				responsePlanTitle = $response.find('input#plan-title').val(),
				customerIDFound = false,
				planIDFound = false;
				customerTags = $response.find('[data-customer-tags]').data('customerTags');

				// Done loading
				$loginButton.prop('disabled', false).removeClass('is-loading');

				// Invalid password
				if(response.indexOf('Invalid login credentials') !== -1) {
					$formError.addClass('shown').html('Invalid login credentials.');
				// Success
				} else {
					// Update customer ID
					if($responseCustomerID.length) {
						if($responseCustomerID.val()) {
							customerID = $responseCustomerID.val();
							customerIDFound = true;
						}
					}

					// Update plan ID
					if($responsePlanID.length) {
						if($responsePlanID.val()) {
							planID = $responsePlanID.val();
							planIDFound = true;
						}
					}

					if(customerIDFound && planIDFound) {
						// Show logged in as
						if($responseTextLinks.length) {
							$('.site-header--text-links').replaceWith($responseTextLinks);
						}

						// Show logged in as (mobile)
						if($responseMobileLinks.length) {
							$('.mobile-customer-nav').replaceWith($responseMobileLinks);
						}

						// Show logged in (desktop)
						if($responseDesktopLinks.length){
							$('.header-content .account-links').replaceWith($responseDesktopLinks);
						}

						// Load plans into select
						if($responsePlanOptions.length) {
							$planToLoad.empty().append($responsePlanOptions);
						}

						// Update plan title
						if(responsePlanTitle) {
							$planTitle.val(responsePlanTitle);
						}

						// Hide login box
						$customerForm.removeClass('shown');
						$fullOverlay.removeClass('shown');

						// If save button was clicked without being logged in
						if(savePlanAfterLogin) {
							savePlan();

						// If load button was clicked without being logged in
						} else {
							// Start the load
							findPlanToLoad();
						}
					} else {
						// Try loading page again (because IE is 'special')
						$loginButton.prop('disabled', true).addClass('is-loading');

						$.ajax({
							url: '/collections/custom-benchtops',
							timeout: 15000,
							cache: false
						}).done(function(response) {
							var $response = $(response),
							$responseTextLinks = $response.find('.site-header--text-links'),
							$responseMobileLinks = $response.find('.mobile-customer-nav'),
							$responseDesktopLinks = $response.find('.header-content .account-links'),
							$responsePlanOptions = $response.find('select#plan-to-load').children(),
							$responseCustomerID = $response.find('#ajax-customer-id'),
							$responsePlanID = $response.find('#ajax-plan-id'),
							responsePlanTitle = $response.find('input#plan-title').val(),
							customerIDFound = false,
							planIDFound = false;

							// Update customer ID
							if($responseCustomerID.length) {
								if($responseCustomerID.val()) {
									customerID = $responseCustomerID.val();
									customerIDFound = true;
								}
							}

							// Update plan ID
							if($responsePlanID.length) {
								if($responsePlanID.val()) {
									planID = $responsePlanID.val();
									planIDFound = true;
								}
							}

							if(customerIDFound && planIDFound) {
								// Show logged in as
								if($responseTextLinks.length) {
									$('.site-header--text-links').replaceWith($responseTextLinks);
								}

								// Show logged in as (mobile)
								if($responseMobileLinks.length) {
									$('.mobile-customer-nav').replaceWith($responseMobileLinks);
								}

								// Show logged in (desktop)
								if($responseDesktopLinks.length){
									$('.header-content .account-links').replaceWith($responseDesktopLinks);
								}

								// Load plans into select
								if($responsePlanOptions.length) {
									$planToLoad.empty().append($responsePlanOptions);
								}

								// Update plan title
								if(responsePlanTitle) {
									$planTitle.val(responsePlanTitle);
								}

								// Hide login box
								$customerForm.removeClass('shown');
								$fullOverlay.removeClass('shown');

								// If save button was clicked without being logged in
								if(savePlanAfterLogin) {
									savePlan();

								// If load button was clicked without being logged in
								} else {
									// Start the load
									findPlanToLoad();
								}
							} else {
								$formError.addClass('shown').html('Error loading customer information, please try again.');
							}
						}).fail(function() {
							$formError.addClass('shown').html('Error logging in, please try again.');
						}).always(function() {
							$loginButton.prop('disabled', false).removeClass('is-loading');
						});
					}
				}
			}).fail(function() {
				$loginButton.prop('disabled', false).removeClass('is-loading');
				$formError.addClass('shown').html('Error logging in, please try again.');
			});
		}
	});

	// Login form cancel
	$login.find('.action-buttons a.cancel').on('click', function(e) {
		e.preventDefault();

		// Close popup
		hideLogin();
	});

	// Show register screen
	$login.find('a.go-to').on('click', function(e) {
		e.preventDefault();

		$login.removeClass('shown');
		$register.addClass('shown');
	});
	// Register form submit
	$register.find('form').find('.btn-register').on('click', function(e) {
		var $this = $register.find('form'),
		$registerButton = $this.find('button.btn-register'),
		$formError = $this.find('.form-error'),
		$firstName = $this.find('input#register-first-name'),
		$lastName = $this.find('input#register-last-name'),
		$email = $this.find('input#register-email'),
		$password = $this.find('input#register-password'),
		sendForm = true;

		e.preventDefault();

		// Clear old errors
		$formError.removeClass('shown').empty();
		$firstName.removeClass('error');
		$lastName.removeClass('error');
		$email.removeClass('error');
		$password.removeClass('error');

		if($firstName.val() == '') {
			addFormError($firstName, 'Please enter your first name.');
			sendForm = false;
		}

		if($lastName.val() == '') {
			addFormError($lastName, 'Please enter your last name.');
			sendForm = false;
		}

		if($email.val() == '') {
			addFormError($email, 'Please enter your email address.');
			sendForm = false;

		} else if(!$email.val().match(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)) {
			addFormError($email, 'Please check your email address is valid.');
			sendForm = false;
		}

		if($password.val() == '') {
			addFormError($password, 'Please enter a password.');
			sendForm = false;
		} else if($password.val().length < 5) {
			addFormError($password, 'The password is too short (minimum is 5 characters).');
			sendForm = false;
		}

		if(sendForm) {
			$registerButton.prop('disabled', true).addClass('is-loading');

			// Send login form
			$.ajax({
				method: 'POST',
				url: '/account',
				data: $this.serialize(),
				dataType: 'html',
				timeout: 15000,
				cache: false
			}).done(function(response) {
				var $response = $(response),
				$responseTextLinks = $response.find('.site-header--text-links'),
				$responseMobileLinks = $response.find('.mobile-customer-nav'),
				$responseDesktopLinks = $response.find('.header-content .account-links'),
				$responseCustomerID = $response.find('#ajax-customer-id'),
				$responsePlanID = $response.find('#ajax-plan-id'),
				responsePlanTitle = $response.find('input#plan-title').val(),
				customerIDFound = false,
				planIDFound = false;
				customerTags = $response.find('[data-customer-tags]').data('customerTags');

				// Done loading
				$registerButton.prop('disabled', false).removeClass('is-loading');

				// Invalid email
				if(response.indexOf('email is invalid') !== -1) {
					$formError.addClass('shown').html('Please check your email address is valid.');

				// Success
				} else {
					// Update customer ID
					if($responseCustomerID.length) {
						if($responseCustomerID.val()) {
							customerID = $responseCustomerID.val();
							customerIDFound = true;
						}
					}

					// Update plan ID
					if($responsePlanID.length) {
						if($responsePlanID.val()) {
							planID = $responsePlanID.val();
							planIDFound = true;
						}
					}

					if(customerIDFound){
						$.ajax({
							method: 'POST',
							url: planner_api_url + '/customer/update',
							data: JSON.stringify({
								customer_id: customerID,
								customer_tag: $this.find('select#register-customer-type').val()
							}),
							timeout: 15000,
							cache: false,
							contentType: "application/json"
						})
					}

					if(customerIDFound && planIDFound) {
						// Show logged in as
						if($responseTextLinks.length) {
							$('.site-header--text-links').replaceWith($responseTextLinks);
						}

						// Show logged in as (mobile)
						if($responseMobileLinks.length) {
							$('.mobile-customer-nav').replaceWith($responseMobileLinks);
						}

						// Show logged in (desktop)
						if($responseDesktopLinks.length){
							$('.header-content .account-links').replaceWith($responseDesktopLinks);
						}

						// Update plan title
						if(responsePlanTitle) {
							$planTitle.val(responsePlanTitle);
						}

						// Hide login box
						$customerForm.removeClass('shown');
						$fullOverlay.removeClass('shown');

						// Save plan
						savePlan();
					} else {
						// Try loading page again (because IE is 'special')
						$registerButton.prop('disabled', true).addClass('is-loading');

						$.ajax({
							url: '/collections/custom-benchtops',
							timeout: 15000,
							cache: false
						}).done(function(response) {
							var $response = $(response),
							$responseTextLinks = $response.find('.site-header--text-links'),
							$responseMobileLinks = $response.find('.mobile-customer-nav'),
							$responseDesktopLinks = $response.find('.header-content .account-links'),
							$responseCustomerID = $response.find('#ajax-customer-id'),
							$responsePlanID = $response.find('#ajax-plan-id'),
							responsePlanTitle = $response.find('input#plan-title').val(),
							customerIDFound = false,
							planIDFound = false;

							// Update customer ID
							if($responseCustomerID.length) {
								if($responseCustomerID.val()) {
									customerID = $responseCustomerID.val();
									customerIDFound = true;
								}
							}

							// Update plan ID
							if($responsePlanID.length) {
								if($responsePlanID.val()) {
									planID = $responsePlanID.val();
									planIDFound = true;
								}
							}

							if(customerIDFound && planIDFound) {
								// Show logged in as
								if($responseTextLinks.length) {
									$('.site-header--text-links').replaceWith($responseTextLinks);
								}

								// Show logged in as (mobile)
								if($responseMobileLinks.length) {
									$('.mobile-customer-nav').replaceWith($responseMobileLinks);
								}

								// Show logged in (desktop)
								if($responseDesktopLinks.length){
									$('.header-content .account-links').replaceWith($responseDesktopLinks);
								}

								// Update plan title
								if(responsePlanTitle) {
									$planTitle.val(responsePlanTitle);
								}

								// Hide login box
								$customerForm.removeClass('shown');
								$fullOverlay.removeClass('shown');

								// Save plan
								savePlan();
							} else {
								$formError.addClass('shown').html('Error loading customer information, please try again. (An account may already exist with this email address.)');
							}
						}).fail(function() {
							$formError.addClass('shown').html('Error creating account, please try again.');
						}).always(function() {
							$registerButton.prop('disabled', false).removeClass('is-loading');
						});
					}
				}
			}).fail(function() {
				$registerButton.prop('disabled', false).removeClass('is-loading');
				$formError.addClass('shown').html('Error creating account, please try again.');
			});
		}
	});

	// Register form cancel
	$register.find('.action-buttons a.cancel').on('click', function(e) {
		e.preventDefault();

		// Close popuply
		hideRegister();
	});

    


	function initAutoLoad() {
		const uuid = new URLSearchParams(window.location.search).get('plan-id');
		if(uuid) {
			planToLoad = uuid;
			// $fullOverlay.addClass('shown');
			// $loadOptions.addClass('shown');

			loadSavedPlan();
		}
		return;
	}

	function findPlanToLoad() {
		// If there's more than one plan
		if(planID > 2) {
			// Show plans popup
			$fullOverlay.addClass('shown');
			$loadOptions.addClass('shown');

		// One saved plan
		} else if(planID == 2) {
			planToLoad = 1;

			// Show loading popup
			$fullOverlay.addClass('shown');
			$loadOptions.addClass('shown');

			loadSavedPlan();

		// No saved plans
		} else {
			// Show plans popup
			$fullOverlay.addClass('shown');
			$loadOptions.addClass('shown');

			// Show no plans message
			$loadOptions.find('.step-form').removeClass('shown').siblings('.step-no-plans').addClass('shown');

			clearTimeout(saveTimer);
			saveTimer = setTimeout(function() {
				// Close popup
				$fullOverlay.removeClass('shown');
				$loadOptions.removeClass('shown').find('.step-no-plans').removeClass('shown').siblings('.step-form').addClass('shown');

				// Create new plan
				createNewPlan();
			}, 3000);
		}
	}

	// Load plan from DB
	function loadSavedPlan(multiplePlans) {
		var multiplePlans = (typeof multiplePlans === 'undefined') ? false : multiplePlans,
		$allChoices = $savedPlan.find('.products-list');

		$allChoices.addClass('is-loading');

		// Show loader
		$loadOptions.find('.step-form').removeClass('shown').siblings('.step-loading').addClass('shown');

		// Full-screen loading overlay covers the planner while we restore the
		// saved plan and step through the intermediate state transitions.
		// updateProgress() tears it down once the review step (step 9) renders.
		loadingSavedPlan = true;
		showSavedPlanLoadingOverlay();

		// A shared benchtop plan is opened with ?cid=<owner>&token=<uuid>; forward both
		// so the backend authorises the public load (same pattern as the other planners).
		const cid = new URLSearchParams(window.location.search).get('cid');
		const shareToken = new URLSearchParams(window.location.search).get('token');

		// Load plan from DB
		$.ajax({
			method: 'POST',
			url: planner_api_url + '/planner/load',
			data: JSON.stringify(Object.assign({
				plan_type: 'benchtop',
				customer_id: cid ? `${cid}__public` : customerID,
				plan_id: planToLoad
			}, (cid && shareToken) ? { share_token: shareToken } : {})),
			timeout: 15000,
			cache: false,
			contentType: "application/json"
		}).done(function(resultJSON) {
			var result = resultJSON;
			if(result.response === 'Success') {
				// Load variables
				var loadedVariables = result.variables;

				if(loadedVariables) {
					firstLoad = true;
					
					// On save, do update not insert
					firstSave = false;

					// A shared plan (opened via ?cid) belongs to someone else, so save
					// it as a NEW plan under the viewer's account rather than updating.
					if(cid && cid != customerID){
						firstSave = true;
					}

					// Update plan ID to the loaded plan (only for the owner's own load)
					if(!cid){
						planID = planToLoad;
					}


					// Convert JSON string to object
					loadedVariables = $.parseJSON(loadedVariables);

					// Update variables with loaded values
					plannerVersion = (typeof loadedVariables.plannerVersion === 'undefined') ? 1 : loadedVariables.plannerVersion;
					stepProgress = loadedVariables.stepProgress;
					
					addtoCartQueue = loadedVariables.addtoCartQueue;
					finalPrice = loadedVariables.finalPrice;
					finalPriceFormatted = loadedVariables.finalPriceFormatted;

					finalImageSrc = loadedVariables.finalImageSrc;
					finalImageSrcset = loadedVariables.finalImageSrcset;
					finalImageSrc = loadedVariables.finalImageSrc;
					finalImageSrcset = loadedVariables.finalImageSrcset;
					finalImageWidth = loadedVariables.finalImageWidth;
					finalImageWidthL = loadedVariables.finalImageWidthL;
					finalImageWidthU = loadedVariables.finalImageWidthU;
					standardLength =loadedVariables.standardLength;
					defaultDepth = loadedVariables.defaultDepth;
					minLength = loadedVariables.minLength;
					minUGap = loadedVariables.minUGap;
					longEndFinishing = loadedVariables.longEndFinishing;
					longEndPolishing = loadedVariables.longEndPolishing != null ? loadedVariables.longEndPolishing : longEndPolishing;
					joinSpace = loadedVariables.joinSpace;
					benchtopShape = loadedVariables.benchtopShape;
					breakfastBar = loadedVariables.breakfastBar;
					breakfastBarSide = loadedVariables.breakfastBarSide;
					benchtopsPrice = loadedVariables.benchtopsPrice;
					endFinishingsPrice = loadedVariables.endFinishingsPrice;
					benchtopPieces = loadedVariables.benchtopPieces;
					benchtop1ID = loadedVariables.benchtop1ID;
					benchtop1Price = loadedVariables.benchtop1Price;
					length1 = loadedVariables.length1;
					length1Final = loadedVariables.length1Final;
					depth1 = loadedVariables.depth1;
					benchtop1AID = loadedVariables.benchtop1AID;
					benchtop1APrice = loadedVariables.benchtop1APrice;
					length1AFinal = loadedVariables.length1AFinal;
					benchtop2ID = loadedVariables.benchtop2ID;
					benchtop2Price = loadedVariables.benchtop2Price;
					length2 = loadedVariables.length2;
					length2Final = loadedVariables.length2Final;
					depth2 = loadedVariables.depth2;
					benchtop2AID = loadedVariables.benchtop2AID;
					benchtop2APrice = loadedVariables.benchtop2APrice;
					length2AFinal = loadedVariables.length2AFinal;
					benchtop3ID = loadedVariables.benchtop3ID;
					benchtop3Price = loadedVariables.benchtop3Price;
					length3 = loadedVariables.length3;
					length3Final = loadedVariables.length3Final;
					depth3 = loadedVariables.depth3;
					benchtop3AID = loadedVariables.benchtop3AID;
					benchtop3APrice = loadedVariables.benchtop3APrice;
					length3AFinal = loadedVariables.length3AFinal;
					leftFinished = loadedVariables.leftFinished;
					rightFinished = loadedVariables.rightFinished;
					joinType = loadedVariables.joinType;
					forceJoin = loadedVariables.forceJoin;
					colour = loadedVariables.colour;
					reviewImage = loadedVariables.reviewImage;
					reviewImageTag = loadedVariables.reviewImageTag;
					endFinishingQty = loadedVariables.endFinishingQty;
					endFinishingLongQty = loadedVariables.endFinishingLongQty;
					joinQty = loadedVariables.joinQty;
					glueQty = loadedVariables.glueQty;

					wallFinished = loadedVariables.wallFinished;

					wallStraightFinishingBack = loadedVariables.wallStraightFinishingBack;

					wallLFinishingBackLeft = loadedVariables.wallLFinishingBackLeft;
					wallLFinishingBackRight = loadedVariables.wallLFinishingBackRight;

					wallLFinishingBackRightBB = loadedVariables.wallLFinishingBackRightBB;
					wallLFinishingBackLeftBB = loadedVariables.wallLFinishingBackLeftBB;

					wallUFinishingBackLeft = loadedVariables.wallUFinishingBackLeft;
					wallUFinishingBackCentre = loadedVariables.wallUFinishingBackCentre;
					wallUFinishingBackRight = loadedVariables.wallUFinishingBackRight;


					wallUFinishingBackCentreBBOnLeft = loadedVariables.wallUFinishingBackCentreBBOnLeft;
					wallUFinishingBackRightBB = loadedVariables.wallUFinishingBackRightBB;

					wallUFinishingBackLeftBB = loadedVariables.wallUFinishingBackLeftBB;
					wallUFinishingBackCentreBBRJoin = loadedVariables.wallUFinishingBackCentreBBRJoin;

					wallFinishedList = loadedVariables.wallFinishedList;

					// Material and stone-related variables
					benchMaterial = loadedVariables.benchMaterial || 'Laminate';
					materialProductID = loadedVariables.materialProductID;
					materialColorsLoaded = loadedVariables.materialColorsLoaded || false;
					colorTier = loadedVariables.colorTier || 'starter';
					starterColors = loadedVariables.starterColors || [];
					premiumColors = loadedVariables.premiumColors || [];
					professionalColors = loadedVariables.professionalColors || [];

					// Polishing and waterfall variables
					leftPolishedTreated = loadedVariables.leftPolishedTreated || false;
					rightPolishedTreated = loadedVariables.rightPolishedTreated || false;
					leftWaterfall = loadedVariables.leftWaterfall || false;
					rightWaterfall = loadedVariables.rightWaterfall || false;
					polishingPrice = loadedVariables.polishingPrice || 0;
					stoneCutoutsPrice = loadedVariables.stoneCutoutsPrice || 0;
					polishingID = loadedVariables.polishingID;
					polishingLongID = loadedVariables.polishingLongID;
					waterfallID = loadedVariables.waterfallID;
					polishingQty = loadedVariables.polishingQty || 0;
					polishingLongQty = loadedVariables.polishingLongQty || 0;
					waterfallQty = loadedVariables.waterfallQty || 0;
					
					// Additional waterfall variables
					waterfallProduct = loadedVariables.waterfallProduct;
					waterfallPrice = loadedVariables.waterfallPrice || 0;
					waterfallArea = loadedVariables.waterfallArea || 0;
					waterfallMaterialProductID = loadedVariables.waterfallMaterialProductID;
					waterfallMaterialPrice = loadedVariables.waterfallMaterialPrice || 0;
					
					// Separate left and right waterfall variables
					leftWaterfallArea = loadedVariables.leftWaterfallArea || 0;
					rightWaterfallArea = loadedVariables.rightWaterfallArea || 0;
					leftWaterfallMaterialProductID = loadedVariables.leftWaterfallMaterialProductID;
					rightWaterfallMaterialProductID = loadedVariables.rightWaterfallMaterialProductID;
					leftWaterfallMaterialPrice = loadedVariables.leftWaterfallMaterialPrice || 0;
					rightWaterfallMaterialPrice = loadedVariables.rightWaterfallMaterialPrice || 0;
					
					// Wall polishing variables
					wallStraightPolishingBack = loadedVariables.wallStraightPolishingBack || false;
					wallLPolishingBackLeft = loadedVariables.wallLPolishingBackLeft || false;
					wallLPolishingBackRight = loadedVariables.wallLPolishingBackRight || false;
					wallLPolishingBackLeftBB = loadedVariables.wallLPolishingBackLeftBB || false;
					wallLPolishingBackRightBB = loadedVariables.wallLPolishingBackRightBB || false;
					wallUPolishingBackLeft = loadedVariables.wallUPolishingBackLeft || false;
					wallUPolishingBackCentre = loadedVariables.wallUPolishingBackCentre || false;
					wallUPolishingBackRight = loadedVariables.wallUPolishingBackRight || false;
					wallUPolishingBackLeftBB = loadedVariables.wallUPolishingBackLeftBB || false;
					wallUPolishingBackRightBB = loadedVariables.wallUPolishingBackRightBB || false;
					wallUPolishingBackCentreBBOnLeft = loadedVariables.wallUPolishingBackCentreBBOnLeft || false;
					wallUPolishingBackCentreBBRJoin = loadedVariables.wallUPolishingBackCentreBBRJoin || false;

					// Common cutout variables
					sinkTapCutout = loadedVariables.sinkTapCutout || false;
					sinkTapMount = loadedVariables.sinkTapMount || 'Top mounted';
					sinkTapQty = loadedVariables.sinkTapQty || 1;
					hobCutout = loadedVariables.hobCutout || false;
					hobMount = loadedVariables.hobMount || 'Top mounted';
					hobQty = loadedVariables.hobQty || 1;
					airSwitchCutout = loadedVariables.airSwitchCutout || false;
					airSwitchQty = loadedVariables.airSwitchQty || 1;

					// Cutout product IDs and quantities
					cutoutID = loadedVariables.cutoutID;
					tapholeID = loadedVariables.tapholeID;
					windowCutoutID = loadedVariables.windowCutoutID;
					cutoutQty = loadedVariables.cutoutQty || 0;
					tapholeQty = loadedVariables.tapholeQty || 0;
					windowCutoutQty = loadedVariables.windowCutoutQty || 0;
					
					// Cutout variant product variables
					cutoutTopID = loadedVariables.cutoutTopID;
					cutoutUnderID = loadedVariables.cutoutUnderID;
					cutoutTopPrice = loadedVariables.cutoutTopPrice;
					cutoutUnderPrice = loadedVariables.cutoutUnderPrice;

					// Installation variables
					needInstallation = loadedVariables.needInstallation || true;
					installContactName = loadedVariables.installContactName || '';
					installContactNumber = loadedVariables.installContactNumber || '';
					installPostcode = loadedVariables.installPostcode || '';
					installationPrice = loadedVariables.installationPrice || 0;
					installationFeePrice = loadedVariables.installationFeePrice || 0;
					installationTravelPrice = loadedVariables.installationTravelPrice || 0;
					installFeeIDWithJoints = loadedVariables.installFeeIDWithJoints;
					installFeeIDNoJoints = loadedVariables.installFeeIDNoJoints;
					installTravelDefaultID = loadedVariables.installTravelDefaultID;
					installFeeProduct = loadedVariables.installFeeProduct;
					installTravelProduct = loadedVariables.installTravelProduct;
					
					// Join variables
					glueID = loadedVariables.glueID;
					stoneJoinID = loadedVariables.stoneJoinID;

					//Pre-fill and pre-select options from load plan data

					if(benchtopShape == 'Straight') {
						if(shapeChanged) {
							$benchtopPlanner.find('.if-l, .if-l-any, .if-u, .if-u-any').removeClass('shown');
							$benchtopPlanner.find('.if-straight, .if-straight-any').addClass('shown');
		
							// Hide join step
							$progress.find('.if-join').removeClass('shown');
							$step5Next.attr('href', '#step-6');
						}
						loadImages();
		
					} else if(benchtopShape == 'L-Shaped') {
						$benchtopPlanner.find('.if-straight, .if-straight-any, .if-u, .if-u-any').removeClass('shown');
						$benchtopPlanner.find('.if-l, .if-l-any').addClass('shown');
		
						// Show join step
						$progress.find('.if-join').addClass('shown');
						$step5Next.attr('href', '#step-6');
						shapeChanged = true;
						
						if(benchMaterial == 'Laminate') {
							// Load join product
							loadJoin(false);
						}
		
					} else if(benchtopShape == 'U-Shaped') {
						$benchtopPlanner.find('.if-straight, .if-straight-any, .if-l, .if-l-any').removeClass('shown');
						$benchtopPlanner.find('.if-u, .if-u-any').addClass('shown');
		
						// Show join step
						$progress.find('.if-join').addClass('shown');
						$step5Next.attr('href', '#step-6');
						shapeChanged = true;
		
						if(benchMaterial == 'Laminate') {
							// Load join product
							loadJoin(false);
						}	
					}

					// Show Benchtop Shape
					if(benchtopShape) {
						$benchtopPlanner.find('.step-1 .choice').each(function() {
							if($(this).find('h3').text() == benchtopShape) {
								$(this).addClass('selected');
								return false;
							}
						});
					}

					//if not breakfastbar
					if(!breakfastBar) {
						if(benchtopShape == 'Straight') {
							$benchtopPlanner.find('.if-straight-bb').removeClass('shown');
							$benchtopPlanner.find('.if-straight, .unless-straight-bb').addClass('shown');
						} else if(benchtopShape == 'L-Shaped') {
							$benchtopPlanner.find('.if-l-bb, .if-l-bb-l, .if-l-bb-r').removeClass('shown');
							$benchtopPlanner.find('.if-l').addClass('shown');
						} else if(benchtopShape == 'U-Shaped') {
							$benchtopPlanner.find('.if-u-bb, .if-u-bb-l, .if-u-bb-r').removeClass('shown');
							$benchtopPlanner.find('.if-u').addClass('shown');
						}
					}

					if(breakfastBar) {
						if(benchtopShape == 'Straight') {
							$benchtopPlanner.find('.if-straight, .unless-straight-bb').removeClass('shown');
							$benchtopPlanner.find('.if-straight-bb').addClass('shown');
						} else if(benchtopShape == 'L-Shaped') {
							$benchtopPlanner.find('.if-l-bb').addClass('shown');
							if(breakfastBarSide == 'Left') {
								$benchtopPlanner.find('.if-l, .if-l-bb-r').removeClass('shown');
								$benchtopPlanner.find('.if-l-bb-l').addClass('shown');
							} else if(breakfastBarSide == 'Right') {
								$benchtopPlanner.find('.if-l, .if-l-bb-l').removeClass('shown');
								$benchtopPlanner.find('.if-l-bb-r').addClass('shown');
							}
						} else if(benchtopShape == 'U-Shaped') {
							$benchtopPlanner.find('.if-u-bb').addClass('shown');
							if(breakfastBarSide == 'Left') {
								$benchtopPlanner.find('.if-u, .if-u-bb-r').removeClass('shown');
								$benchtopPlanner.find('.if-u-bb-l').addClass('shown');
							} else if(breakfastBarSide == 'Right') {
								$benchtopPlanner.find('.if-u, .if-u-bb-l').removeClass('shown');
								$benchtopPlanner.find('.if-u-bb-r').addClass('shown');
							}
						}

						if(breakfastBarSide == 'Left') {
							if(benchtopShape == 'L-Shaped') {
								$benchtopPlanner.find('.if-l, .if-l-bb-r').removeClass('shown');
								$benchtopPlanner.find('.if-l-bb-l').addClass('shown');
							} else if(benchtopShape == 'U-Shaped') {
								$benchtopPlanner.find('.if-u, .if-u-bb-r').removeClass('shown');
								$benchtopPlanner.find('.if-u-bb-l').addClass('shown');
							}
						} else if(breakfastBarSide = 'Right') {
							if(benchtopShape == 'L-Shaped') {
								$benchtopPlanner.find('.if-l, .if-l-bb-l').removeClass('shown');
								$benchtopPlanner.find('.if-l-bb-r').addClass('shown');
							} else if(benchtopShape == 'U-Shaped') {
								$benchtopPlanner.find('.if-u, .if-u-bb-l').removeClass('shown');
								$benchtopPlanner.find('.if-u-bb-r').addClass('shown');
							}
						}
					} 
					// Check breakfast bar 
					if(breakfastBar) {
						$benchtopPlanner.find('.step-2 .choice').each(function() {
							if($(this).find('h3').text() == 'Breakfast Bar') {
								$(this).addClass('selected');
							}
						});
						// Show join step
						$progress.find('.if-join').addClass('shown');
						$step5Next.attr('href', '#step-6');


						if(breakfastBarSide == 'Left'){
							$benchtopPlanner.find('.step-2 .choice').each(function() {
								if($(this).find('h3').text() == 'Breakfast Bar on Left') {
									$(this).addClass('selected');
								}
							});
						}

						if(breakfastBarSide == 'Right'){

							$benchtopPlanner.find('.step-2 .choice').each(function() {
								if($(this).find('h3').text() == 'Breakfast Bar on Right') {
									$(this).addClass('selected');
								}
							});
						}
					}
					else{
						$benchtopPlanner.find('.step-2 .choice').each(function() {
							if($(this).find('h3').text() == 'Standard Benchtop') {
								$(this).addClass('selected');
							}
						});
					}

					//Measurements
					$benchtopPlanner.find('.step-3 .shown input').each(function() {

						if($(this).closest('.user-input').hasClass('straight-length') || $(this).closest('.user-input').hasClass('l-left-length') || $(this).closest('.user-input').hasClass('u-left-length')) {
							//length1 = parseInt($this.val(), 10);
							$(this).val(length1);
							
						} else if($(this).closest('.user-input').hasClass('l-right-length') || $(this).closest('.user-input').hasClass('u-centre-length')) {
							$(this).val(length2);
						} else if($(this).closest('.user-input').hasClass('u-right-length')) {
							$(this).val(length3);
						} else if($(this).closest('.user-input').hasClass('straight-depth') || $(this).closest('.user-input').hasClass('l-left-depth') || $(this).closest('.user-input').hasClass('u-left-depth') ) {
							$(this).val(depth1);
							$benchtopPlanner.find(`.step-3 input[value=${depth1}]`).prop('checked', true); 
						} else if($(this).closest('.user-input').hasClass('l-right-depth') || $(this).closest('.user-input').hasClass('u-centre-depth')) {
							$(this).val(depth2);
							$benchtopPlanner.find(`.step-3 input[value=${depth2}]`).prop('checked', true); 
						} else if($(this).closest('.user-input').hasClass('u-right-depth')) {
							$benchtopPlanner.find(`.step-3 input[value=${depth3}]`).prop('checked', true); 
						}
					});



					// Check finish radio buttons
					if(leftFinished){
						$benchtopPlanner.find('.step-4 input[name=straight-finishing-left]').prop('checked', true);
						$benchtopPlanner.find('.step-4 input[name=l-finishing-left]').prop('checked', true);
						$benchtopPlanner.find('.step-4 input[name=u-finishing-left]').prop('checked', true);
						$benchtopPlanner.find('.step-9 span.end-finishing-left').text('Finished');
					}
					if(rightFinished){
						$benchtopPlanner.find('.step-4 input[name=straight-finishing-right]').prop('checked', true);
						$benchtopPlanner.find('.step-4 input[name=l-finishing-right]').prop('checked', true);
						$benchtopPlanner.find('.step-4 input[name=u-finishing-right]').prop('checked', true);
						$benchtopPlanner.find('.step-9 span.end-finishing-right').text('Finished');
					}


					if(wallStraightFinishingBack){
						$benchtopPlanner.find('.step-4 input[name=straight-finishing-back]').eq(1).prop('checked', true);
					}

					if(wallLFinishingBackLeft){
						$benchtopPlanner.find('.step-4 input[name=l-finishing-back-left]').eq(1).prop('checked', true);
					}
					
					if(wallLFinishingBackRight){
						$benchtopPlanner.find('.step-4 input[name=l-finishing-back-right]').eq(1).prop('checked', true);
					}

					if(wallLFinishingBackRightBB){
						$benchtopPlanner.find('.step-4 input[name=l-finishing-back-right-bb]').eq(1).prop('checked', true);
					}
					
					if(wallLFinishingBackLeftBB){
						$benchtopPlanner.find('.step-4 input[name=l-finishing-back-left-bb]').eq(1).prop('checked', true);
					}

					if(wallUFinishingBackLeft){
						$benchtopPlanner.find('.step-4 input[name=u-finishing-back-left]').eq(1).prop('checked', true);
					}
					
					if(wallUFinishingBackCentre){
						$benchtopPlanner.find('.step-4 input[name=u-finishing-back-centre]').eq(1).prop('checked', true);
					}
					
					if(wallUFinishingBackRight){
						$benchtopPlanner.find('.step-4 input[name=u-finishing-back-right]').eq(1).prop('checked', true);
					}

					if(wallUFinishingBackCentreBBOnLeft){
						$benchtopPlanner.find('.step-4 input[name=u-finishing-back-centre-bb]').eq(1).prop('checked', true);
					}
					
					if(wallUFinishingBackRightBB){
						$benchtopPlanner.find('.step-4 input[name=u-finishing-back-right-bb]').eq(1).prop('checked', true);
					}

					if(wallUFinishingBackLeftBB){
						$benchtopPlanner.find('.step-4 input[name=u-finishing-back-left-bb]').eq(1).prop('checked', true);
					}
					
					if(wallUFinishingBackCentreBBRJoin){
						$benchtopPlanner.find('.step-4 input[name=u-finishing-back-centre-bb]').eq(1).prop('checked', true);
					}

					if(leftFinished) {
						if(rightFinished) {
							$benchtopPlanner.find('.step-4 .diagram img.clashed').addClass('shown').siblings().removeClass('shown');
						} else {
							$benchtopPlanner.find('.step-4 .diagram img.unclashed-r').addClass('shown').siblings().removeClass('shown');
						}

					} else if(leftFinished = false) {
						if(rightFinished) {
							$benchtopPlanner.find('.step-4 .diagram img.unclashed-l').addClass('shown').siblings().removeClass('shown');
						} else {
							$benchtopPlanner.find('.step-4 .diagram img.unclashed-both').addClass('shown').siblings().removeClass('shown');
						}

					} else if(rightFinished) {
						if(leftFinished) {
							$benchtopPlanner.find('.step-4 .diagram img.clashed').addClass('shown').siblings().removeClass('shown');
						} else {
							$benchtopPlanner.find('.step-4 .diagram img.unclashed-l').addClass('shown').siblings().removeClass('shown');
						}

					} else if(rightFinished = false) {
						if(leftFinished) {
							$benchtopPlanner.find('.step-4 .diagram img.unclashed-r').addClass('shown').siblings().removeClass('shown');
						} else {
							$benchtopPlanner.find('.step-4 .diagram img.unclashed-both').addClass('shown').siblings().removeClass('shown');
						}
					}

					//Join
					if(benchtopShape == 'L-Shaped') {
						if(joinType == 'Left'){
							$benchtopPlanner.find('.step-5 .choice').each(function() {
								if($(this).find('h3').text() == 'Left Join') {
									$(this).addClass('selected');
								}
							});
						}
						if(joinType == 'Right'){
							$benchtopPlanner.find('.step-5 .choice').each(function() {
								if($(this).find('h3').text() == 'Right Join') {
									$(this).addClass('selected');
								}
							});
						}
						loadImages();
					} else if(benchtopShape == 'U-Shaped') {

						if(joinType == 'RightLeft'){
							$benchtopPlanner.find('.step-5 .choice').each(function() {
								if($(this).find('h3').text() == 'Inner Join') {
									$(this).addClass('selected');
								}
							});
						}

						if(joinType == 'LeftRight'){
							$benchtopPlanner.find('.step-5 .choice').each(function() {
								if($(this).find('h3').text() == 'Outer Join') {
									$(this).addClass('selected');
								}
							});
						}

						if(joinType == 'Left'){
							$benchtopPlanner.find('.step-5 .choice').each(function() {
								if($(this).find('h3').text() == 'Left Join') {
									$(this).addClass('selected');
								}
							});
						}

						if(joinType == 'Right'){
							$benchtopPlanner.find('.step-5 .choice').each(function() {
								if($(this).find('h3').text() == 'Right Join') {
									$(this).addClass('selected');
								}
							});
						}
						loadImages();
					}

					// Update material selection UI
					if(benchMaterial) {
						$benchtopPlanner.find('.step-4 .choice').each(function() {
							if($(this).find('h3').text() == benchMaterial) {
								$(this).addClass('selected');
								return false;
							}
						});
					}

					// Update polishing and waterfall UI for stone materials
					if(benchMaterial != 'Laminate') {
						// Show/hide appropriate polishing sections
						$benchtopPlanner.find('.material-laminate').removeClass('shown');
						$benchtopPlanner.find('.material-stone').addClass('shown');

						// Update polishing radio buttons
						if(leftPolishedTreated) {
							$benchtopPlanner.find('.step-5 input[name="straight-polishing-left"][value="Polished"]').prop('checked', true);
							$benchtopPlanner.find('.step-5 input[name="l-polishing-left"][value="Polished"]').prop('checked', true);
							$benchtopPlanner.find('.step-5 input[name="u-polishing-left"][value="Polished"]').prop('checked', true);
						}

						if(rightPolishedTreated) {
							$benchtopPlanner.find('.step-5 input[name="straight-polishing-right"][value="Polished"]').prop('checked', true);
							$benchtopPlanner.find('.step-5 input[name="l-polishing-right"][value="Polished"]').prop('checked', true);
							$benchtopPlanner.find('.step-5 input[name="u-polishing-right"][value="Polished"]').prop('checked', true);
						}

						// Update waterfall radio buttons
						if(leftWaterfall) {
							$benchtopPlanner.find('.step-5 input[name="straight-polishing-left"][value="Waterfall"]').prop('checked', true);
							$benchtopPlanner.find('.step-5 input[name="l-polishing-left"][value="Waterfall"]').prop('checked', true);
							$benchtopPlanner.find('.step-5 input[name="u-polishing-left"][value="Waterfall"]').prop('checked', true);
						}

						if(rightWaterfall) {
							$benchtopPlanner.find('.step-5 input[name="straight-polishing-right"][value="Waterfall"]').prop('checked', true);
							$benchtopPlanner.find('.step-5 input[name="l-polishing-right"][value="Waterfall"]').prop('checked', true);
							$benchtopPlanner.find('.step-5 input[name="u-polishing-right"][value="Waterfall"]').prop('checked', true);
						}

						// Update wall polishing for stone materials
						if(wallStraightPolishingBack) {
							$benchtopPlanner.find('.step-5 input[name="straight-polishing-back"][value="Wall Polished"]').prop('checked', true);
						}
						if(wallLPolishingBackLeft) {
							$benchtopPlanner.find('.step-5 input[name="l-polishing-back-left"][value="Wall Polished"]').prop('checked', true);
						}
						if(wallLPolishingBackRight) {
							$benchtopPlanner.find('.step-5 input[name="l-polishing-back-right"][value="Wall Polished"]').prop('checked', true);
						}
						if(wallLPolishingBackLeftBB) {
							$benchtopPlanner.find('.step-5 input[name="l-polishing-back-left-bb"][value="Wall Polished"]').prop('checked', true);
						}
						if(wallLPolishingBackRightBB) {
							$benchtopPlanner.find('.step-5 input[name="l-polishing-back-right-bb"][value="Wall Polished"]').prop('checked', true);
						}
						if(wallUPolishingBackLeft) {
							$benchtopPlanner.find('.step-5 input[name="u-polishing-back-left"][value="Wall Polished"]').prop('checked', true);
						}
						if(wallUPolishingBackCentre) {
							$benchtopPlanner.find('.step-5 input[name="u-polishing-back-centre"][value="Wall Polished"]').prop('checked', true);
						}
						if(wallUPolishingBackRight) {
							$benchtopPlanner.find('.step-5 input[name="u-polishing-back-right"][value="Wall Polished"]').prop('checked', true);
						}
						if(wallUPolishingBackLeftBB) {
							$benchtopPlanner.find('.step-5 input[name="u-polishing-back-left-bb"][value="Wall Polished"]').prop('checked', true);
						}
						if(wallUPolishingBackRightBB) {
							$benchtopPlanner.find('.step-5 input[name="u-polishing-back-right-bb"][value="Wall Polished"]').prop('checked', true);
						}
						if(wallUPolishingBackCentreBBOnLeft) {
							$benchtopPlanner.find('.step-5 input[name="u-polishing-back-centre-bb-on-left"][value="Wall Polished"]').prop('checked', true);
						}
						if(wallUPolishingBackCentreBBRJoin) {
							$benchtopPlanner.find('.step-5 input[name="u-polishing-back-centre-bb-on-right"][value="Wall Polished"]').prop('checked', true);
						}

						// Update waterfall images
						updateWaterfallImages();

						// Load tier colors if available
						if((starterColors && starterColors.length > 0) || 
						   (premiumColors && premiumColors.length > 0) || 
						   (professionalColors && professionalColors.length > 0)) {
							materialColorsLoaded = true;
							populateStoneColorsByTier();
						}
					}

					// Update common cutout checkboxes and options
					if(sinkTapCutout) {
						$('#cutout-sink-tap').prop('checked', true);
						$('.sink-tap-options').removeClass('hide');
						$('input[name="sink-tap-mount"][value="' + sinkTapMount + '"]').prop('checked', true);
						$('#sink-tap-qty').val(sinkTapQty);
					}
					
					if(hobCutout) {
						$('#cutout-hob').prop('checked', true);
						$('.hob-options').removeClass('hide');
						$('input[name="hob-mount"][value="' + hobMount + '"]').prop('checked', true);
						$('#hob-qty').val(hobQty);
					}
					
					if(airSwitchCutout) {
						$('#cutout-air-switch').prop('checked', true);
						$('.air-switch-options').removeClass('hide');
						$('#air-switch-qty').val(airSwitchQty);
					}

					// Update installation UI
					if(needInstallation) {
						$('input[name="installation"][value="Yes"]').prop('checked', true);
						$('.install-contact').addClass('shown');
						$('.install-postcode').addClass('shown');
					} else {
						$('input[name="installation"][value="No"]').prop('checked', true);
						$('.install-contact').removeClass('shown');
						$('.install-postcode').removeClass('shown');
					}

					// Fill installation form fields
					if(installContactName) {
						$('#install-contact-name').val(installContactName);
					}
					if(installContactNumber) {
						$('#install-contact-number').val(installContactNumber);
					}
					if(installPostcode) {
						$('#install-postcode').val(installPostcode);
					}

					// Update progress steps for non-laminate materials
					if(benchMaterial != 'Laminate') {
						// Update progress step to show "Cut-Outs" instead of "Join" and show Installation
						$progress.find('.if-join').removeClass('shown')
						$progress.find('.if-cut-outs').addClass('shown');
						$progress.find('.if-stone-only').addClass('shown');
						
						// Show cutout step content and installation step
						$benchtopPlanner.find('.step-6 .if-cut-outs').addClass('shown');
						$benchtopPlanner.find('.step-6 .if-join').removeClass('shown');
						$benchtopPlanner.find('.step.if-stone-only').addClass('shown');
					} else {
						// Hide installation step for laminate materials
						$progress.find('.if-stone-only').removeClass('shown');
						$benchtopPlanner.find('.step.if-stone-only').removeClass('shown');
					}

					// Update step 7 color display based on material
					toggleStep7Colors();
					
					// Update review details
					updateReviewDetails();					

					//Review image
					updateReviewImage();

					// For laminate, search within .laminate-colors, for stone search within .stone-colors
					var colorSelector = benchMaterial == 'Laminate' ? '.step-7 .laminate-colors .choice' : '.step-7 .stone-colors .choice';
					$benchtopPlanner.find(colorSelector).each(function() {
						if($(this).find('h3').text() == colour) {
							$(this).addClass('selected');
							return false;
						}
					});
					$benchtopPlanner.find('.step-9 p.benchtop-colour').text(colour);					

					// Update summary list
					//updateSummary();

					// Close popup
					$fullOverlay.removeClass('shown');
					$loadOptions.removeClass('shown');

					calculateEndFinishingPrice();
					
					
					// Navigate based on material type
					if(benchMaterial != 'Laminate') {
						// For stone materials, go directly to step 9 (review)
						goToNextStepAndValidate(9);
						loadStoneJoin(true);
						setTimeout(() => loadPolishingProducts(true), 500);
						setTimeout(() => loadCutoutProducts(true), 1000);
						setTimeout(() => loadInstallationProducts(true), 1500);		
						calculateSize();
						// updatePrice();
					} else {
						// For laminate, go directly to the review step (step 9) — the
						// same destination as stone. Installation (step 8) is
						// stone-only and validateSteps() short-circuits it for
						// laminate, so validation passes through to the review step.
						// Landing on step 9 also lets updateProgress() tear down the
						// saved-plan loading overlay (its teardown only fires there).
						goToNextStepAndValidate(9);
					}
				} else {
					alert('Error with loaded plan.');
					hideSavedPlanLoadingOverlay();
				}

			} else {
				alert('Could not load plan. Please try again. (' + result.msg + '.)');
				hideSavedPlanLoadingOverlay();
			}
		}).fail(function() {
			alert('Could not load plan. Please try again. (AJAX error.)');

			// If only one plan, hide popup
			if(!multiplePlans) {

				// Close popup
				$fullOverlay.removeClass('shown');
				$loadOptions.removeClass('shown');
			}

			// Don't leave the planner stuck behind the loading overlay if the
			// restore failed before we ever reach the review step.
			hideSavedPlanLoadingOverlay();
		}).always(function() {
			$allChoices.removeClass('is-loading');

			// Go back to form
			$loadOptions.find('.step-loading').removeClass('shown').siblings('.step-form').addClass('shown');
		});
	}

	function savePlan() {
		savedVariables.stepProgress = stepProgress;
		savedVariables.addtoCartQueue = addtoCartQueue;
		savedVariables.finalPrice = finalPrice;
		savedVariables.finalPriceFormatted = finalPriceFormatted;
		
		savedVariables.finalImageSrc = finalImageSrc;
		savedVariables.finalImageSrcset = finalImageSrcset;
		savedVariables.finalImageSrc = $finalImage.data('src'),
		savedVariables.finalImageSrcset = $finalImage.data('srcset'),
		savedVariables.finalImageWidth = finalImageWidth;
		savedVariables.finalImageWidthL = finalImageWidthL;
		savedVariables.finalImageWidthU = finalImageWidthU;
		savedVariables.standardLength = standardLength;
		savedVariables.defaultDepth = defaultDepth;
		savedVariables.minLength = minLength;
		savedVariables.minUGap = minUGap;
		savedVariables.longEndFinishing = longEndFinishing;
		savedVariables.longEndPolishing = longEndPolishing;
		savedVariables.joinSpace = joinSpace;
		savedVariables.benchtopShape = benchtopShape;
		savedVariables.breakfastBar = breakfastBar;
		savedVariables.breakfastBarSide = breakfastBarSide;
		savedVariables.benchtopsPrice = benchtopsPrice;
		savedVariables.endFinishingsPrice = endFinishingsPrice;
		savedVariables.benchtopPieces = benchtopPieces;
		savedVariables.benchtop1ID = benchtop1ID;
		savedVariables.benchtop1Price = benchtop1Price;
		savedVariables.length1 = length1;
		savedVariables.length1Final = length1Final;
		savedVariables.depth1 = depth1;
		savedVariables.benchtop1AID = benchtop1AID;
		savedVariables.benchtop1APrice = benchtop1APrice;
		savedVariables.length1AFinal = length1AFinal;
		savedVariables.benchtop2ID = benchtop2ID;
		savedVariables.benchtop2Price = benchtop2Price;
		savedVariables.length2 = length2;
		savedVariables.length2Final = length2Final;
		savedVariables.depth2 = depth2;
		savedVariables.benchtop2AID = benchtop2AID;
		savedVariables.benchtop2APrice = benchtop2APrice;
		savedVariables.length2AFinal = length2AFinal;
		savedVariables.benchtop3ID = benchtop3ID;
		savedVariables.benchtop3Price = benchtop3Price;
		savedVariables.length3 = length3;
		savedVariables.length3Final = length3Final;
		savedVariables.depth3 = depth3;
		savedVariables.benchtop3AID = benchtop3AID;
		savedVariables.benchtop3APrice = benchtop3APrice;
		savedVariables.length3AFinal = length3AFinal;
		savedVariables.leftFinished = leftFinished;
		savedVariables.rightFinished = rightFinished;
		savedVariables.joinType = joinType;
		savedVariables.forceJoin = forceJoin;
		savedVariables.colour = colour;
		savedVariables.reviewImage = reviewImage;
		savedVariables.reviewImageTag = reviewImageTag;
		savedVariables.endFinishingQty = endFinishingQty;
		savedVariables.endFinishingLongQty = endFinishingLongQty;
		savedVariables.joinQty = joinQty;
		savedVariables.glueQty = glueQty;

		savedVariables.wallFinished = wallFinished;

		savedVariables.wallStraightFinishingBack = wallStraightFinishingBack;
	
		savedVariables.wallLFinishingBackLeft = wallLFinishingBackLeft;
		savedVariables.wallLFinishingBackRight = wallLFinishingBackRight;
	
		savedVariables.wallLFinishingBackRightBB = wallLFinishingBackRightBB;
		savedVariables.wallLFinishingBackLeftBB = wallLFinishingBackLeftBB;
	
		savedVariables.wallUFinishingBackLeft = wallUFinishingBackLeft;
		savedVariables.wallUFinishingBackCentre = wallUFinishingBackCentre;
		savedVariables.wallUFinishingBackRight = wallUFinishingBackRight;
	
	
		savedVariables.wallUFinishingBackCentreBBOnLeft = wallUFinishingBackCentreBBOnLeft;
		savedVariables.wallUFinishingBackRightBB = wallUFinishingBackRightBB;
	
		savedVariables.wallUFinishingBackLeftBB = wallUFinishingBackLeftBB;
		savedVariables.wallUFinishingBackCentreBBRJoin = wallUFinishingBackCentreBBRJoin;
	
		savedVariables.wallFinishedList = wallFinishedList;

		// Material and stone-related variables
		savedVariables.benchMaterial = benchMaterial;
		savedVariables.materialProductID = materialProductID;
		savedVariables.materialColorsLoaded = materialColorsLoaded;
		savedVariables.colorTier = colorTier;
		savedVariables.starterColors = starterColors;
		savedVariables.premiumColors = premiumColors;
		savedVariables.professionalColors = professionalColors;

		// Polishing and waterfall variables
		savedVariables.leftPolishedTreated = leftPolishedTreated;
		savedVariables.rightPolishedTreated = rightPolishedTreated;
		savedVariables.leftWaterfall = leftWaterfall;
		savedVariables.rightWaterfall = rightWaterfall;
		savedVariables.polishingPrice = polishingPrice;
		savedVariables.stoneCutoutsPrice = stoneCutoutsPrice;
		savedVariables.polishingID = polishingID;
		savedVariables.polishingLongID = polishingLongID;
		savedVariables.waterfallID = waterfallID;
		savedVariables.polishingQty = polishingQty;
		savedVariables.polishingLongQty = polishingLongQty;
		savedVariables.waterfallQty = waterfallQty;
		
		// Additional waterfall variables
		savedVariables.waterfallProduct = waterfallProduct;
		savedVariables.waterfallPrice = waterfallPrice;
		savedVariables.waterfallArea = waterfallArea;
		savedVariables.waterfallMaterialProductID = waterfallMaterialProductID;
		savedVariables.waterfallMaterialPrice = waterfallMaterialPrice;
		
		// Separate left and right waterfall variables
		savedVariables.leftWaterfallArea = leftWaterfallArea;
		savedVariables.rightWaterfallArea = rightWaterfallArea;
		savedVariables.leftWaterfallMaterialProductID = leftWaterfallMaterialProductID;
		savedVariables.rightWaterfallMaterialProductID = rightWaterfallMaterialProductID;
		savedVariables.leftWaterfallMaterialPrice = leftWaterfallMaterialPrice;
		savedVariables.rightWaterfallMaterialPrice = rightWaterfallMaterialPrice;
		
		// Wall polishing variables
		savedVariables.wallStraightPolishingBack = wallStraightPolishingBack;
		savedVariables.wallLPolishingBackLeft = wallLPolishingBackLeft;
		savedVariables.wallLPolishingBackRight = wallLPolishingBackRight;
		savedVariables.wallLPolishingBackLeftBB = wallLPolishingBackLeftBB;
		savedVariables.wallLPolishingBackRightBB = wallLPolishingBackRightBB;
		savedVariables.wallUPolishingBackLeft = wallUPolishingBackLeft;
		savedVariables.wallUPolishingBackCentre = wallUPolishingBackCentre;
		savedVariables.wallUPolishingBackRight = wallUPolishingBackRight;
		savedVariables.wallUPolishingBackLeftBB = wallUPolishingBackLeftBB;
		savedVariables.wallUPolishingBackRightBB = wallUPolishingBackRightBB;
		savedVariables.wallUPolishingBackCentreBBOnLeft = wallUPolishingBackCentreBBOnLeft;
		savedVariables.wallUPolishingBackCentreBBRJoin = wallUPolishingBackCentreBBRJoin;

		// Common cutout variables
		savedVariables.sinkTapCutout = sinkTapCutout;
		savedVariables.sinkTapMount = sinkTapMount;
		savedVariables.sinkTapQty = sinkTapQty;
		savedVariables.hobCutout = hobCutout;
		savedVariables.hobMount = hobMount;
		savedVariables.hobQty = hobQty;
		savedVariables.airSwitchCutout = airSwitchCutout;
		savedVariables.airSwitchQty = airSwitchQty;

		// Cutout product IDs and quantities
		savedVariables.cutoutID = cutoutID;
		savedVariables.tapholeID = tapholeID;
		savedVariables.windowCutoutID = windowCutoutID;
		savedVariables.cutoutQty = cutoutQty;
		savedVariables.tapholeQty = tapholeQty;
		savedVariables.windowCutoutQty = windowCutoutQty;
		
		// Cutout variant product variables
		savedVariables.cutoutTopID = cutoutTopID;
		savedVariables.cutoutUnderID = cutoutUnderID;
		savedVariables.cutoutTopPrice = cutoutTopPrice;
		savedVariables.cutoutUnderPrice = cutoutUnderPrice;

		// Installation variables
		savedVariables.needInstallation = needInstallation;
		savedVariables.installContactName = installContactName;
		savedVariables.installContactNumber = installContactNumber;
		savedVariables.installPostcode = installPostcode;
		savedVariables.installationPrice = installationPrice;
		savedVariables.installationFeePrice = installationFeePrice;
		savedVariables.installationTravelPrice = installationTravelPrice;
		savedVariables.installFeeIDWithJoints = installFeeIDWithJoints;
		savedVariables.installFeeIDNoJoints = installFeeIDNoJoints;
		savedVariables.installTravelDefaultID = installTravelDefaultID;
		savedVariables.installFeeProduct = installFeeProduct;
		savedVariables.installTravelProduct = installTravelProduct;
		
		// Join variables
		savedVariables.glueID = glueID;
		savedVariables.stoneJoinID = stoneJoinID;

		if(firstSave) {
			// Show title popup
			$fullOverlay.addClass('shown');
			$saveOptions.addClass('shown');

		// Update existing plan
		} else {
			// Show loader
			$saveButton.addClass('is-saving');
			$saveButton.find('span').text('Saving');

			$.ajax({
				method: 'POST',
				url: planner_api_url + '/planner/update',
				data: JSON.stringify({
					plan_type: 'benchtop',
					customer_id: customerID,
					plan_id: planID,
					plan: JSON.stringify({}),
					variables: JSON.stringify(savedVariables)
				}),
				timeout: 15000,
				cache: false,
				contentType: "application/json"
			}).done(function(resultJSON) {
				var result = resultJSON;
				if(result.response === 'Success') {
					$saveButton.find('span').text('Saved');
					clearTimeout(saveTimer);
					saveTimer = setTimeout(function() {
						$saveButton.find('span').text('Save');
					}, 15000);

					// Hide prompt if window closed without saving
					window.onbeforeunload = null;
				} else {
					$saveButton.find('span').text('Save');
					// Don't show error if doing sneaky save
					if(!addToCartAfterSave) {
						alert('Could not save plan. Please try again. (' + result.msg + '.)');
					}
				}
			}).fail(function() {
				$saveButton.find('span').text('Save');
				// Don't show error if doing sneaky save
				if(!addToCartAfterSave) {
					alert('Could not save plan. Please try again. (AJAX error.)');
				}
			}).always(function() {
				$saveButton.removeClass('is-saving');
				$saveButton.blur();
			});

			// Add to cart after saving
			/*
			if(addToCartAfterSave) {
				ajaxAddtoCart();
			}
			*/
		}
	}

	// Print button
	$('a.btn-print').on('click', function(e) {
		e.preventDefault();
		window.print();
	});
	// Save options submit
	$saveOptions.find('.action-buttons button').on('click', function(e) {
		e.preventDefault();
		
		var planTitle = document.getElementById('plan-title').value; //$planTitle.val();

		if(planTitle) {
			// Hide errors
			$saveOptions.find('.form-error').removeClass('shown');

			// Show loader
			$saveOptions.find('.step-form').removeClass('shown').siblings('.step-saving').addClass('shown');
			
			// Save plan to DB
			$.ajax({
				method: 'POST',
				url: planner_api_url + '/planner/save',
				data: JSON.stringify({
					plan_type: 'benchtop',
					customer_id: customerID,
					plan_id: planID,
					plan_title: planTitle,
					plan: JSON.stringify({}),
					variables: JSON.stringify(savedVariables),
					customer_tags: customerTags
				}),
				timeout: 15000,
				cache: false,
				contentType: "application/json"
			}).done(function(resultJSON) {
				if(resultJSON.response === 'Success') {
					$saveOptions.find('.step-saving').removeClass('shown').siblings('.step-saved').addClass('shown');

					clearTimeout(saveTimer);
					saveTimer = setTimeout(function() {
						// Close popup
						$fullOverlay.removeClass('shown');
						$saveOptions.removeClass('shown').find('.step-saved').removeClass('shown').siblings('.step-form').addClass('shown');
					}, 3000);

					// Next time do update not insert
					firstSave = false;

					// Hide prompt if window closed without saving
					window.onbeforeunload = null;

				} else {
					$saveOptions.find('.form-error').addClass('shown').html('<p>Could not save plan. Please try again. (' + resultJSON.msg + '.)</p>');
					$saveOptions.find('.step-saving').removeClass('shown').siblings('.step-form').addClass('shown');
				}
			}).fail(function() {
				$saveOptions.find('.form-error').addClass('shown').html('<p>Could not save plan. Please try again. (AJAX error.)</p>');
				$saveOptions.find('.step-saving').removeClass('shown').siblings('.step-form').addClass('shown');
			});
		} else {
			$saveOptions.find('.form-error').addClass('shown').html('<p>Please enter a title.</p>');
		}
	});

	// Save options cancel
	$saveOptions.find('.action-buttons a.cancel').on('click', function(e) {
		e.preventDefault();

		// Close popup
		hideSaveOptions();
	});

	 // Load options submit
	 $loadOptions.find('.action-buttons button').on('click', function(e) {
		e.preventDefault();

		planToLoad = $planToLoad.val();

		// Load plan
		loadSavedPlan(true);
	});
	
	 // Load options cancel
	 $loadOptions.find('.action-buttons a.cancel').on('click', function(e) {
		e.preventDefault();

		// Close popup
		hideLoadOptions();
	});

	// Init AutoLoad
	initAutoLoad();

	// Hob mount/qty handlers
	// Common cutout event handlers
	$benchtopPlanner.on('change', '#cutout-sink-tap', function(){
		sinkTapCutout = $(this).is(':checked');
		$benchtopPlanner.find('.sink-tap-options')[sinkTapCutout ? 'removeClass' : 'addClass']('hide');
		calculateCutoutsPrice();
	});
	$benchtopPlanner.on('change', 'input[name=sink-tap-mount]', function(){
		sinkTapMount = $(this).val();
		// Top-mounted and under-mounted are priced differently — recalc the total.
		calculateCutoutsPrice();
	});
	$benchtopPlanner.on('change', '#sink-tap-qty', function(){
		sinkTapQty = parseInt($(this).val(),10) || 1;
		calculateCutoutsPrice();
	});

	$benchtopPlanner.on('change', '#cutout-hob', function(){
		hobCutout = $(this).is(':checked');
		$benchtopPlanner.find('.hob-options')[hobCutout ? 'removeClass' : 'addClass']('hide');
		calculateCutoutsPrice();
	});
	$benchtopPlanner.on('change', 'input[name=hob-mount]', function(){
		hobMount = $(this).val();
	});
	$benchtopPlanner.on('change', '#hob-qty', function(){
		hobQty = parseInt($(this).val(),10) || 1;
		calculateCutoutsPrice();
	});

	$benchtopPlanner.on('change', '#cutout-air-switch', function(){
		airSwitchCutout = $(this).is(':checked');
		$benchtopPlanner.find('.air-switch-options')[airSwitchCutout ? 'removeClass' : 'addClass']('hide');
		calculateCutoutsPrice();
	});
	$benchtopPlanner.on('change', '#air-switch-qty', function(){
		airSwitchQty = parseInt($(this).val(),10) || 1;
		calculateCutoutsPrice();
	});

	// Initialize progress bar visibility based on default material (Laminate)
	if(benchMaterial == 'Laminate') {
		$progress.find('.if-stone-only').removeClass('shown');
		$benchtopPlanner.find('.step.if-stone-only').removeClass('shown');
	}
};

